var _toConsumableArray = require("/var/lib/jenkins/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/var/lib/jenkins/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e5) { throw _e5; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e6) { didErr = true; err = _e6; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*! For license information please see index.js.LICENSE.txt */
!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"), require("antd"), require("@ant-design/icons"), require("react-router-dom"), require("lodash"), require("react-intl"), require("react-redux"), require("styled-components"), require("underscore.string"), require("dayjs"), require("pluralize"), require("moment"), require("immutable"), require("react-helmet"), require("redux-saga"), require("redux-saga/effects"));else if ("function" == typeof define && define.amd) define(["react", "antd", "@ant-design/icons", "react-router-dom", "lodash", "react-intl", "read-redux", "styled-components", "underscore.string",, "pluralize", "moment", "immutable", "react-helmet", "redux-saga", "redux-saga/effects"], t);else {
    var r = "object" == typeof exports ? t(require("react"), require("antd"), require("@ant-design/icons"), require("react-router-dom"), require("lodash"), require("react-intl"), require("react-redux"), require("styled-components"), require("underscore.string"), require("dayjs"), require("pluralize"), require("moment"), require("immutable"), require("react-helmet"), require("redux-saga"), require("redux-saga/effects")) : t(e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e.ReactRedux, e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0], e[void 0]);

    for (var n in r) {
      ("object" == typeof exports ? exports : e)[n] = r[n];
    }
  }
}(window, function (e, t, r, n, a, o, i, u, l, c, s, f, d, p, m, h) {
  return function (e) {
    var t = {};

    function r(n) {
      if (t[n]) return t[n].exports;
      var a = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(a.exports, a, a.exports, r), a.l = !0, a.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var a in e) {
        r.d(n, a, function (t) {
          return e[t];
        }.bind(null, a));
      }
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 75);
  }([function (e, t) {
    e.exports = function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (t, r) {
    t.exports = e;
  }, function (e, t) {
    e.exports = function (e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    e.exports = r(78)();
  }, function (e, t, r) {
    var n = r(16).default;

    function a(e) {
      if ("function" != typeof WeakMap) return null;
      var t = new WeakMap(),
          r = new WeakMap();
      return (a = function a(e) {
        return e ? r : t;
      })(e);
    }

    e.exports = function (e, t) {
      if (!t && e && e.__esModule) return e;
      if (null === e || "object" !== n(e) && "function" != typeof e) return {
        default: e
      };
      var r = a(t);
      if (r && r.has(e)) return r.get(e);
      var o = {},
          i = Object.defineProperty && Object.getOwnPropertyDescriptor;

      for (var u in e) {
        if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
          var l = i ? Object.getOwnPropertyDescriptor(e, u) : null;
          l && (l.get || l.set) ? Object.defineProperty(o, u, l) : o[u] = e[u];
        }
      }

      return o.default = e, r && r.set(e, o), o;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, r) {
    e.exports = t;
  }, function (e, t, r) {
    "use strict";

    (function (e) {
      var n = r(0);
      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.isShallowEqual = function (e, t) {
        var r = Object.getOwnPropertyNames(e),
            n = Object.getOwnPropertyNames(t);
        if (r.length != n.length) return !1;

        for (var a = 0; a < r.length; a++) {
          var o = r[a],
              u = e[o],
              l = t[o];
          if ((0, i.default)(u) !== (0, i.default)(l)) return !1;
          if (Array.isArray(u) && u.length !== l.length) return !1;
          var c = (0, i.default)(u);
          if (!["function", "object"].includes(c) && u !== l) return !1;
        }

        return !0;
      }, t.default = t.dropDownTrigger = t.checkMob = t.checkIPAD = t.shallowCompare = t.getQueryParams = t.returnFinalValue = t.isFunction = t.setQueryParams = t.setQueryParamsTest = t.setQueryParamsV1 = t.mergeFunction = t.formatJsonApiData = t.getFirstRoute = t.MrAxiosInstanceMethodBuilder = t.mapStateToPropsBuilder = t.selectorsObjBuilder = t.returnSelectorProps = t.getUUid = t.getResourceNameSet = t.getPluralUnderscore = t.getUnderscore = t.getPluralCamelCase = t.getCamelCase = t.getPluralPascalCase = t.getPascalCase = t.pluralizeName = t.returnQueryString = void 0;
      var a = n(r(23)),
          o = n(r(2)),
          i = n(r(16)),
          u = n(r(38)),
          l = n(r(125)),
          c = n(r(24));
      r(11);

      function s(e, t) {
        var r = Object.keys(e);

        if (Object.getOwnPropertySymbols) {
          var n = Object.getOwnPropertySymbols(e);
          t && (n = n.filter(function (t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
          })), r.push.apply(r, n);
        }

        return r;
      }

      function f(e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? s(Object(r), !0).forEach(function (t) {
            (0, o.default)(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }

        return e;
      }

      var d = function d(e) {
        var t = [];

        for (var r in e) {
          e.hasOwnProperty(r) && t.push(encodeURIComponent(r) + "=" + encodeURIComponent(e[r]));
        }

        return t.join("&");
      };

      t.returnQueryString = d;

      t.pluralizeName = function (e) {
        return (0, l.default)(e);
      };

      var p = function p(e) {
        return c.default.camelize(e);
      };

      t.getPascalCase = p;

      var m = function m(e) {
        return (0, l.default)(p(e));
      };

      t.getPluralPascalCase = m;

      var h = function h(e) {
        return c.default.camelize(e, !0);
      };

      t.getCamelCase = h;

      var v = function v(e) {
        return (0, l.default)(h(e));
      };

      t.getPluralCamelCase = v;

      var g = function g(e) {
        return c.default.underscored(e);
      };

      t.getUnderscore = g;

      var y = function y(e) {
        return (0, l.default)(g(e));
      };

      t.getPluralUnderscore = y;

      var b = function b(e) {
        return {
          resourceCamelCaseName: h(e),
          resourcePluralCamelCaseName: v(e),
          resourcePascalCaseName: p(e),
          resourcePluralPascalCaseName: m(e),
          resourceUnderscoreName: g(e),
          resourcePluralUnderscoreName: y(e)
        };
      };

      t.getResourceNameSet = b;

      t.getUUid = function () {
        var e = new Date().getTime();
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (t) {
          var r = (e + 16 * Math.random()) % 16 | 0;
          return e = Math.floor(e / 16), ("x" == t ? r : 3 & r | 8).toString(16);
        });
      };

      var O = function O(e, t) {
        var r = {};

        for (var n in e) {
          e.hasOwnProperty(n) && t.hasOwnProperty(n) && (r[n] = t[n]);
        }

        return r;
      };

      t.returnSelectorProps = O;

      t.selectorsObjBuilder = function (e) {
        var t = {};

        for (var r in e) {
          if (e.hasOwnProperty(r)) {
            var n = e[r];

            if ("function" == typeof n()) {
              var a = n();
              t[r] = a;
            } else t[r] = n;
          }
        }

        return t;
      };

      var P = function P(e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            n = {};

        for (var a in t) {
          if (t.hasOwnProperty(a)) {
            var o = t[a];

            if ("function" == typeof o()) {
              o();
              n[a] = o()(e, r);
            } else n[a] = o(e, r);
          }
        }

        return n;
      };

      t.mapStateToPropsBuilder = P;

      t.MrAxiosInstanceMethodBuilder = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "token",
            n = function n() {
          var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
              a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              o = {
            token: n,
            createInstance: function createInstance() {
              return e.create(f({
                baseURL: "http://localhost:3005/api/v1/",
                timeout: 1e4
              }, t, {
                headers: f({
                  token: o.token
                }, t.headers || {})
              }, a));
            },
            instance: null,
            resetInstance: function resetInstance() {
              var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
              o.token = e || localStorage.getItem(r), o.instance = o.createInstance();
            }
          };
          return o.resetInstance(), o;
        };

        return n;
      };

      t.getFirstRoute = function e(t) {
        var r = null;
        return Array.isArray(t) && t.length > 0 && (r = t[0].children ? e(t[0].children) : t[0].url), r;
      };

      t.formatJsonApiData = function e(t) {
        var r;
        if (t.hasOwnProperty("data") && (t = t.data), Array.isArray(t)) return r = [], t.forEach(function (t) {
          r.push(e(t));
        }), r;
        if (!t.hasOwnProperty("attributes")) return t;
        var n = f({}, t.attributes);

        if (t.hasOwnProperty("relationships")) {
          var o = {};

          for (var i in t.relationships) {
            if (t.relationships.hasOwnProperty(i)) {
              var u = t.relationships[i];

              if (u.data) {
                e(u.data);
                var l = u.data,
                    c = (l.type, (0, a.default)(l, ["type"]));
                o[i] = f({}, c);
              }
            }
          }

          n = f({}, n, {}, o);
        }

        return n;
      };

      t.mergeFunction = function (e, t) {
        if (Array.isArray(e) && Array.isArray(t) && t.length != e.length) return t;
      };

      function w(e, t) {
        return -1 !== Object.keys(e).indexOf(t);
      }

      t.setQueryParamsV1 = function (e) {
        var t = e.url,
            r = e.history,
            n = e.location,
            a = e.newParams,
            o = e.removeParams,
            i = {};

        for (var l in a) {
          if (a.hasOwnProperty(l)) {
            var c = a[l];
            null === a[l] || "null" === a[l] ? (o || (o = []), o.push(l)) : i[l] = c;
          }
        }

        var s = f({}, u.default.parse(n.search), {}, i);
        o && o.forEach(function (e) {
          s.hasOwnProperty(e) && delete s[e];
        });
        var d = u.default.stringify(s);
        r.push("".concat(t, "?").concat(d));
      };

      t.setQueryParamsTest = function (e) {
        var t = e.url,
            r = e.history,
            n = (e.location, e.params),
            a = {},
            o = function o(e) {
          if (n.hasOwnProperty(e)) {
            var t = n[e];
            null !== t && "null" !== t && "" !== t && (Array.isArray(t) ? t.forEach(function (t, r) {
              a["".concat(e)] = t;
            }) : a[e] = t);
          }
        };

        for (var i in n) {
          o(i);
        }

        var l = u.default.stringify(a);
        r.push("".concat(t, "?").concat(l));
      };

      var x = function x(e) {
        var t = e.url,
            r = e.history,
            n = (e.location, e.params),
            a = {};

        for (var o in n) {
          if (w(n, o)) {
            var i = n[o];
            null !== n[o] && "null" !== n[o] && "" !== n[o] && (a[o] = i);
          }
        }

        var l = u.default.stringify(a, {
          arrayFormat: "bracket"
        });
        r.push("".concat(t, "?").concat(l));
      };

      t.setQueryParams = x;

      t.isFunction = function (e) {
        return "function" == typeof e;
      };

      var j = function j(e, t) {
        return "object" === t || "string" == typeof e || Array.isArray(e) ? e : e && e.hasOwnProperty("target") ? e.target.hasOwnProperty("checked") ? e.target.checked : e.target.value : e;
      };

      t.returnFinalValue = j;

      var E = function E(e) {
        var t = e.location;
        return u.default.parse(t.search, {
          arrayFormat: "bracket"
        });
      };

      t.getQueryParams = E;

      t.shallowCompare = function (e, t) {
        return Object.keys(e).length === Object.keys(t).length && Object.keys(e).every(function (r) {
          return t.hasOwnProperty(r) && e[r] === t[r];
        });
      };

      var k = function k() {
        return /iPad/.test(navigator.userAgent) || /Macintosh/.test(navigator.userAgent) && void 0 !== window.navigator.standalone || /AssessPrepIOS/.test(navigator.userAgent);
      };

      t.checkIPAD = k;

      var S = function S() {
        var t,
            r = !1;
        return e.env.REACT_APP_MODE, t = navigator.userAgent || navigator.vendor || window.opera, (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|playbook|silk/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4))) && (r = !0), r = r || window.matchMedia("(max-width: 768px)").matches;
      };

      t.checkMob = S;
      var C = k() || S() ? "click" : "hover";
      t.dropDownTrigger = C;
      var M = {
        getQueryParams: E,
        returnFinalValue: j,
        setQueryParams: x,
        mapStateToPropsBuilder: P,
        returnSelectorProps: O,
        getResourceNameSet: b,
        returnQueryString: d
      };
      t.default = M;
    }).call(this, r(121));
  }, function (e, t) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = r;
  }, function (e, t) {
    e.exports = n;
  }, function (e, t) {
    function r(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    e.exports = function (e, t, n) {
      return t && r(e.prototype, t), n && r(e, n), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = a;
  }, function (e, t, r) {
    var n = r(16).default,
        a = r(17);
    e.exports = function (e, t) {
      if (t && ("object" === n(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return a(e);
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    function r(t) {
      return e.exports = r = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      }, e.exports.__esModule = !0, e.exports.default = e.exports, r(t);
    }

    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    var n = r(77);
    e.exports = function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && n(e, t);
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = o;
  }, function (e, t) {
    function r(t) {
      return e.exports = r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, r(t);
    }

    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = i;
  }, function (e, t, r) {
    "use strict";

    var n,
        a = function a() {
      return void 0 === n && (n = Boolean(window && document && document.all && !window.atob)), n;
    },
        o = function () {
      var e = {};
      return function (t) {
        if (void 0 === e[t]) {
          var r = document.querySelector(t);
          if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
            r = r.contentDocument.head;
          } catch (e) {
            r = null;
          }
          e[t] = r;
        }

        return e[t];
      };
    }(),
        i = [];

    function u(e) {
      for (var t = -1, r = 0; r < i.length; r++) {
        if (i[r].identifier === e) {
          t = r;
          break;
        }
      }

      return t;
    }

    function l(e, t) {
      for (var r = {}, n = [], a = 0; a < e.length; a++) {
        var o = e[a],
            l = t.base ? o[0] + t.base : o[0],
            c = r[l] || 0,
            s = "".concat(l, " ").concat(c);
        r[l] = c + 1;
        var f = u(s),
            d = {
          css: o[1],
          media: o[2],
          sourceMap: o[3]
        };
        -1 !== f ? (i[f].references++, i[f].updater(d)) : i.push({
          identifier: s,
          updater: v(d, t),
          references: 1
        }), n.push(s);
      }

      return n;
    }

    function c(e) {
      var t = document.createElement("style"),
          n = e.attributes || {};

      if (void 0 === n.nonce) {
        var a = r.nc;
        a && (n.nonce = a);
      }

      if (Object.keys(n).forEach(function (e) {
        t.setAttribute(e, n[e]);
      }), "function" == typeof e.insert) e.insert(t);else {
        var i = o(e.insert || "head");
        if (!i) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        i.appendChild(t);
      }
      return t;
    }

    var s,
        f = (s = [], function (e, t) {
      return s[e] = t, s.filter(Boolean).join("\n");
    });

    function d(e, t, r, n) {
      var a = r ? "" : n.media ? "@media ".concat(n.media, " {").concat(n.css, "}") : n.css;
      if (e.styleSheet) e.styleSheet.cssText = f(t, a);else {
        var o = document.createTextNode(a),
            i = e.childNodes;
        i[t] && e.removeChild(i[t]), i.length ? e.insertBefore(o, i[t]) : e.appendChild(o);
      }
    }

    function p(e, t, r) {
      var n = r.css,
          a = r.media,
          o = r.sourceMap;
      if (a ? e.setAttribute("media", a) : e.removeAttribute("media"), o && btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), e.styleSheet) e.styleSheet.cssText = n;else {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }

        e.appendChild(document.createTextNode(n));
      }
    }

    var m = null,
        h = 0;

    function v(e, t) {
      var r, n, a;

      if (t.singleton) {
        var o = h++;
        r = m || (m = c(t)), n = d.bind(null, r, o, !1), a = d.bind(null, r, o, !0);
      } else r = c(t), n = p.bind(null, r, t), a = function a() {
        !function (e) {
          if (null === e.parentNode) return !1;
          e.parentNode.removeChild(e);
        }(r);
      };

      return n(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          n(e = t);
        } else a();
      };
    }

    e.exports = function (e, t) {
      (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = a());
      var r = l(e = e || [], t);
      return function (e) {
        if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
          for (var n = 0; n < r.length; n++) {
            var a = u(r[n]);
            i[a].references--;
          }

          for (var o = l(e, t), c = 0; c < r.length; c++) {
            var s = u(r[c]);
            0 === i[s].references && (i[s].updater(), i.splice(s, 1));
          }

          r = o;
        }
      };
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function () {
        return this.map(function (t) {
          var r = function (e, t) {
            var r = e[1] || "",
                n = e[3];
            if (!n) return r;

            if (t && "function" == typeof btoa) {
              var a = (i = n, u = btoa(unescape(encodeURIComponent(JSON.stringify(i)))), l = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(u), "/*# ".concat(l, " */")),
                  o = n.sources.map(function (e) {
                return "/*# sourceURL=".concat(n.sourceRoot || "").concat(e, " */");
              });
              return [r].concat(o).concat([a]).join("\n");
            }

            var i, u, l;
            return [r].join("\n");
          }(t, e);

          return t[2] ? "@media ".concat(t[2], " {").concat(r, "}") : r;
        }).join("");
      }, t.i = function (e, r, n) {
        "string" == typeof e && (e = [[null, e, ""]]);
        var a = {};
        if (n) for (var o = 0; o < this.length; o++) {
          var i = this[o][0];
          null != i && (a[i] = !0);
        }

        for (var u = 0; u < e.length; u++) {
          var l = [].concat(e[u]);
          n && a[l[0]] || (r && (l[2] ? l[2] = "".concat(r, " and ").concat(l[2]) : l[2] = r), t.push(l));
        }
      }, t;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = n(r(1));
    r(153);

    var o = function o(e) {
      return a.default.createElement("div", {
        class: "main-loader"
      }, a.default.createElement("div", {
        class: "lds-ring"
      }, a.default.createElement("div", null), a.default.createElement("div", null), a.default.createElement("div", null), a.default.createElement("div", null)));
    };

    t.default = o;
  }, function (e, t) {
    e.exports = u;
  }, function (e, t, r) {
    var n = r(76);
    e.exports = function (e, t) {
      if (null == e) return {};
      var r,
          a,
          o = n(e, t);

      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);

        for (a = 0; a < i.length; a++) {
          r = i[a], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
        }
      }

      return o;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = l;
  }, function (e, t) {
    e.exports = function (e, t) {
      return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
          value: Object.freeze(t)
        }
      }));
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.recNest = t.getNested = t.updateNested = t.getPathFromObject = t.cloneObject = t.getValidationRule = void 0;
    var a = n(r(7)),
        o = n(r(10)),
        i = n(r(2)),
        u = n(r(16)),
        l = n(r(24));
    n(r(70));

    function c(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function s(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? c(Object(r), !0).forEach(function (t) {
          (0, i.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    t.getValidationRule = function (e) {
      var t = l.default.classify(e);
      return t = "is".concat(t);
    };

    var f = function e(t) {
      var r = {};

      for (var n in Array.isArray(t) && (r = []), t) {
        null != t[n] && "object" == (0, u.default)(t[n]) ? r[n] = e(t[n]) : r[n] = t[n];
      }

      return r;
    };

    t.cloneObject = f;

    t.getPathFromObject = function e() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
      if ("object" === (0, u.default)(t)) if (Array.isArray(t)) for (var n = 0; n < t.length; n++) {
        var a = t[n];
        a && (r.push(n), "object" === (0, u.default)(a) && e(t[n], r));
      } else for (var o in t) {
        if (Object.hasOwnProperty.call(t, o)) {
          t[o];
          r.push(o), e(t[o], r);
        }
      }
      return r;
    };

    var d = function d(e, t) {
      var r,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
      a.debugger, r = "function" == typeof t ? t.target.value : t;
      var o = f(n);
      return p(e, r, o), o;
    };

    t.updateNested = d;

    t.getNested = function e(t) {
      var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = Array.isArray(t) ? t : t.split(".");

      if (n.length > 1) {
        if (!r.hasOwnProperty(n[0]) || "object" !== (0, u.default)(r[n[0]])) return;
        return e(n.slice(1), r[n[0]]);
      }

      return r[n[0]];
    };

    var p = function e(t, r) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          a = Array.isArray(t) ? t : t.split(".");

      if (a.length > 1) {
        if ((!n.hasOwnProperty(a[0]) || "object" !== (0, u.default)(n[a[0]])) && (n[a[0]] = {}, void 0 !== (0, u.default)(a[1]))) {
          var o = parseInt(a[1]);
          isNaN(o) || (n[a[0]] = []);
        }

        return e(a.slice(1), r, n[a[0]]);
      }

      return Array.isArray(r) ? n[a[0]] = r : "object" === (0, u.default)(r) ? n[a[0]] = s({}, n[a[0]], {}, r) : n[a[0]] = r, !0;
    };

    t.recNest = p;

    var m = function () {
      function e() {
        var t = this,
            r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        (0, a.default)(this, e), (0, i.default)(this, "allValid", function () {
          var e = !1;

          for (var r in t.fields) {
            if (t.fields.hasOwnProperty(r)) {
              if (!t.fields[r].valid) {
                e = !1;
                break;
              }

              e = !0;
            }
          }

          return t.isAllValid = e, e;
        }), this.fields = {}, this.valueFields = {}, this.options = r.options || {}, this.isShowMessages = !1, this.isAllValid = !1;
      }

      return (0, o.default)(e, [{
        key: "showMessages",
        value: function value() {
          this.isShowMessages = !0;
        }
      }, {
        key: "fieldValid",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
          return !!this.fields.hasOwnProperty(e) && (t ? this.isValid(e, t, this.fields[e].rules) : this.fields[e].valid || !1);
        }
      }, {
        key: "isValid",
        value: function value(e, t, r) {
          if (null == r) return !0;

          for (var n = r.split("|"), a = !0, o = 0; o < n.length; o++) {
            var i = n[o];

            if ("required" === i) {
              if ("" === t || null == t) {
                a = !1;
                break;
              }
            } else {
              try {
                a = !1;
              } catch (e) {
                a = !0;
              }

              if (!a) break;
            }
          }

          return a;
        }
      }, {
        key: "message",
        value: function value(e, t, r) {
          var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
              a = this.isValid(e, t, r, n);
          return a || (this.isAllValid = !1), this.fields[e] = {
            valid: a,
            rules: r
          }, this.isShowMessages, null;
        }
      }, {
        key: "setFieldValue",
        value: function value(e, t) {
          return this.valueFields = d(e, t, this.valueFields), !0;
        }
      }]), e;
    }();

    t.default = m;
  }, function (e, t) {
    e.exports = function (e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = a(r(23)),
        i = a(r(2)),
        u = n(r(1)),
        l = (a(r(3)), r(65)),
        c = r(15),
        s = r(11);

    function f(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    var d = function d(e) {
      var t = e.forms,
          r = e.selectorProps,
          n = e.currentUser,
          a = e.permission,
          d = e.handleOk,
          p = e.handleCancel,
          m = e.newItem,
          h = e.mainProps,
          v = e.loading,
          g = e.displayName,
          y = e.showFormVal,
          b = e.resourceName,
          O = e.callbacks,
          P = (e.edited, (0, c.useIntl)()),
          w = t.map(function (e) {
        var t = function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? f(Object(r), !0).forEach(function (t) {
              (0, i.default)(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : f(Object(r)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
          }

          return e;
        }({
          intl: P,
          currentUser: n,
          permission: a
        }, r),
            c = l.MrFormComponent,
            w = "function" == typeof e.config ? e.config({
          intl: P
        }) : e.config,
            x = {
          isModal: !0,
          visible: !1,
          noHtml5Validate: !0,
          formLabel: g,
          createAtIndex: 0
        },
            j = (0, s.merge)({}, x, w),
            E = w.handleCancelCallback || null,
            k = (w.changeCallback, j.isModal),
            S = j.formLabel,
            C = (0, o.default)(j, ["isModal", "formLabel"]),
            M = y === e.name || j.visible;

        return M ? u.default.createElement(c, {
          resourceForm: e,
          key: "mainForm-".concat(e.name),
          formProps: t,
          formConfig: C,
          mainProps: h,
          isModal: k,
          layout: "vertical",
          visible: M,
          displayName: S,
          loading: v,
          item: m,
          handleOk: d,
          handleCancel: p,
          handleCancelCallback: E,
          callbacks: O,
          formData: m,
          resourceName: b
        }) : null;
      });
      return w.length, w;
    };

    d.defaultProps = {}, d.propTypes = {};
    var p = d;
    t.default = p;
  }, function (e, t, r) {
    var n = r(33);

    e.exports = function (e, t) {
      for (var r = e.length; r--;) {
        if (n(e[r][0], t)) return r;
      }

      return -1;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.buildOptions = void 0;
    var o = a(r(2)),
        i = a(r(16)),
        u = n(r(1)),
        l = (a(r(3)), a(r(39)));
    r(126);
    var c = r(24),
        s = r(6),
        f = r(5);

    function d(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function p(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? d(Object(r), !0).forEach(function (t) {
          (0, o.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : d(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var m = f.Select.Option,
        h = f.Input.Search,
        v = function v(e, t, r) {
      var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
      if (!e) return [];
      var a,
          o,
          u,
          l,
          s = [];
      l = !1, e.forEach(function (e) {
        "string" == typeof e ? o = u = e : "object" === (0, i.default)(e) && (u = "object" === t ? e : e[t], o = e[r], l = e.disabled), o = (0, c.capitalize)(o), "" === u && "" === o && (o = "All"), a = {
          key: o,
          text: o,
          value: u,
          disabled: l
        }, s.push(a);
      });
      return n.clearOptions ? [{
        value: null,
        text: "All"
      }].concat(s) : s;
    };

    t.buildOptions = v;

    var g = function g(e) {
      var t = e.controlName,
          r = e.type,
          n = e.placeholder,
          a = e.prefix,
          o = e.style,
          i = e.elementType,
          c = e.label,
          d = e.noLabel,
          g = e.disabled,
          y = e.isFormItem,
          b = e.mainForm,
          O = e.defaultValue,
          P = e.valueKey,
          w = e.textKey,
          x = (e.validationRules, e.fieldInfo),
          j = (e.enterButton, e.loading),
          E = e.extraOptions,
          k = e.value,
          S = e.id,
          C = e.onFocus,
          M = e.onBlur,
          _ = e.required,
          A = e.readonly,
          N = e.autofocus,
          T = (e.ref, e.options);
      r || (r = "text"), x || (x = {}), i || (i = "input"), j || (j = !1), g || (g = !1), y || (y = !1), o || (o = {}), E || (E = {}), n || (n = t), c || d || (c = t);
      var F;
      a ? "element" === a.type && (F = a.element) : a = null;

      var R = function R(t) {
        var r = (0, s.returnFinalValue)(t);

        if (e.hasOwnProperty("changed")) {
          var n = {};
          b && (n.mainForm = b), e.hasOwnProperty("fieldInfo") && (n = p({}, e.fieldInfo));
          e.changed("" === r ? T.emptyValue : r, n);
        }
      },
          I = {
        required: _,
        placeholder: n,
        disabled: g,
        readonly: A,
        value: k || O,
        defaultValue: O,
        autoFocus: N,
        onChange: R,
        className: e.classNames
      };

      e.default && !O && (O = e.default);
      var D = p({
        id: S,
        type: r,
        placeholder: n,
        disabled: g,
        readonly: A,
        onBlur: M,
        onFocus: C,
        autofocus: N,
        required: _,
        value: k,
        prefix: F,
        defaultValue: O,
        onChange: R
      }, e.options),
          L = {
        type: r,
        placeholder: n,
        disabled: g,
        defaultValue: O,
        onSearch: R,
        enterButton: e.enterButton || !0
      },
          U = p({
        style: o,
        placeholder: n,
        initialValue: O,
        defaultValue: O,
        loading: e.loading,
        id: e.id,
        mode: e.mode,
        required: e.required,
        autofocus: e.autofocus,
        disabled: g,
        onBlur: e.onBlur,
        onFocus: e.onFocus
      }, I, {
        onChange: R
      }),
          B = p({
        format: e.format,
        showTime: e.showTime
      }, I),
          V = p({
        format: e.format,
        onChange: R
      }, I),
          W = p({}, I, {
        disabled: g,
        autofocus: N,
        label: c
      }),
          q = p({
        options: e.options
      }, I, {
        disabled: g,
        autofocus: N
      }),
          z = p({
        format: e.format
      }, D, {}, I),
          H = p({
        autoSize: {
          minRows: 2,
          maxRows: 6
        }
      }, D);
      "select" !== i || o.hasOwnProperty("width") || (U.style = {
        width: 200
      });
      var $;

      switch (i) {
        case "select":
          var K = v(e.options, P, w, E).map(function (e) {
            return y ? u.default.createElement(m, {
              key: e.value,
              value: e.value
            }, e.text) : u.default.createElement(m, {
              key: e.value
            }, e.text);
          });
          $ = u.default.createElement(f.Select, U, K);
          break;

        case "search":
        case "file":
          $ = u.default.createElement(h, L);
          break;

        case "datetime":
          B.value && "string" == typeof B.value && (B.value = (0, l.default)(B.value, B.format)), B.defaultValue && "string" == typeof B.defaultValue && (B.defaultValue = (0, l.default)(B.defaultValue, B.format)), $ = u.default.createElement(f.DatePicker, B);
          break;

        case "date":
          V.value && "string" == typeof V.value && (V.value = (0, l.default)(V.value, V.format)), V.defaultValue && "string" == typeof V.defaultValue && (V.defaultValue = (0, l.default)(V.defaultValue, V.format)), $ = u.default.createElement(f.DatePicker, V);
          break;

        case "checkboxes":
          $ = u.default.createElement(f.Checkbox.Group, q);
          break;

        case "password":
          $ = u.default.createElement(f.Input.Password, D);
          break;

        case "textarea":
          $ = u.default.createElement(f.Input.TextArea, H);
          break;

        case "time":
          z.value && "string" == typeof z.value && (z.value = (0, l.default)(z.value, z.format)), z.defaultValue && "string" == typeof z.defaultValue && (z.defaultValue = (0, l.default)(z.defaultValue, z.format)), $ = u.default.createElement(f.TimePicker, z);
          break;

        case "checkbox":
          $ = u.default.createElement(f.Checkbox, W, W.label);
          break;

        case "json":
          var G = {};
          O && (G = "string" == typeof O ? JSON.parse(O) : O);
          var Q = {
            value: G,
            onChange: function onChange(t) {
              if (e.hasOwnProperty("changed")) {
                var r = {};
                e.hasOwnProperty("fieldInfo") && (r = p({}, e.fieldInfo));
                var n = t;
                e.changed(n, r);
              }

              return t;
            }
          };
          $ = u.default.createElement(Editor, Q), $ = null;
          break;

        default:
          $ = u.default.createElement(f.Input, D);
      }

      return $;
    };

    g.defaultProps = {
      valueKey: "value",
      textKey: "text",
      options: {}
    };
    var y = g;
    t.default = y;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.mrTranslate = t.useTranslate = t.MrTranslate = void 0;
    var a = n(r(2)),
        o = n(r(1)),
        i = r(15);

    function u(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    var l = function l(e) {
      var t = e.id,
          r = e.contentType || "message",
          n = e.component,
          l = e.componentProps || {},
          c = e.defaultMessage || t,
          s = e.values || {},
          f = (e.opts, i.FormattedMessage),
          d = {};
      return "message" === r && (d = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? u(Object(r), !0).forEach(function (t) {
            (0, a.default)(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : u(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }

        return e;
      }({}, d, {
        id: t,
        defaultMessage: c,
        values: s
      })), n ? o.default.createElement(n, l) : o.default.createElement(o.default.Fragment, null, o.default.createElement(f, d));
    };

    t.MrTranslate = l;

    var c = function c(e) {
      function t(t) {
        var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            a = n.defaultMsg || t;
        return e.formatMessage({
          id: t,
          defaultMessage: a
        }, r);
      }

      return t;
    };

    t.useTranslate = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = (0, i.useIntl)();
      return c(t, e);
    };

    t.mrTranslate = function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return c(e, t);
    };

    var s = l;
    t.default = s;
  }, function (e, t, r) {
    var n = r(128),
        a = r(129),
        o = r(66),
        i = r(130);
    e.exports = function (e, t) {
      return n(e) || a(e, t) || o(e, t) || i();
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e, t) {
      return e === t || e != e && t != t;
    };
  }, function (e, t, r) {
    var n = r(86);

    e.exports = function (e, t, r) {
      "__proto__" == t && n ? n(e, t, {
        configurable: !0,
        enumerable: !0,
        value: r,
        writable: !0
      }) : e[t] = r;
    };
  }, function (e, t, r) {
    var n = r(93),
        a = "object" == typeof self && self && self.Object === Object && self,
        o = n || a || Function("return this")();
    e.exports = o;
  }, function (e, t) {
    var r = Array.isArray;
    e.exports = r;
  }, function (e, t) {
    e.exports = function (e) {
      return null != e && "object" == typeof e;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(122),
        a = r(123),
        o = r(124);

    function i(e, t) {
      return t.encode ? t.strict ? n(e) : encodeURIComponent(e) : e;
    }

    function u(e, t) {
      return t.decode ? a(e) : e;
    }

    function l(e) {
      var t = e.indexOf("#");
      return -1 !== t && (e = e.slice(0, t)), e;
    }

    function c(e) {
      var t = (e = l(e)).indexOf("?");
      return -1 === t ? "" : e.slice(t + 1);
    }

    function s(e, t) {
      return t.parseNumbers && !Number.isNaN(Number(e)) && "string" == typeof e && "" !== e.trim() ? e = Number(e) : !t.parseBooleans || null === e || "true" !== e.toLowerCase() && "false" !== e.toLowerCase() || (e = "true" === e.toLowerCase()), e;
    }

    function f(e, t) {
      var r = function (e) {
        var t;

        switch (e.arrayFormat) {
          case "index":
            return function (e, r, n) {
              t = /\[(\d*)\]$/.exec(e), e = e.replace(/\[\d*\]$/, ""), t ? (void 0 === n[e] && (n[e] = {}), n[e][t[1]] = r) : n[e] = r;
            };

          case "bracket":
            return function (e, r, n) {
              t = /(\[\])$/.exec(e), e = e.replace(/\[\]$/, ""), t ? void 0 !== n[e] ? n[e] = [].concat(n[e], r) : n[e] = [r] : n[e] = r;
            };

          case "comma":
            return function (e, t, r) {
              var n = "string" == typeof t && t.split("").indexOf(",") > -1 ? t.split(",") : t;
              r[e] = n;
            };

          default:
            return function (e, t, r) {
              void 0 !== r[e] ? r[e] = [].concat(r[e], t) : r[e] = t;
            };
        }
      }(t = Object.assign({
        decode: !0,
        sort: !0,
        arrayFormat: "none",
        parseNumbers: !1,
        parseBooleans: !1
      }, t)),
          n = Object.create(null);

      if ("string" != typeof e) return n;
      if (!(e = e.trim().replace(/^[?#&]/, ""))) return n;

      var _iterator = _createForOfIteratorHelper(e.split("&")),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _a = _step.value;

          var _o = o(t.decode ? _a.replace(/\+/g, " ") : _a, "="),
              _o2 = _slicedToArray(_o, 2),
              _e3 = _o2[0],
              _i3 = _o2[1];

          _i3 = void 0 === _i3 ? null : u(_i3, t), r(u(_e3, t), _i3, n);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      for (var _i = 0, _Object$keys = Object.keys(n); _i < _Object$keys.length; _i++) {
        var _e = _Object$keys[_i];
        var _r = n[_e];
        if ("object" == typeof _r && null !== _r) for (var _i2 = 0, _Object$keys2 = Object.keys(_r); _i2 < _Object$keys2.length; _i2++) {
          var _e2 = _Object$keys2[_i2];
          _r[_e2] = s(_r[_e2], t);
        } else n[_e] = s(_r, t);
      }

      return !1 === t.sort ? n : (!0 === t.sort ? Object.keys(n).sort() : Object.keys(n).sort(t.sort)).reduce(function (e, t) {
        var r = n[t];
        return Boolean(r) && "object" == typeof r && !Array.isArray(r) ? e[t] = function e(t) {
          return Array.isArray(t) ? t.sort() : "object" == typeof t ? e(Object.keys(t)).sort(function (e, t) {
            return Number(e) - Number(t);
          }).map(function (e) {
            return t[e];
          }) : t;
        }(r) : e[t] = r, e;
      }, Object.create(null));
    }

    t.extract = c, t.parse = f, t.stringify = function (e, t) {
      if (!e) return "";

      var r = function (e) {
        switch (e.arrayFormat) {
          case "index":
            return function (t) {
              return function (r, n) {
                var a = r.length;
                return void 0 === n || e.skipNull && null === n ? r : null === n ? [].concat(_toConsumableArray(r), [[i(t, e), "[", a, "]"].join("")]) : [].concat(_toConsumableArray(r), [[i(t, e), "[", i(a, e), "]=", i(n, e)].join("")]);
              };
            };

          case "bracket":
            return function (t) {
              return function (r, n) {
                return void 0 === n || e.skipNull && null === n ? r : null === n ? [].concat(_toConsumableArray(r), [[i(t, e), "[]"].join("")]) : [].concat(_toConsumableArray(r), [[i(t, e), "[]=", i(n, e)].join("")]);
              };
            };

          case "comma":
            return function (t) {
              return function (r, n) {
                return null == n || 0 === n.length ? r : 0 === r.length ? [[i(t, e), "=", i(n, e)].join("")] : [[r, i(n, e)].join(",")];
              };
            };

          default:
            return function (t) {
              return function (r, n) {
                return void 0 === n || e.skipNull && null === n ? r : null === n ? [].concat(_toConsumableArray(r), [i(t, e)]) : [].concat(_toConsumableArray(r), [[i(t, e), "=", i(n, e)].join("")]);
              };
            };
        }
      }(t = Object.assign({
        encode: !0,
        strict: !0,
        arrayFormat: "none"
      }, t)),
          n = Object.assign({}, e);

      if (t.skipNull) for (var _i4 = 0, _Object$keys3 = Object.keys(n); _i4 < _Object$keys3.length; _i4++) {
        var _e4 = _Object$keys3[_i4];
        void 0 !== n[_e4] && null !== n[_e4] || delete n[_e4];
      }
      var a = Object.keys(n);
      return !1 !== t.sort && a.sort(t.sort), a.map(function (n) {
        var a = e[n];
        return void 0 === a ? "" : null === a ? i(n, t) : Array.isArray(a) ? a.reduce(r(n), []).join("&") : i(n, t) + "=" + i(a, t);
      }).filter(function (e) {
        return e.length > 0;
      }).join("&");
    }, t.parseUrl = function (e, t) {
      return {
        url: l(e).split("?")[0] || "",
        query: f(c(e), t)
      };
    }, t.stringifyUrl = function (e, r) {
      var n = l(e.url).split("?")[0] || "",
          a = t.extract(e.url),
          o = t.parse(a),
          i = function (e) {
        var t = "";
        var r = e.indexOf("#");
        return -1 !== r && (t = e.slice(r)), t;
      }(e.url),
          u = Object.assign(o, e.query);

      var c = t.stringify(u, r);
      return c && (c = "?" + c), "".concat(n).concat(c).concat(i);
    };
  }, function (e, t) {
    e.exports = c;
  }, function (e, t) {
    e.exports = function (e) {
      throw new TypeError('"' + e + '" is read-only');
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    var n = r(27),
        a = r(132),
        o = r(133),
        i = Math.max,
        u = Math.min;

    e.exports = function (e, t, r) {
      var l,
          c,
          s,
          f,
          d,
          p,
          m = 0,
          h = !1,
          v = !1,
          g = !0;
      if ("function" != typeof e) throw new TypeError("Expected a function");

      function y(t) {
        var r = l,
            n = c;
        return l = c = void 0, m = t, f = e.apply(n, r);
      }

      function b(e) {
        return m = e, d = setTimeout(P, t), h ? y(e) : f;
      }

      function O(e) {
        var r = e - p;
        return void 0 === p || r >= t || r < 0 || v && e - m >= s;
      }

      function P() {
        var e = a();
        if (O(e)) return w(e);
        d = setTimeout(P, function (e) {
          var r = t - (e - p);
          return v ? u(r, s - (e - m)) : r;
        }(e));
      }

      function w(e) {
        return d = void 0, g && l ? y(e) : (l = c = void 0, f);
      }

      function x() {
        var e = a(),
            r = O(e);

        if (l = arguments, c = this, p = e, r) {
          if (void 0 === d) return b(p);
          if (v) return clearTimeout(d), d = setTimeout(P, t), y(p);
        }

        return void 0 === d && (d = setTimeout(P, t)), f;
      }

      return t = o(t) || 0, n(r) && (h = !!r.leading, s = (v = "maxWait" in r) ? i(o(r.maxWait) || 0, t) : s, g = "trailing" in r ? !!r.trailing : g), x.cancel = function () {
        void 0 !== d && clearTimeout(d), m = 0, l = p = c = d = void 0;
      }, x.flush = function () {
        return void 0 === d ? f : w(a());
      }, x;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.FormRenderer = t.ObjectField = void 0;
    var o = a(r(2)),
        i = a(r(43)),
        u = n(r(1)),
        l = (a(r(3)), r(5)),
        c = n(r(138)),
        s = (r(11), r(8));

    function f(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function d(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? f(Object(r), !0).forEach(function (t) {
          (0, o.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : f(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    r(147);

    var p = function p(e) {
      var t = e.fields,
          r = e.arrayHelpers,
          n = e.propertyKey,
          a = e.objToProcess,
          o = e.sourceValues,
          f = e.formInstance,
          p = e.options,
          h = e.config || {},
          v = (h.span, h.addButtonTitle || u.default.createElement("span", null, u.default.createElement(s.PlusOutlined, null), " Add")),
          g = h.removeButtonTitle || u.default.createElement(s.DeleteTwoTone, {
        twoToneColor: "#EB2F96"
      }),
          y = r.add,
          b = r.remove,
          O = (r.move, h.disableRemoveProperty, h.min || 0),
          P = h.max || 5,
          w = (h.className, h.title),
          x = h.span || 24,
          j = h.offset || 0;
      return u.default.createElement(u.default.Fragment, null, w && u.default.createElement(l.Form.Item, null, w), t.map(function (e, t) {
        var r = !1,
            s = p.parentPropertyKey || [];
        s && (Array.isArray(s) || (s = s.split(".")));
        var h = [].concat((0, i.default)(s), (0, i.default)((0, c.getFormItemName)(n)), [e.name]),
            v = f.getFieldValue(h);
        return v && v.id && (r = !0), u.default.createElement(l.Col, {
          span: x,
          offset: j,
          key: "nested-form-row-".concat(e.key)
        }, u.default.createElement(l.Row, null, u.default.createElement(l.Col, {
          span: 22
        }, u.default.createElement(l.Row, {
          gutter: 24
        }, u.default.createElement(m, {
          key: e.key,
          propertyKey: [e.name],
          formObj: a.items,
          sourceValues: o,
          options: d({}, p, {
            arrayItemProps: e,
            parentPropertyKey: n
          }),
          formInstance: f,
          isNested: !0
        }))), !r && t >= O && u.default.createElement(l.Col, {
          span: 2,
          className: "form-nested-remove-btn-wrapper"
        }, u.default.createElement(l.Form.Item, null, u.default.createElement(l.Button, {
          type: "text",
          shape: "circle",
          className: "form-nested-remove-btn1 ".concat(e.key, " ").concat(e.name),
          onClick: function onClick() {
            return b(t);
          }
        }, g)))));
      }), t.length < P && u.default.createElement(l.Form.Item, {
        className: "form-nested-add-btn-wrapper"
      }, u.default.createElement(l.Button, {
        onClick: function onClick() {
          return y();
        }
      }, v)));
    };

    (0, u.memo)(p, function (e, t) {
      var r = e.arrayHelpers.form,
          n = t.arrayHelpers.form;
      return getIn(r.values, e.propertyKey).length === getIn(n.values, t.propertyKey).length;
    });

    t.ObjectField = function (e) {
      var t = e.name,
          r = e.label,
          n = e.children,
          a = e.rules;
      return u.default.createElement(l.Form.Item, {
        key: "Fields.ObjectField_".concat(t),
        label: r,
        name: t,
        rules: a
      }, n);
    };

    var m = function e(t) {
      var r = t.formObj,
          n = t.propertyKey,
          a = t.isNested,
          o = t.sourceValues,
          i = t.formInstance,
          s = t.options || {},
          f = [],
          m = d({}, r);
      if (r.hasOwnProperty("schema") && (m = r.schema), m.hasOwnProperty("type") && "string" == typeof m.type) switch (m.type) {
        case "object":
          var h = n || "topSchema";
          return u.default.createElement(e, Object.assign({
            key: h
          }, t, {
            propertyKey: n,
            formObj: m.properties,
            sourceValues: o,
            formInstance: i,
            options: s
          }));

        case "array":
          var v = a ? 23 : 24,
              g = 24 - v;
          return u.default.createElement(l.Form.List, {
            key: "".concat(n, "_field_array"),
            name: n.split(".")
          }, function (e, t) {
            return u.default.createElement(l.Col, {
              span: v,
              offset: g
            }, u.default.createElement(l.Row, null, u.default.createElement(p, {
              fields: e,
              arrayHelpers: t,
              propertyKey: n,
              config: m,
              objToProcess: m,
              sourceValues: o,
              formInstance: i,
              options: s
            })));
          });

        default:
          return u.default.createElement(c.default, {
            key: n,
            type: m.type,
            config: m,
            name: n,
            sourceValues: o,
            options: s,
            formInstance: i
          });
      } else for (var y in m) {
        if (m.hasOwnProperty(y)) {
          var b = m[y],
              O = n ? "".concat(n, ".").concat(y) : y,
              P = u.default.createElement(e, Object.assign({}, t, {
            key: "".concat(O, "_").concat(y),
            propertyKey: O,
            formObj: b,
            sourceValues: o,
            options: s
          }));
          f.push(P);
        }
      }
      return f;
    };

    t.FormRenderer = m;
    (0, u.memo)(m, function (e, t) {
      return !1;
    });
    var h = m;
    t.default = h;
  }, function (e, t, r) {
    var n = r(135),
        a = r(136),
        o = r(66),
        i = r(137);
    e.exports = function (e) {
      return n(e) || a(e) || o(e) || i();
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    var n = r(145)();
    e.exports = n;

    try {
      regeneratorRuntime = n;
    } catch (e) {
      "object" == typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
    }
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var a = n(r(2)),
        o = r(46),
        i = n(r(155)),
        u = function u(e) {
      var t,
          r,
          n,
          u = e.resourceName,
          l = e.resourceGroupName,
          c = e.resourceSelector,
          s = e.resourceState,
          f = e.actionNames,
          d = function d(e) {
        return e[u], e[u].get("loading");
      },
          p = function p(e) {
        return e[u].get("firstAction", null);
      },
          m = function m(e) {
        return e[u].get("error");
      };

      r = s || function (e) {
        var t = e[u].get(l, i.default.List());
        return t.hasOwnProperty("size") ? t.toJS() : t;
      }, n = c || function () {
        return (0, o.createSelector)([r], function (e) {
          return e;
        });
      };

      var h = {},
          v = function v(e) {
        return h.page = e[u].get("page"), h.totalPages = e[u].get("total_pages"), h.totalCount = e[u].get("total_count"), h.pageSize = e[u].get("page_size"), h;
      },
          g = (t = {
        loading: function loading() {
          return (0, o.createSelector)([d], function (e) {
            return e;
          });
        },
        error: function error() {
          return (0, o.createSelector)([m], function (e) {
            return e;
          });
        }
      }, (0, a.default)(t, u, n), (0, a.default)(t, "firstAction", function () {
        return (0, o.createSelector)([p], function (e) {
          return e;
        });
      }), (0, a.default)(t, "pagination", function () {
        return (0, o.createSelector)([v], function (e) {
          return e;
        });
      }), t);

      return f && Array.isArray(f) && f.forEach(function (e) {
        var t = "".concat(e.toLowerCase(), "loading"),
            r = function r(e) {
          return e[u].get("".concat(t), !1);
        };

        g[t] = function () {
          return (0, o.createSelector)([r], function (e) {
            return e;
          });
        };
      }), g;
    };

    t.default = u;
  }, function (e, t, r) {
    "use strict";

    function n(e, t) {
      return e === t;
    }

    function a(e, t, r) {
      if (null === t || null === r || t.length !== r.length) return !1;

      for (var n = t.length, a = 0; a < n; a++) {
        if (!e(t[a], r[a])) return !1;
      }

      return !0;
    }

    function o(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : n,
          r = null,
          o = null;
      return function () {
        return a(t, r, arguments) || (o = e.apply(null, arguments)), r = arguments, o;
      };
    }

    function i(e) {
      var t = Array.isArray(e[0]) ? e[0] : e;

      if (!t.every(function (e) {
        return "function" == typeof e;
      })) {
        var r = t.map(function (e) {
          return typeof e;
        }).join(", ");
        throw new Error("Selector creators expect all input-selectors to be functions, instead received the following types: [" + r + "]");
      }

      return t;
    }

    function u(e) {
      for (var t = arguments.length, r = Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) {
        r[n - 1] = arguments[n];
      }

      return function () {
        for (var t = arguments.length, n = Array(t), a = 0; a < t; a++) {
          n[a] = arguments[a];
        }

        var o = 0,
            u = n.pop(),
            l = i(n),
            c = e.apply(void 0, [function () {
          return o++, u.apply(null, arguments);
        }].concat(r)),
            s = e(function () {
          for (var e = [], t = l.length, r = 0; r < t; r++) {
            e.push(l[r].apply(null, arguments));
          }

          return c.apply(null, e);
        });
        return s.resultFunc = u, s.dependencies = l, s.recomputations = function () {
          return o;
        }, s.resetRecomputations = function () {
          return o = 0;
        }, s;
      };
    }

    r.r(t), r.d(t, "defaultMemoize", function () {
      return o;
    }), r.d(t, "createSelectorCreator", function () {
      return u;
    }), r.d(t, "createSelector", function () {
      return l;
    }), r.d(t, "createStructuredSelector", function () {
      return c;
    });
    var l = u(o);

    function c(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l;
      if ("object" != typeof e) throw new Error("createStructuredSelector expects first argument to be an object where each property is a selector, instead received a " + typeof e);
      var r = Object.keys(e);
      return t(r.map(function (t) {
        return e[t];
      }), function () {
        for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
          t[n] = arguments[n];
        }

        return t.reduce(function (e, t, n) {
          return e[r[n]] = t, e;
        }, {});
      });
    }
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.SearchFilterComponent = t.CreateBtn = void 0;
    var o = a(r(32)),
        i = a(r(25)),
        u = n(r(1)),
        l = r(5),
        c = a(r(22)),
        s = a(r(30)),
        f = (r(15), r(8)),
        d = r(9),
        p = r(11);
    r(156);
    var m = r(71),
        h = r(31);

    function v() {
      var e = (0, i.default)(["\n  max-width: 500px;\n"]);
      return v = function v() {
        return e;
      }, e;
    }

    function g() {
      var e = (0, i.default)(["\n  padding: 0 0 20px 0;\n  > div,\n  > span,\n  button {\n    // margin-right: 15px;\n  }\n  .ant-input-search {\n    max-width: 500px;\n  }\n"]);
      return g = function g() {
        return e;
      }, e;
    }

    var y = l.Input.Search,
        b = (c.default.div(g()), (0, c.default)(s.default)(v()), {
      create: {
        show: !0
      },
      search: {
        show: !0,
        compact: !1,
        showFilterSuffix: !1
      },
      reload: {
        show: !1
      }
    });

    t.CreateBtn = function (e) {
      var t = (0, h.useTranslate)(),
          r = (0, d.useRouteMatch)().url;
      return u.default.createElement(l.Button, {
        type: "primary",
        key: "createBtn",
        icon: u.default.createElement(f.PlusOutlined, null),
        onClick: function onClick() {
          e.history.push("".concat(r, "/create"));
        }
      }, t("CommonText.create", {}, {
        defaultMsg: "Create"
      }));
    };

    var O = function O(e) {
      (0, d.useRouteMatch)().url;
      var t = (0, h.useTranslate)(),
          r = (0, u.useState)(e.search),
          n = (0, o.default)(r, 2),
          a = n[0],
          i = n[1],
          c = (0, m.usePrevious)(e.search),
          s = e.config || {},
          v = (0, p.merge)({}, b, s);
      v.search.showFilterSuffix = !(!v.layout || "compact" !== v.layout.mode);
      var g = t("CommonText.search", {}, {
        defaultMsg: "Search"
      });
      (0, u.useEffect)(function () {
        c !== e.search && e.search !== a && i(e.search);
      }, [e.search]);
      var O = u.default.createElement(l.Dropdown, {
        overlay: [],
        trigger: ["click"]
      }, u.default.createElement(f.FilterOutlined, {
        onClick: function onClick() {}
      })),
          P = {};
      return v.search.showFilterSuffix && (P.suffix = O), u.default.createElement(y, Object.assign({
        key: "searchFilter".concat(e.singleResourceName),
        allowClear: !0,
        placeholder: g,
        value: a,
        onChange: function onChange(e) {
          return i(e.target.value);
        },
        onSearch: function onSearch(t) {
          return e.setParams({
            search: t
          });
        },
        enterButton: !0
      }, P));
    };

    t.SearchFilterComponent = O;

    var P = function P(e) {
      (0, d.useRouteMatch)().url;
      var t = (0, h.useTranslate)(),
          r = e.searchComponent || O,
          n = e.config || {},
          a = (0, p.merge)({}, b, n),
          o = [],
          i = e.extraFilters || [];

      if (e.hasOwnProperty("create") && a.create.show && o.push(u.default.createElement(l.Col, {
        key: "colcreateBtnMain"
      }, u.default.createElement(l.Button, {
        key: "createBtnMain",
        type: "primary",
        onClick: e.create,
        icon: u.default.createElement(f.PlusOutlined, null)
      }, t("CommonText.create", {}, {
        defaultMsg: "Create"
      })))), e.createBtn && a.create.show) {
        var c = e.createBtn;
        o.push(u.default.createElement(c, e, "Hello"));
      }

      a.search.show && o.push(u.default.createElement(l.Col, {
        key: "colsearchFilter"
      }, u.default.createElement(r, e))), a.reload.show && o.push(u.default.createElement(l.Col, {
        key: "colreloadBtnMain"
      }, u.default.createElement(l.Button, {
        key: "reloadBtnMain",
        onClick: e.refresh,
        icon: u.default.createElement(f.ReloadOutlined, null)
      })));
      var s = Array.isArray(i) ? i.map(function (e, t) {
        return u.default.createElement(l.Col, {
          key: "extraFilter" + t
        }, e);
      }) : i,
          m = u.default.createElement(u.default.Fragment, null, o, e.children);
      return u.default.createElement(l.Row, {
        className: "".concat(a.className || "mainFilterComponent_".concat(e.singleResourceName), " mainFilter")
      }, a.layout && "compact" === a.layout.mode ? u.default.createElement(u.default.Fragment, null, u.default.createElement(l.Col, {
        span: 24
      }, u.default.createElement(l.Space, null, a.customStyle ? o : m)), u.default.createElement(l.Col, {
        span: 24
      }, u.default.createElement("div", {
        className: "main-filter-extra-filter-wrapper"
      }, u.default.createElement("div", {
        className: "main-filter-extra-filters"
      }, s), u.default.createElement("div", {
        className: "main-filter-children"
      })))) : u.default.createElement(l.Col, {
        span: 24
      }, a.customStyle ? m : u.default.createElement(l.Space, null, m, s)));
    };

    t.default = P;
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = a(r(2)),
        i = (n(r(1)), r(18)),
        u = a(r(24)),
        l = a(r(45)),
        c = r(6);

    function s(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function f(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? s(Object(r), !0).forEach(function (t) {
          (0, o.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var d = function d(e, t) {
      var r,
          n = e.resourceName,
          a = e.singleResourceName,
          o = (e.displayName, e.actions),
          s = e.actionNames,
          d = (e.firstTimeFetchParams, e.listHeader, e.useOwnProps),
          p = e.dispatchObj || {},
          m = {
        resourceName: n,
        resourceGroupName: a + "s",
        actionNames: s
      },
          h = f({}, (0, l.default)(m));
      return e.selectorsObj && (h = f({}, h, {}, e.selectorsObj)), r = e.hasOwnProperty("mapDispatchToProps") ? e.mapDispatchToProps : function (t) {
        var r = {};

        for (var n in s.forEach(function (e) {
          var n = u.default.classify(e);

          r["on".concat(n)] = function (r) {
            for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) {
              a[i - 1] = arguments[i];
            }

            t(o["".concat(e)].apply(o, [r].concat(a)));
          };
        }), p) {
          if (p.hasOwnProperty(n)) {
            r[n] = function (e) {
              for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++) {
                n[a - 1] = arguments[a];
              }

              t(o.fetch.apply(o, [e].concat(n)));
            };

            var a = p[n];
            t(a);
          }
        }

        return e.fetch && t(e.actions.fetch(params)), r;
      }, (0, i.connect)(function () {
        var e = (0, c.selectorsObjBuilder)(h);
        return d ? function (t, r) {
          var n = {};
          if (t) for (var a in e) {
            if (e.hasOwnProperty(a)) {
              var o = e[a];
              n[a] = o(t, r);
            }
          }
          return n;
        } : function (t) {
          var r = {};
          if (t) for (var n in e) {
            if (e.hasOwnProperty(n)) {
              var a = e[n];
              r[n] = a(t);
            }
          }
          return r;
        };
      }, r)(t);
    };

    t.default = d;
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = a(r(16)),
        i = a(r(23)),
        u = a(r(7)),
        l = a(r(10)),
        c = a(r(12)),
        s = a(r(13)),
        f = a(r(17)),
        d = a(r(14)),
        p = a(r(2)),
        m = n(r(1)),
        h = a(r(3)),
        v = (r(18), a(r(50))),
        g = a(r(24)),
        y = a(r(116)),
        b = (a(r(62)), r(5), a(r(63)), r(6)),
        O = a(r(28)),
        P = (a(r(70)), a(r(150))),
        w = a(r(21)),
        x = (a(r(45)), a(r(47))),
        j = (a(r(22)), a(r(158))),
        E = (a(r(74)), a(r(48))),
        k = a(r(171));

    function S(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function C(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? S(Object(r), !0).forEach(function (t) {
          (0, p.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : S(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var M = function M(e) {
      var t = e.resourceName,
          r = e.singleResourceName,
          n = e.displayName,
          a = e.filter,
          h = e.listItem,
          S = (e.actions, e.params, e.actionNames),
          M = e.firstTimeFetchParams,
          _ = e.resourceUrl,
          A = e.forms,
          N = e.layout,
          T = e.pagination,
          F = (e.totalPages, e.formProps),
          R = e.listHeader,
          I = (e.isRoute, e.selectorsObj),
          D = e.manualFormRender,
          L = e.formMode;
      g.default.camelize("".concat(t), !0);
      N || (N = j.default);
      var U = R;
      R || (U = null);
      var B = N;
      F || (F = {}), T || (T = null), _ || (_ = t), n || (n = t), S || (S = ["fetch", "create", "udpate", "delete"]), M || (M = {});

      var V = function (g) {
        function j(a) {
          var l, d;
          (0, u.default)(this, j), l = (0, c.default)(this, (0, s.default)(j).call(this, a)), (0, p.default)((0, f.default)(l), "debounceFetch", function () {
            l.executeFetch();
          }), (0, p.default)((0, f.default)(l), "executeFetch", function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;

            if (l.config.list.shouldExecuteRequest) {
              var r = C({}, e);
              l.props.parentName && l.props.parentId && (r["".concat(l.props.parentName, "_id")] = l.props.parentId), l.props.params && (r = C({}, r, {}, l.props.params)), t && (r = C({}, r, {}, t)), r = C({}, r, {}, l.state.params), l.props.onFetch({
                params: r
              });
            }
          }), (0, p.default)((0, f.default)(l), "refresh", function () {
            l.executeFetch();
          }), (0, p.default)((0, f.default)(l), "onPageChange", function (e) {
            var t = l.props,
                r = t.location,
                n = t.history,
                a = C({}, l.state.params, {
              page: e
            });
            l.setState({
              params: a
            }, function () {
              l.config.core.setQueryParams && (0, b.setQueryParams)({
                history: n,
                location: r,
                url: r.pathname,
                params: l.state.params
              }), l.executeFetch();
            });
          }), (0, p.default)((0, f.default)(l), "toggleSelectItem", function (e) {}), (0, p.default)((0, f.default)(l), "toggleSelectAll", function () {}), (0, p.default)((0, f.default)(l), "switchTab", function (e) {
            l.setState({
              currentTab: e
            });
          }), (0, p.default)((0, f.default)(l), "edited", function (e) {
            l.showForm(e);
          }), (0, p.default)((0, f.default)(l), "goBack", function () {
            l.props.history.goBack();
          }), (0, p.default)((0, f.default)(l), "duplicateResource", function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = C({
              duplicateAtIndex: 0
            }, t);
            l.props.onDuplicate && l.props.onDuplicate((0, p.default)({
              id: e.id
            }, r, e), n);
          }), (0, p.default)((0, f.default)(l), "deleted", function (e, t) {
            l.props.onDelete((0, p.default)({
              id: e.id
            }, r, {
              id: e.id,
              archived: !0
            }), t);
          }), (0, p.default)((0, f.default)(l), "updateResource", function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              redirectTo: null
            };
            l.handleOk(e, t);
          }), (0, p.default)((0, f.default)(l), "handleOk", function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              redirectTo: "back"
            },
                n = {},
                a = "Create",
                o = "id";
            l.config.uuid.active && (o = l.config.uuid.key), e[o] && null !== e[o] ? (a = "Update", n = (0, p.default)({
              id: e[o]
            }, r, C({}, e, {
              id: e[o]
            }))) : n = (0, p.default)({}, r, C({}, e)), l.props.createUpdateParams && (n[r] = C({}, l.props.createUpdateParams, {}, n[r])), l.props.parentId && l.props.parentName && (n[r]["".concat(l.props.parentName, "_id")] = l.props.parentId);
            t.redirectTo;
            var u = (0, i.default)(t, ["redirectTo"]),
                c = (0, f.default)(l);
            u.successCallback = function (e) {
              t.hideForm && c.hideForm(), t.redirectTo && c.goBack(), t.successCallback && t.successCallback(e);
            }, u.errorCallback = function (e) {
              t.errorCallback && t.errorCallback(e);
            }, l.props["on".concat(a)](n, u);
          }), (0, p.default)((0, f.default)(l), "handleCancel", function (e) {
            var t = e.callback;
            l.hideForm(function () {
              t ? t() : l.goBack();
            });
          }), (0, p.default)((0, f.default)(l), "selectorProps", function () {
            return (0, b.returnSelectorProps)(I, l.props);
          }), (0, p.default)((0, f.default)(l), "renderForm", function (e) {
            var r = e.name,
                a = e.config,
                i = e.resource,
                u = e.callbacks,
                c = ("function" == typeof a ? a(l.props) : a) || {},
                s = u || {},
                f = l.forms.find(function (e) {
              return e.name === r;
            });

            if (f) {
              var d = C({}, f),
                  p = l.props,
                  h = p.currentUser,
                  g = p.permission,
                  y = l.props.loading,
                  b = l.state.showForm,
                  P = i || l.state.item;
              d.config = (0, v.default)({}, d.config, c), P && P.id && (y = l.props.updateloading, l.props.updateloading && (0, o.default)("object" === l.props.updateloading) && (y = l.props.updateloading["".concat(P.id)]));
              var w = {
                forms: [C({}, d)],
                selectorProps: l.selectorProps(),
                currentUser: h,
                permission: g,
                handleOk: l.handleOk,
                handleCancel: l.handleCancel,
                callbacks: s,
                newItem: P,
                item: P,
                loading: y,
                mainProps: l.props,
                displayName: n,
                showFormVal: b,
                resourceName: t,
                edited: l.edited
              };
              return m.default.createElement(O.default, Object.assign({
                key: r
              }, w));
            }

            console.error("originalForm not found by name ".concat(r, ", please provide proper form"));
          }), (0, p.default)((0, f.default)(l), "showForm", function (e) {
            var t = {
              showForm: e.name
            };
            t.item = e.item || {}, l.setState(t);
          }), (0, p.default)((0, f.default)(l), "hideForm", function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
            l.setState({
              showForm: ""
            }, function () {
              e && e();
            });
          }), (0, p.default)((0, f.default)(l), "setParams", function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                r = l.props,
                n = (r.location, r.history, C({}, l.state.params, {}, e, {
              page: null
            }));
            l.setState({
              params: C({}, n)
            }, function () {
              if (l.config.core.setQueryParams) {
                var e = l.props,
                    r = e.location,
                    a = e.history;
                (0, b.setQueryParams)({
                  history: a,
                  location: r,
                  url: r.pathname,
                  params: n
                });
              }

              var o = t.firstTimeFetchParams || {};
              l.executeFetch({}, o);
            });
          }), l.state = C({}, (d = {}, (0, p.default)(d, "".concat(t), []), (0, p.default)(d, "params", {
            search: "",
            page: 1
          }), (0, p.default)(d, "selectedItems", {}), (0, p.default)(d, "modal", {
            open: !1
          }), (0, p.default)(d, "pagination", {
            totalPages: 1
          }), (0, p.default)(d, "displayForm", ""), (0, p.default)(d, "formProps", {
            name: "",
            item: null
          }), d));
          var h = a.config || {},
              g = ("function" == typeof e.config ? e.config(l.props) : e.config) || {},
              P = {
            uuid: {
              active: !1,
              key: "uuid"
            },
            routes: {
              show: !0,
              fetch: !0,
              create: !0
            },
            itemPreview: {},
            itemDetail: {
              loader: w.default
            },
            pagination: {
              show: !0,
              config: {
                showSizeChanger: !1
              }
            },
            filter: {
              show: !0,
              style: {
                align: "top",
                width: 24
              }
            },
            core: {
              setQueryParams: !0
            },
            list: {
              createBtn: {
                show: !0
              },
              actions: {
                show: !0
              },
              show: !0,
              forceReload: !1,
              shouldExecuteRequest: !0,
              params: {},
              loader: w.default
            }
          };
          return l.forms = "function" == typeof A ? A(l.props) : A, l.config = C({}, P, {}, g, {}, h, {
            uuid: C({}, P.uuid, {}, g.uuid || {}, {}, h.uuid || {}),
            routes: C({}, P.routes, {}, g.routes || {}, {}, h.routes || {}),
            itemPreview: C({}, P.itemPreview, {}, g.itemPreview || {}, {}, h.itemPreview || {}),
            itemDetail: C({}, P.itemDetail, {}, g.itemDetail || {}, {}, h.itemDetail || {}),
            pagination: C({}, P.pagination, {}, g.pagination || {}, {}, h.pagination || {}),
            filter: C({}, P.filter, {}, g.filter || {}, {}, h.filter || {}, {
              style: C({}, P.filter.style, {}, (g.filter || {}).style || {}, {}, (h.filter || {}).style || {})
            }),
            list: C({}, P.list, {}, g.list || {}, {}, h.list || {}),
            core: C({}, P.core, {}, g.core || {}, {}, h.core || {})
          }), l.debounceFetch = l.debounceFetch.bind((0, f.default)(l)), l.debounceFetch = (0, y.default)(l.debounceFetch, 1e3), l;
        }

        return (0, d.default)(j, g), (0, l.default)(j, [{
          key: "getCrudMode",
          value: function value() {}
        }, {
          key: "componentDidMount",
          value: function value() {
            var e = this,
                r = this.props,
                n = (r.crudMode, r.location),
                a = r.match;

            if ((!this.config.routes.show || a.url === n.pathname) && this.config.routes.fetch) {
              var o = (0, b.getQueryParams)({
                location: this.props.location
              });
              this.setState({
                params: C({}, this.props.params, {}, o)
              }, function () {
                e.props.doNotReloadOnUpdate || 0 != e.props[t].length && !e.config.list.forceReload && e.props.firstAction || e.executeFetch({}, M);
              });
            }
          }
        }, {
          key: "getConfigParams",
          value: function value() {
            var e = {},
                t = this.config.list.params;
            return t && (e = "function" == typeof t ? t(this.props) || {} : t), e || {};
          }
        }, {
          key: "componentDidUpdate",
          value: function value(e, t) {
            var r = this.props,
                n = r.match,
                a = r.location,
                o = (e.match, e.location);
            this.props.doNotReloadOnUpdate || (this.props.parentId && e.parentId !== this.props.parentId || !(0, k.default)(e.params, this.props.params) || (this.config.list.forceReload || !this.props.firstAction) && o.pathname !== a.pathname && n.url === a.pathname && this.config.routes.fetch) && this.executeFetch();
          }
        }, {
          key: "render",
          value: function value() {
            var o = this.state.showForm,
                i = this.props.fetchloading || !1,
                u = (0, b.returnSelectorProps)(I, this.props),
                l = (e.config, this.props.config, this.config.itemPreview.widget || h),
                c = this.forms[0],
                s = C({}, this.props, {
              resourceName: t,
              singleResourceName: r,
              filter: a,
              MrFilter: x.default,
              displayName: n,
              resourceForm: c,
              resourceUrl: _,
              forms: this.forms,
              CustomListItem: l,
              ActionBtns: P.default,
              ListHeader: U,
              params: this.state.params,
              setParams: this.setParams,
              showFormVal: o,
              showForm: this.showForm,
              loading: i,
              item: this.state.item,
              duplicateResource: this.duplicateResource,
              handleOk: this.handleOk,
              handleCancel: this.handleCancel,
              refresh: this.refresh,
              dataSource: this.props[t],
              pagination: this.props.pagination,
              onPageChange: this.onPageChange,
              edited: this.edited,
              deleted: this.deleted,
              permission: this.props.permission,
              currentUser: this.props.currentUser,
              parentInstance: this,
              hocProps: e,
              isRoute: this.props.isRoute,
              selectorProps: u,
              renderForm: this.renderForm,
              manualFormRender: D,
              crudMode: this.props.crudMode,
              formMode: L,
              config: this.config,
              updateResource: this.updateResource,
              parentProps: C({}, this.props)
            });
            return m.default.createElement(B, s);
          }
        }]), j;
      }(m.PureComponent),
          W = (0, E.default)(e, V);

      return W.defaultProps = {
        isRoute: !0,
        manualFormRender: !1,
        doNotReloadOnUpdate: !1
      }, W;
    };

    M.defaultProps = {
      isRoute: !0,
      formMode: "regular"
    }, M.propTypes = {
      config: h.default.shape({
        itemPreview: h.default.shape({
          widget: h.default.any.isRequired
        }).isRequired,
        itemDetail: h.default.shape({
          show: h.default.bool,
          widget: h.default.any
        }).isRequired,
        core: h.default.shape({
          setQueryParams: h.default.bool
        }),
        list: h.default.shape({
          show: h.default.bool,
          widget: h.default.any
        }),
        filter: h.default.shape({
          show: h.default.bool,
          widget: h.default.any
        }),
        pagination: h.default.shape({
          show: h.default.bool
        })
      }).isRequired
    };
    var _ = M;
    t.default = _;
  }, function (e, t, r) {
    var n = r(80),
        a = r(109)(function (e, t, r) {
      n(e, t, r);
    });
    e.exports = a;
  }, function (e, t, r) {
    var n = r(81),
        a = r(82),
        o = r(83),
        i = r(84),
        u = r(85);

    function l(e) {
      var t = -1,
          r = null == e ? 0 : e.length;

      for (this.clear(); ++t < r;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }

    l.prototype.clear = n, l.prototype.delete = a, l.prototype.get = o, l.prototype.has = i, l.prototype.set = u, e.exports = l;
  }, function (e, t, r) {
    var n = r(34),
        a = r(33);

    e.exports = function (e, t, r) {
      (void 0 !== r && !a(e[t], r) || void 0 === r && !(t in e)) && n(e, t, r);
    };
  }, function (e, t) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (r = window);
    }

    e.exports = r;
  }, function (e, t, r) {
    var n = r(55)(Object.getPrototypeOf, Object);
    e.exports = n;
  }, function (e, t) {
    e.exports = function (e, t) {
      return function (r) {
        return e(t(r));
      };
    };
  }, function (e, t, r) {
    var n = r(57),
        a = r(27);

    e.exports = function (e) {
      if (!a(e)) return !1;
      var t = n(e);
      return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
    };
  }, function (e, t) {
    var r = Object.prototype.toString;

    e.exports = function (e) {
      return r.call(e);
    };
  }, function (e, t) {
    e.exports = function () {
      return !1;
    };
  }, function (e, t) {
    e.exports = function () {
      return !1;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = [];
      if (null != e) for (var r in Object(e)) {
        t.push(r);
      }
      return t;
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = n(r(25)),
        o = n(r(1)),
        i = r(5),
        u = n(r(22));

    function l() {
      var e = (0, a.default)(["\n  margin: 48px 0 24px 0;\n  padding: 0 16px;\n  text-align: center;\n  display: block;\n  ::before,\n  ::after {\n    box-sizing: border-box;\n  }\n"]);
      return l = function l() {
        return e;
      }, e;
    }

    function c() {
      var e = (0, a.default)(["\n  padding: 32px 0 24px 0px;\n  flex: 1 1;\n"]);
      return c = function c() {
        return e;
      }, e;
    }

    function s() {
      var e = (0, a.default)(["\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: auto;\n"]);
      return s = function s() {
        return e;
      }, e;
    }

    r(117);

    var f = i.Layout.Header,
        d = i.Layout.Content,
        p = i.Layout.Footer,
        m = (0, u.default)(i.Layout)(s()),
        h = (0, u.default)(d)(c()),
        v = (0, u.default)(p)(l()),
        g = function g(e) {
      var t = [];
      return t.push(o.default.createElement(f, {
        key: "header"
      }, "Some Nice Header")), t.push(o.default.createElement(h, {
        key: "content"
      }, e.children)), t.push(o.default.createElement(v, {
        key: "footer"
      }, "Some Nice Footer")), o.default.createElement(m, {
        className: "layout"
      }, t);
    };

    t.default = g;
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = a(r(7)),
        i = a(r(10)),
        u = a(r(12)),
        l = a(r(13)),
        c = a(r(17)),
        s = a(r(14)),
        f = a(r(2)),
        d = a(r(25)),
        p = n(r(1)),
        m = (a(r(3)), a(r(62)), r(5)),
        h = r(8),
        v = a(r(50));
    r(119);
    var g = a(r(22)),
        y = (r(18), a(r(64))),
        b = (a(r(30)), r(15), r(6)),
        O = a(r(31));

    function P() {
      var e = (0, d.default)(["\n  // margin-top: 64px;\n  // padding: 0 50px;\n"]);
      return P = function P() {
        return e;
      }, e;
    }

    function w() {
      var e = (0, d.default)(["\n  // margin-top: 64px;\n  // padding: 0 50px;\n"]);
      return w = function w() {
        return e;
      }, e;
    }

    function x() {
      var e = (0, d.default)(["\n  // margin-top: 64px;\n  // padding: 0 50px;\n"]);
      return x = function x() {
        return e;
      }, e;
    }

    function j() {
      var e = (0, d.default)(["\n  // margin-top: 64px;\n  // padding: 0 50px;\n  font-size: 20px;\n  font-weight: bold;\n  padding: 20px 30px 0;\n"]);
      return j = function j() {
        return e;
      }, e;
    }

    function E() {
      var e = (0, d.default)(["\n  // margin-top: 64px;\n  // padding: 0 50px;\n"]);
      return E = function E() {
        return e;
      }, e;
    }

    function k() {
      var e = (0, d.default)(["\n  min-height: 100vh;\n  // padding-left: 80px;\n"]);
      return k = function k() {
        return e;
      }, e;
    }

    function S() {
      var e = (0, d.default)(["\n  // flex: 0 0 256px;\n  // max-width: 256px;\n  // min-width: 256px;\n  // width: 256px;\n"]);
      return S = function S() {
        return e;
      }, e;
    }

    function C() {
      var e = (0, d.default)(['\n  // margin-left: 200;\n  // background: "#fff";\n  // padding: 0;\n  // position: fixed;\n  // width: 100%;\n']);
      return C = function C() {
        return e;
      }, e;
    }

    var M = m.Layout.Header,
        _ = m.Layout.Sider,
        A = m.Layout.Content,
        N = (0, g.default)(M)(C()),
        T = ((0, g.default)(_)(S()), (0, g.default)(m.Layout)(k())),
        F = (0, g.default)(A)(E()),
        R = (g.default.div(j()), g.default.div(x()), g.default.div(w()), g.default.div(P()), {
      preHeader: {
        show: !1,
        component: null
      },
      header: {
        siderToggleIcon: {
          show: !1
        },
        language: {
          show: !0
        },
        userDropdown: {
          display: "name",
          show: !0
        }
      },
      sider: {
        logo: {
          expanded: null,
          collapsed: null
        },
        collapsed: !1,
        className: "appLeftSider",
        menuOptions: {
          theme: "light"
        },
        footer: {
          config: {},
          component: null
        }
      }
    }),
        I = function (e) {
      function t(e) {
        var r;
        (0, o.default)(this, t), r = (0, u.default)(this, (0, l.default)(t).call(this, e)), (0, f.default)((0, c.default)(r), "onBreakpoint", function () {}), (0, f.default)((0, c.default)(r), "toggle", function () {
          r.setState({
            collapsed: !r.state.collapsed
          });
        });
        var n = "function" == typeof e.config ? e.config(e) : e.config;
        return r.state = {
          collapsed: n.sider.collapsed,
          collapsedWidth: 80
        }, r;
      }

      return (0, s.default)(t, e), (0, i.default)(t, [{
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              r = t.currentUser,
              n = t.permission;
          this.props.intl;
          var a = "function" == typeof this.props.config ? this.props.config(this.props) : this.props.config,
              o = (0, v.default)({}, R, a),
              i = null,
              u = null,
              l = o.header.topNavbarDropdown || null,
              c = a.preHeader.component || null;
          o.header.extraItems && (i = o.header.extraItems), o.header.extraItemsLeft && (u = o.header.extraItemsLeft);
          var s = this.state.collapsed ? o.sider.logo.collapsed : o.sider.logo.expanded,
              f = (p.default.createElement(m.List, {
            grid: {
              gutter: 16,
              xs: 1,
              sm: 2,
              md: 4,
              lg: 4,
              xl: 6,
              xxl: 3
            },
            dataSource: this.props.listData,
            renderItem: function renderItem(e) {
              return p.default.createElement("div", null);
            }
          }), o.header.extraMenuItems || []),
              d = p.default.createElement(m.Menu, null, f.map(function (t, r) {
            return p.default.createElement(m.Menu.Item, {
              key: t.key || "topNavbarMenuItemKey-".concat(r),
              onClick: function onClick() {
                "function" == typeof t.path ? t.path(e.props) : t.path && e.props.history.push(t.path);
              }
            }, t.content);
          }), p.default.createElement(m.Menu.Item, {
            key: "topNavbarLogout",
            onClick: function onClick() {
              return e.props.logout();
            }
          }, p.default.createElement(h.LogoutOutlined, null), " ", p.default.createElement(O.default, {
            id: "CommonText.logout",
            defaultMessage: "Logout"
          }))),
              g = {
            options: o.sider.menuOptions
          },
              P = y.default;
          return this.props.locales, p.default.createElement(m.Layout, null, o.preHeader.show && c && p.default.createElement(c, {
            currentUser: r,
            permission: n
          }), p.default.createElement(m.Layout, {
            id: "app-layout"
          }, p.default.createElement(_, {
            trigger: null,
            collapsible: !0,
            className: o.sider.className,
            collapsed: this.state.collapsed,
            breakpoint: "lg",
            collapsedWidth: this.state.collapsedWidth,
            onBreakpoint: function onBreakpoint(t) {
              t ? e.setState({
                collapsedWidth: 0
              }) : e.setState({
                collapsedWidth: 80
              });
            },
            onCollapse: function onCollapse(e, t) {}
          }, p.default.createElement("div", {
            className: "logo"
          }, s), p.default.createElement(P, Object.assign({
            collapsed: this.state.collapsed,
            items: this.props.menu
          }, g)), p.default.createElement("div", {
            className: "side-menu-footer"
          }, o.sider.footer.component)), p.default.createElement(T, null, p.default.createElement(N, {
            style: {
              background: "#fff",
              padding: 0,
              display: "flex",
              justifyContent: "space-between",
              paddingRight: 24
            }
          }, p.default.createElement("div", {
            className: "header-items-left-container"
          }, p.default.createElement(a.header.siderToggleIcon.show ? this.state.collapsed ? h.MenuUnfoldOutlined : h.MenuFoldOutlined : function (e) {
            return p.default.createElement("span", null);
          }, {
            className: "trigger",
            onClick: this.toggle
          }), u ? p.default.createElement("span", {
            className: "extra-header-items-left-wrapper"
          }, p.default.createElement(u, {
            currentUser: r,
            permission: n
          })) : null), p.default.createElement(m.Space, null, i && p.default.createElement(i, {
            currentUser: r,
            permission: n
          }), o.header.language.show && this.props.locales.length > 1 && p.default.createElement(m.Select, {
            key: "lang",
            options: this.props.locales,
            defaultValue: this.props.currentLocale,
            onChange: this.props.changeLanguage,
            style: {
              width: 100
            }
          }), l ? p.default.createElement(l, this.props) : p.default.createElement(m.Dropdown, {
            trigger: [b.dropDownTrigger],
            overlay: d
          }, p.default.createElement("a", {
            style: {
              textDecoration: "none"
            }
          }, p.default.createElement(m.Space, null, r.first_name || r.name || r.full_name, !r.profile_picture && p.default.createElement(m.Avatar, {
            style: {
              color: "#f56a00",
              backgroundColor: "#fde3cf"
            }
          }, r.first_name.substr(0, 1).toUpperCase())))))), p.default.createElement(F, {
            style: {
              padding: 24,
              background: "#fff",
              minHeight: 280
            }
          }, this.props.children))));
        }
      }]), t;
    }(p.Component);

    I.propTypes = {}, I.defaultProps = {
      menuOptions: {},
      config: {
        header: {
          siderToggleIcon: {
            show: !1
          },
          language: {
            show: !0
          },
          userDropdown: {
            display: "name",
            show: !0
          }
        },
        sider: {
          logo: {
            expanded: null,
            collapsed: null
          },
          collapsed: !1,
          className: "appLeftSider",
          menuOptions: {
            theme: "light"
          }
        }
      }
    };
    var D = I;
    t.default = D;
  }, function (e, t, r) {
    "use strict";

    var n = r(0),
        a = r(4);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = n(r(7)),
        i = n(r(10)),
        u = n(r(12)),
        l = n(r(13)),
        c = n(r(17)),
        s = n(r(14)),
        f = n(r(2)),
        d = a(r(1)),
        p = r(9),
        m = r(5),
        h = r(8),
        v = r(15),
        g = r(6),
        y = m.Menu.SubMenu,
        b = function b(e) {
      return e || d.default.createElement(h.SettingOutlined, null);
    },
        O = function O(e) {
      var t = [];

      if (-1 !== e.indexOf(".")) {
        t = [];

        for (var r, n = e.split("."), a = 0; a < n.length - 1; a++) {
          var o = n[a];
          r && (o = "".concat(r, ".").concat(o)), r = o, t.push(o);
        }
      }

      return t;
    },
        P = {
      current: ["1"],
      collapsed: !0
    },
        w = function w(e) {
      var t = e.options,
          r = e.items,
          n = (0, p.useRouteMatch)(),
          a = (n.path, n.url, (0, p.useLocation)()),
          o = "",
          i = "",
          u = function e(t) {
        for (var r = t.menuItems, n = t.keyPrefix, u = [], l = 0; l < r.length; l++) {
          var c = r[l],
              s = void 0,
              f = n ? "".concat(n, ".").concat(l + 1) : "".concat(l + 1);

          if (c.isSubMenu) {
            var h;
            h = e({
              menuItems: c.children,
              keyPrefix: f
            }), s = d.default.createElement(y, {
              key: f,
              title: d.default.createElement("span", null, b(c.icon), d.default.createElement("span", null, c.title))
            }, h);
          } else {
            var v = "".concat(l + 1),
                g = n ? "".concat(n, ".").concat(l + 1) : "".concat(l + 1);
            n && (v = "".concat(n, ".").concat(v));
            var O = !1;
            (void 0 === c.addToMenu || c.addToMenu) && (O = !0), a.pathname.match("^" + c.url) && (o = g, i = n), O && (s = d.default.createElement(m.Menu.Item, {
              key: g
            }, d.default.createElement(p.NavLink, {
              to: c.url,
              key: c.title
            }, b(c.icon), d.default.createElement("span", null, c.title))));
          }

          s && u.push(s);
        }

        return u;
      }({
        menuItems: r,
        keyPrefix: ""
      });

      if ("" === o) {
        var l = (0, g.getFirstRoute)(r);
        if (l) return d.default.createElement(p.Redirect, {
          to: l
        });
      }

      return d.default.createElement(m.Menu, Object.assign({
        theme: "dark",
        mode: "inline"
      }, t, {
        defaultSelectedKeys: [o],
        defaultOpenKeys: [i]
      }), u);
    };

    d.Component;
    w.defaultProps = {
      collapsed: !0,
      options: {}
    };
    var x = (0, v.injectIntl)(w);
    t.default = x;
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.MrFormComponent = void 0;
    var o = a(r(16)),
        i = a(r(32)),
        u = a(r(131)),
        l = a(r(40)),
        c = a(r(2)),
        s = n(r(1)),
        f = a(r(3)),
        d = r(9),
        p = r(11),
        m = a(r(41)),
        h = r(134),
        v = a(r(42)),
        g = r(68),
        y = r(6),
        b = (r(26), a(r(39))),
        O = r(31);

    function P(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function w(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? P(Object(r), !0).forEach(function (t) {
          (0, c.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : P(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var x = h.Steps.Step,
        j = {
      debounce: 400,
      showMessage: !1,
      shouldAutoSave: !1,
      hideMessage: !0,
      hideMessageTimeout: 4e3,
      validateAllFieldsTouched: !0,
      loadingMsg: "Saving...",
      successMsg: "Saved at ",
      errorMsg: "Not saved."
    },
        E = {
      msg: "",
      status: ""
    },
        k = function k(e) {
      var t = e.handleOk,
          r = e.handleCancel,
          n = e.handleCancelCallback,
          a = e.isModal,
          c = e.callbacks,
          f = e.visible,
          P = e.displayName,
          k = e.loading,
          S = e.item,
          C = e.resourceName,
          M = e.resourceForm;
      (0, u.default)(e.formProps);

      var _,
          A = (0, s.useState)(!1),
          N = (0, i.default)(A, 2),
          T = N[0],
          F = N[1],
          R = (0, O.useTranslate)();

      (0, s.useEffect)(function () {
        return function () {
          F(!1), _ && clearTimeout(_);
        };
      }, []);
      var I = M.config || {
        displayName: P
      },
          D = I.processInitialValues || null,
          L = I.submitConfig || {},
          U = I.disablePrompt || !1,
          B = (e.formConfig, {
        title: {
          show: !0,
          value: I.displayName || P
        },
        actions: {
          submitText: R("CommonText.submit", {}, {
            defaultMsg: "Submit"
          }),
          submitEnabled: !0,
          nextText: "Next",
          showCancelBtn: !1,
          showSubmitBtn: !0,
          showSavedMsg: !1,
          previousText: "Previous",
          autoSave: !1,
          autoSaveConfig: w({}, j, {
            loadingMsg: R("CommonText.saving", {}, {
              defaultMsg: "Saving..."
            })
          })
        },
        steps: {},
        modal: {
          okText: "Submit"
        },
        formLayout: {
          labelCol: {
            span: 2
          },
          labelAlign: "right",
          layout: "vertical",
          size: "middle",
          wrapperCol: {
            span: 22
          }
        }
      }),
          V = (0, p.merge)({}, B, e.formConfig || {}),
          W = V.title.show ? V.title.value : null,
          q = {},
          z = V.actions,
          H = V.steps,
          $ = V.modal,
          K = V.formLayout,
          G = e.mainProps || {},
          Q = z.autoSaveConfig,
          J = {
        mainProps: G
      };
      "vertical" === K.layout && (K.labelCol = {}, K.wrapperCol = {});
      var Y = "".concat(C, "_mrform_"),
          X = S || {};
      D && (X = D(X));

      var Z,
          ee = (0, s.useState)({
        currentStep: 1,
        values: w({}, X)
      }),
          te = (0, i.default)(ee, 2),
          re = te[0],
          ne = te[1],
          ae = (0, s.useState)(j),
          oe = (0, i.default)(ae, 2),
          ie = oe[0],
          ue = oe[1],
          le = (0, s.useState)(null),
          ce = (0, i.default)(le, 2),
          se = (ce[0], ce[1]),
          fe = function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = (0, O.mrTranslate)(t.intl),
            n = e.form,
            a = (e.name, w({}, t, {
          mrIntl: r
        }));
        return "function" == typeof n ? n(a) : e.form;
      }(w({}, M), w({
        setFormState: ne,
        formState: re,
        mainProps: G
      }, e.formProps)),
          de = [],
          pe = [],
          me = (pe = Array.isArray(fe.schema) ? fe.schema : [fe.schema]).length,
          he = function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
          reset: !1
        };
        Q.shouldAutoSave && (_ && clearTimeout(_), r.reset || !t ? ue(w({}, E)) : (Q.hideMessage && setTimeout(function () {
          ue(w({}, E));
        }, Q.hideMessageTimeout), "loading" === t.status && (_ = setTimeout(function () {
          e({
            status: "error",
            errorMsg: "Autosave Failed:: Saving took more than 4 seconds"
          });
        }, 4e3)), ue(w({}, ie, {}, t))));
      },
          ve = function ve() {
        ne(w({}, re, {
          currentStep: re.currentStep - 1
        })), he(null);
      },
          ge = function ge(e) {
        return ye({
          values: e
        });
      },
          ye = function ye(e) {
        return (0, p.mergeWith)({}, re.values, e.values, y.mergeFunction);
      },
          be = function be(r, n) {
        var a,
            i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            u = n,
            l = w({}, L);

        if (i.fromAutoSave ? (he({
          status: "loading",
          msg: Q.loadingMsg
        }), F(!1), a = u = ge(n), l.success = {
          showMessage: Q.showMessage
        }, delete l.redirectTo) : a = ye(u), l.successCallback = function (e) {
          var t,
              r,
              n,
              a,
              u,
              l,
              c = (null == e || null === (t = e.data) || void 0 === t || null === (r = t[C]) || void 0 === r || null === (n = r.data) || void 0 === n || null === (a = n.attributes) || void 0 === a ? void 0 : a.updated_at) || (null == e || null === (u = e.data) || void 0 === u || null === (l = u[C]) || void 0 === l ? void 0 : l.updated_at) || L.getSavedAt && L.getSavedAt(e) || new Date();
          L.getSavedAtMsg, L.getSavedAtMsg && (0, o.default)("function" === L.getSavedAtMsg) ? (c = L.getSavedAtMsg(e), se(c)) : c && (c = (0, b.default)(c).format("DD-MM-YY, HH:mm:ss"), se(c)), i.fromAutoSave && he({
            status: "success",
            msg: "".concat(Q.successMsg)
          }), L.successCallback && L.successCallback(e, {});
        }, l.errorCallback = function (e) {
          i.fromAutoSave && he({
            status: "error",
            msg: Q.errorMsg
          }), L.errorCallback && L.errorCallback(e);
        }, fe.processFormData && "function" == typeof fe.processFormData) {
          var c = fe.processFormData(e, {
            name: r,
            formFinishProps: u,
            formState: re,
            values: a
          });
          t && t(c, l);
        } else t && t(a, l);
      },
          Oe = (0, s.useCallback)((0, m.default)(be, Q.debounce), []),
          Pe = (0, s.useCallback)((0, m.default)(function (e, t) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            n = {},
            a = Q.validateAllFieldsTouched ? t : e,
            o = r.formInstance;
        o && (n = o.getFieldsValue());
        var i = !0,
            u = !1;
        if (re.values.id || (i = !1), i) for (var s = 0; s < a.length; s++) {
          var f = a[s];

          if (!u && f.touched && (u = !0), f.errors.length > 0) {
            i = !1;
            break;
          }
        }
        if (!i) return !1;
        if (!u) return !1;
        Q.shouldAutoSave && "function" == typeof Q.shouldAutoSave && ((0, l.default)("autoSaveConfig"), Q = Q.shouldAutoSave(e, n, {})), r.formInstance, T || Q.shouldAutoSave || F(!0), name, re.values;
        var d = w({}, n);
        c && c.onValuesChange && c.onValuesChange(name, d), Q.shouldAutoSave, Q.shouldAutoSave && Oe(name, d, {
          fromAutoSave: !0
        });
      }, Q.debounce), []),
          we = pe.map(function (e, t) {
        var r = {};
        return (0, g.setInitialValues)(e, null, r, X, {
          mainProps: G
        }), X.id, {
          name: "".concat(C, "_").concat(t + 1),
          formInitialValues: r,
          formSchema: e
        };
      });

      Z = re.currentStep === pe.length ? s.default.createElement(s.default.Fragment, null, s.default.createElement(h.Space, null, re.currentStep > 1 && s.default.createElement(h.Button, {
        onClick: ve
      }, "Previous"), z.showSubmitBtn ? a ? s.default.createElement(h.Button, {
        type: "primary",
        onClick: function onClick() {
          return de[re.currentStep - 1].submit();
        }
      }, z.submitText) : s.default.createElement(h.Button, {
        htmlType: "submit",
        loading: k,
        disabled: !z.submitEnabled,
        type: "primary"
      }, z.submitText) : null, z.showCancelBtn && s.default.createElement(h.Button, {
        onClick: function onClick() {
          return r({
            callback: n
          });
        }
      }, R("CommonText.cancel", {}, {
        defaultMsg: "Cancel"
      })))) : s.default.createElement(s.default.Fragment, null, re.currentStep > 1 && s.default.createElement(h.Button, {
        onClick: ve
      }, z.previousText || "Previous"), a ? s.default.createElement(h.Button, {
        type: "primary",
        onClick: function onClick() {
          return de[re.currentStep - 1].submit();
        }
      }, z.nextText) : s.default.createElement(h.Button, {
        htmlType: "submit",
        type: "primary"
      }, z.nextText));
      var xe = null;
      pe.length > 1 && (xe = s.default.createElement(s.default.Fragment, null, s.default.createElement(h.Steps, Object.assign({
        current: re.currentStep - 1,
        className: "".concat(Y, "_steps")
      }, H, {
        style: {
          marginBottom: "15px"
        }
      }), we.map(function (e, t) {
        e.name, e.formInitialValues;
        var r = e.formSchema;
        return s.default.createElement(x, {
          title: r.title,
          description: r.description,
          subTitle: r.subTitle
        });
      }))));
      var je = we.map(function (e, t) {
        var r = e.name,
            n = e.formInitialValues,
            o = e.formSchema,
            u = h.Form.useForm(),
            l = (0, i.default)(u, 1)[0];
        de.push(l);
        var c = {};
        return re.values.id && (c.onFieldsChange = function (e, t) {
          return Pe(e, t, {
            formInstance: l
          });
        }), re.currentStep === t + 1 && s.default.createElement(h.Form, Object.assign({
          name: r,
          form: l,
          key: r,
          initialValues: n
        }, K, c), s.default.createElement(h.Row, {
          gutter: 24
        }, s.default.createElement(v.default, {
          formObj: w({}, fe, {
            schema: o
          }),
          propertyKey: null,
          sourceValues: X,
          formInstance: l,
          options: J
        })), s.default.createElement(h.Form.Item, Object.assign({
          label: "",
          colon: !1
        }, q), s.default.createElement("div", {
          className: "auto-save-state"
        }, z.showSavedMsg && (k ? s.default.createElement("div", {
          className: "loading auto-save-message "
        }, Q.loadingMsg) : ie.msg && s.default.createElement("div", {
          className: "last-saved-at auto-save-message ".concat(ie.status)
        }, s.default.createElement("span", {
          className: "prefix"
        }, ie.msg)))), !a && Z));
      }),
          Ee = a ? s.default.createElement(h.Modal, Object.assign({
        key: "".concat(e.resourceName, "_modal_form1"),
        visible: f,
        title: W,
        onCancel: r
      }, $, {
        footer: Z
      }), xe, je) : s.default.createElement(s.default.Fragment, null, xe, s.default.createElement(h.Row, null, je)),
          ke = s.default.createElement(s.default.Fragment, null, s.default.createElement(h.Form.Provider, {
        onFormFinish: function onFormFinish(e, t) {
          var r;
          e === "".concat(C, "_").concat(me) ? (F(!1), be(e, t)) : (r = t.values, ne(w({}, re, {
            values: (0, p.mergeWith)({}, re.values, r, y.mergeFunction),
            currentStep: re.currentStep + 1
          })), he(null));
        }
      }, Ee));
      return s.default.createElement("div", {
        className: "".concat(C, "_mrform_wrapper")
      }, !U && s.default.createElement(d.Prompt, {
        when: T,
        message: function message(e, t) {
          return "Are you sure you want to leave the current page?";
        }
      }), ke);
    };

    t.MrFormComponent = k, k.defaultProps = {
      item: {}
    }, k.propTypes = {
      resourceForm: f.default.shape({
        form: f.default.shape({
          schema: f.default.object
        }).isRequired
      }).isRequired,
      item: f.default.object,
      resourceName: f.default.string,
      formConfig: f.default.shape({
        layout: f.default.object,
        actions: f.default.object,
        steps: f.default.object,
        modal: f.default.object,
        title: f.default.object
      }),
      formProps: f.default.object
    };
    var S = k;
    t.default = S;
  }, function (e, t, r) {
    var n = r(67);
    e.exports = function (e, t) {
      if (e) {
        if ("string" == typeof e) return n(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
      }
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }

      return n;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.setInitialValues = t.getFinalValue = void 0;
    var a = n(r(16)),
        o = n(r(2)),
        i = r(11),
        u = n(r(141)),
        l = r(142);

    function c(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function s(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? c(Object(r), !0).forEach(function (t) {
          (0, o.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var f = function f(e, t) {
      return t && e ? l.CONSTANTS.RANGE_PICKER_GROUP.includes(e) && Array.isArray(t) ? t.map(function (e) {
        return "string" == typeof e ? (0, u.default)(e) : e;
      }) : l.CONSTANTS.DATE_PICKER_GROUP.includes(e) && "string" == typeof t ? (0, u.default)(t) : t : t;
    };

    t.getFinalValue = f;

    t.setInitialValues = function e() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          r = arguments.length > 1 ? arguments[1] : void 0,
          n = arguments.length > 2 ? arguments[2] : void 0,
          o = arguments.length > 3 ? arguments[3] : void 0,
          u = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {},
          c = s({}, t);
      if (t.hasOwnProperty("schema") && (c = t.schema), c.hasOwnProperty("type") && (0, a.default)("string" === c.type)) switch (c.type) {
        case "object":
          e(c.properties, r, n, o, u);
      } else for (var d in c) {
        var p = c[d],
            m = r ? "".concat(r, ".").concat(d) : d;
        if ("object" === p.type) e(p, m, n, o, u);else {
          var h = (0, i.get)(o, m, void 0),
              v = p.default;
          "function" == typeof v && (v = v({
            sourceValues: o,
            finalKey: m,
            options: u
          }));
          var g = h || v;
          l.CONSTANTS.DATE_PICKER_GROUP.includes(p.widget);
          var y = f(p.widget, g);
          _.set(n, m, y), o.id && (p.default = g);
        }
      }
    };
  }, function (e, t) {
    function r(e, t, r, n, a, o, i) {
      try {
        var u = e[o](i),
            l = u.value;
      } catch (e) {
        return void r(e);
      }

      u.done ? t(l) : Promise.resolve(l).then(n, a);
    }

    e.exports = function (e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (a, o) {
          var i = e.apply(t, n);

          function u(e) {
            r(i, a, o, u, l, "next", e);
          }

          function l(e) {
            r(i, a, o, u, l, "throw", e);
          }

          u(void 0);
        });
      };
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(149),
        a = Object.prototype.hasOwnProperty,
        o = Array.prototype.splice,
        i = Object.prototype.toString;

    function u(e) {
      return i.call(e).slice(8, -1);
    }

    var l = Object.assign || function (e, t) {
      return c(t).forEach(function (r) {
        a.call(t, r) && (e[r] = t[r]);
      }), e;
    },
        c = "function" == typeof Object.getOwnPropertySymbols ? function (e) {
      return Object.keys(e).concat(Object.getOwnPropertySymbols(e));
    } : function (e) {
      return Object.keys(e);
    };

    function s(e) {
      return Array.isArray(e) ? l(e.constructor(e.length), e) : "Map" === u(e) ? new Map(e) : "Set" === u(e) ? new Set(e) : e && "object" == typeof e ? l(Object.create(Object.getPrototypeOf(e)), e) : e;
    }

    var f = function () {
      function e() {
        this.commands = l({}, d), this.update = this.update.bind(this), this.update.extend = this.extend = this.extend.bind(this), this.update.isEquals = function (e, t) {
          return e === t;
        }, this.update.newContext = function () {
          return new e().update;
        };
      }

      return Object.defineProperty(e.prototype, "isEquals", {
        get: function get() {
          return this.update.isEquals;
        },
        set: function set(e) {
          this.update.isEquals = e;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.extend = function (e, t) {
        this.commands[e] = t;
      }, e.prototype.update = function (e, t) {
        var r = this,
            o = "function" == typeof t ? {
          $apply: t
        } : t;
        Array.isArray(e) && Array.isArray(o) || n(!Array.isArray(o), "update(): You provided an invalid spec to update(). The spec may not contain an array except as the value of $set, $push, $unshift, $splice or any custom command allowing an array value."), n("object" == typeof o && null !== o, "update(): You provided an invalid spec to update(). The spec and every included key path must be plain objects containing one of the following commands: %s.", Object.keys(this.commands).join(", "));
        var i = e;
        return c(o).forEach(function (t) {
          if (a.call(r.commands, t)) {
            var n = e === i;
            i = r.commands[t](o[t], i, o, e), n && r.isEquals(i, e) && (i = e);
          } else {
            var l = "Map" === u(e) ? r.update(e.get(t), o[t]) : r.update(e[t], o[t]),
                c = "Map" === u(i) ? i.get(t) : i[t];
            r.isEquals(l, c) && (void 0 !== l || a.call(e, t)) || (i === e && (i = s(e)), "Map" === u(i) ? i.set(t, l) : i[t] = l);
          }
        }), i;
      }, e;
    }();

    t.Context = f;
    var d = {
      $push: function $push(e, t, r) {
        return m(t, r, "$push"), e.length ? t.concat(e) : t;
      },
      $unshift: function $unshift(e, t, r) {
        return m(t, r, "$unshift"), e.length ? e.concat(t) : t;
      },
      $splice: function $splice(e, t, r, a) {
        return function (e, t) {
          n(Array.isArray(e), "Expected $splice target to be an array; got %s", e), v(t.$splice);
        }(t, r), e.forEach(function (e) {
          v(e), t === a && e.length && (t = s(a)), o.apply(t, e);
        }), t;
      },
      $set: function $set(e, t, r) {
        return function (e) {
          n(1 === Object.keys(e).length, "Cannot have more than one key in an object with $set");
        }(r), e;
      },
      $toggle: function $toggle(e, t) {
        h(e, "$toggle");
        var r = e.length ? s(t) : t;
        return e.forEach(function (e) {
          r[e] = !t[e];
        }), r;
      },
      $unset: function $unset(e, t, r, n) {
        return h(e, "$unset"), e.forEach(function (e) {
          Object.hasOwnProperty.call(t, e) && (t === n && (t = s(n)), delete t[e]);
        }), t;
      },
      $add: function $add(e, t, r, n) {
        return g(t, "$add"), h(e, "$add"), "Map" === u(t) ? e.forEach(function (e) {
          var r = e[0],
              a = e[1];
          t === n && t.get(r) !== a && (t = s(n)), t.set(r, a);
        }) : e.forEach(function (e) {
          t !== n || t.has(e) || (t = s(n)), t.add(e);
        }), t;
      },
      $remove: function $remove(e, t, r, n) {
        return g(t, "$remove"), h(e, "$remove"), e.forEach(function (e) {
          t === n && t.has(e) && (t = s(n)), t.delete(e);
        }), t;
      },
      $merge: function $merge(e, t, r, a) {
        var o, i;
        return o = t, n((i = e) && "object" == typeof i, "update(): $merge expects a spec of type 'object'; got %s", i), n(o && "object" == typeof o, "update(): $merge expects a target of type 'object'; got %s", o), c(e).forEach(function (r) {
          e[r] !== t[r] && (t === a && (t = s(a)), t[r] = e[r]);
        }), t;
      },
      $apply: function $apply(e, t) {
        var r;
        return n("function" == typeof (r = e), "update(): expected spec of $apply to be a function; got %s.", r), e(t);
      }
    },
        p = new f();

    function m(e, t, r) {
      n(Array.isArray(e), "update(): expected target of %s to be an array; got %s.", r, e), h(t[r], r);
    }

    function h(e, t) {
      n(Array.isArray(e), "update(): expected spec of %s to be an array; got %s. Did you forget to wrap your parameter in an array?", t, e);
    }

    function v(e) {
      n(Array.isArray(e), "update(): expected spec of $splice to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?", e);
    }

    function g(e, t) {
      var r = u(e);
      n("Map" === r || "Set" === r, "update(): %s expects a target of type Set or Map; got %s", t, r);
    }

    t.isEquals = p.update.isEquals, t.extend = p.extend, t.default = p.update, t.default.default = e.exports = l(t.default, t);
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.usePrevious = void 0;
    var o = a(r(2)),
        i = a(r(32)),
        u = a(r(23)),
        l = a(r(3)),
        c = n(r(1)),
        s = r(5),
        f = r(18),
        d = a(r(41)),
        p = r(11),
        m = a(r(21));

    function h(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function v(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? h(Object(r), !0).forEach(function (t) {
          (0, o.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : h(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    s.Select.Option;

    var g = {
      isJsx: !1,
      searchApi: !1,
      initialSearchApiParams: {},
      params: {},
      clearValueOnParamsChange: !0,
      forceReload: !1,
      debounceTime: 400,
      widgetConfig: {},
      loader: m.default
    },
        y = function y(e) {
      var t = (0, c.useRef)();
      return (0, c.useEffect)(function () {
        t.current = e;
      }), t.current;
    };

    t.usePrevious = y;

    var b = function b(e) {
      var t = e.actions,
          r = e.resourceName,
          n = e.apiResourceName || r;
      e.searchKeys;
      return function (a) {
        var l = a.value,
            h = (a.onChange, a.config, (0, u.default)(a, ["config"])),
            b = (0, c.useState)(l),
            O = (0, i.default)(b, 2),
            P = O[0],
            w = O[1],
            x = e.config || {},
            j = a.config || {},
            E = j.callback,
            k = (0, p.merge)({}, g, x, j),
            S = y(l);
        (0, c.useEffect)(function () {
          (0, p.isEqual)(l, S) ? !S && !Array.isArray(S) && (0, p.isEqual)(l, S) : (0, p.isEqual)(l, P) || w(l);
        }, [l, S, P]);
        var C = k.processData,
            M = !0,
            _ = k.widgetConfig.options;
        _ && (M = !1);
        var A = [];
        A = M ? (0, f.useSelector)(function (e) {
          return e.request.get(r, []);
        }) : "function" == typeof _ ? (0, f.useSelector)(_) : _;
        var N = (0, c.useState)(k.params),
            T = (0, i.default)(N, 2),
            F = (T[0], T[1], (0, f.useSelector)(function (e) {
          return e.request.getIn(["".concat(r, "loading")], !1);
        })),
            R = (0, f.useDispatch)(),
            I = y(k.params),
            D = (0, c.useCallback)((0, d.default)(function (e) {
          L({
            search: e
          });
        }, k.debounceTime), []);
        A && C && (A = C(A, a));

        var L = function L() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          M && R(t[r]({
            params: v({}, k.params, {}, e)
          }, {
            resourceName: r,
            apiResourceName: n,
            url: k.url,
            successCallback: function successCallback(e) {
              E && E(e);
            }
          }));
        };

        (0, c.useEffect)(function () {
          if (!(0, p.isEqual)(I, k.params) && (k.searchApi || L(), k.clearValueOnParamsChange)) {
            var e = null;
            S && (Array.isArray(S) && (e = []), a.onChange(e));
          }
        }, [I]), (0, c.useEffect)(function () {
          var e = !1,
              t = {};

          if (k.searchApi, A.length && 0 !== A.length && !k.forceReload || k.searchApi || (e = !0), A.length, k.forceReload, k.searchApi, k.searchApi) {
            var r = !1;
            e = !1;
            var n = k.initialSearchApiKeyName || "by_ids";
            if (A.length && 0 !== A.length || (r = !0), Array.isArray(P) && 0 !== P.length) if (r) t = (0, o.default)({}, n, P);else for (var a = function a(r) {
              var a = P[r];
              if (!A.find(function (e) {
                return e.value == a;
              })) return e = !0, t = (0, o.default)({}, n, P), "break";
            }, i = 0; i < P.length; i++) {
              if ("break" === a(i)) break;
            }
            if (!Array.isArray(P) && null != P) if (r) t = (0, o.default)({}, n, [P]);else A.find(function (e) {
              return e.value == P;
            }) || (e = !0, t = (0, o.default)({}, n, [P]));
            A.length && 0 !== A.length || (Array.isArray(P) && 0 !== P.length && (e = !0, t = (0, o.default)({}, n, P)), !Array.isArray(P) && P && (t = (0, o.default)({}, n, [P])));
          }

          e && L(t);
        }, []);
        var U = v({}, k.widgetConfig, {
          onBlur: function onBlur() {
            k.searchApi && R(t["".concat(r, "Success")]({
              data: (0, o.default)({}, r, [])
            }));
          },
          loading: F,
          onChange: a.onChange
        }, h, {
          value: P
        });

        if (k.isJsx || (U.options = A), k.searchApi) {
          U.onSearch = D;
          var B = k.loader || m.default;
          U.notFoundContent = F ? c.default.createElement(B, null) : null;
        }

        var V = k.widget || s.Select,
            W = null;
        return W = k.isJsx ? c.default.createElement(V, U, A) : c.default.createElement(V, U), c.default.createElement(c.default.Fragment, null, W);
      };
    };

    b.propTypes = {
      url: l.default.string.isRequired,
      resourceName: l.default.string.isRequired,
      apiResourceName: l.default.string,
      config: l.default.shape({
        params: l.default.object,
        searchApi: l.default.bool,
        isJsx: l.default.bool,
        widgetConfig: l.default.shape({
          options: l.default.any
        })
      })
    };
    var O = b;
    t.default = O;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = n(r(1)),
        o = r(5);
    r(165);

    var i = r(8),
        u = function u(e) {
      return a.default.createElement(a.default.Fragment, null, a.default.createElement(o.Col, {
        span: 24,
        className: "mrf-page-header"
      }, a.default.createElement(o.Row, null, a.default.createElement(o.Row, null, a.default.createElement(o.Space, null, a.default.createElement("span", {
        className: "page-header-back-btn",
        onClick: function onClick() {
          return e.onBack();
        }
      }, a.default.createElement(i.ArrowLeftOutlined, null)), a.default.createElement("h2", null, e.title))), a.default.createElement(o.Col, {
        span: 24,
        className: "mrf-page-header-children"
      }, e.children))));
    },
        l = function l(e) {
      var t = e.pageHeaderConfig;
      return a.default.createElement(a.default.Fragment, null, a.default.createElement(u, t, e.children));
    };

    l.defaultProps = {};
    var c = l;
    t.default = c;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = n(r(1)),
        o = (n(r(3)), r(15), function (e) {
      var t = e.renderForm,
          r = (e.currentUser, e.permission, e.selectorProps, e.forms, e.handleOk, e.handleCancel, e.newItem, e.loading, e.displayName, e.showFormVal, e.resourceName),
          n = (e.singleResourceName, e.resource),
          o = [],
          i = {
        isModal: e.isModal || !1,
        visible: e.visible || !0,
        submitConfig: {
          redirectTo: "back"
        }
      };
      return o.push(t({
        name: r,
        resource: n,
        config: i
      })), a.default.createElement(a.default.Fragment, null, o);
    });
    o.defaultProps = {}, o.propTypes = {};
    var i = o;
    t.default = i;
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = a(r(23)),
        i = a(r(7)),
        u = a(r(12)),
        l = a(r(13)),
        c = a(r(17)),
        s = a(r(14)),
        f = a(r(2)),
        d = n(r(1)),
        p = (a(r(3)), r(6)),
        m = a(r(28));

    function h(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function v(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? h(Object(r), !0).forEach(function (t) {
          (0, f.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : h(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var g = function g(e, t) {
      var r = e.resourceName,
          n = e.singleResourceName,
          a = e.displayName,
          h = (e.filter, e.listItem, e.actions, e.params, e.actionNames, e.firstTimeFetchParams, e.resourceUrl, e.forms),
          g = (e.layout, e.pagination, e.totalPages, e.formProps, e.listHeader, e.tabs, e.selectorsObj);
      return function (e) {
        function t() {
          var e, s;
          (0, i.default)(this, t);

          for (var y = arguments.length, b = new Array(y), O = 0; O < y; O++) {
            b[O] = arguments[O];
          }

          return s = (0, u.default)(this, (e = (0, l.default)(t)).call.apply(e, [this].concat(b))), (0, f.default)((0, c.default)(s), "switchTab", function (e) {
            s.setState({
              currentTab: e
            });
          }), (0, f.default)((0, c.default)(s), "edited", function (e) {
            s.showForm(e);
          }), (0, f.default)((0, c.default)(s), "goBack", function () {
            s.props.history.goBack();
          }), (0, f.default)((0, c.default)(s), "deleted", function (e) {
            var t = {};
            s.props.onDelete((0, f.default)({
              id: e.id
            }, n, {
              id: e.id,
              archived: !0
            }), t);
          }), (0, f.default)((0, c.default)(s), "updateResource", function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              redirectTo: null
            };
            s.handleOk(e, t);
          }), (0, f.default)((0, c.default)(s), "handleOk", function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              redirectTo: "back"
            },
                r = {},
                a = "Create";
            e.id && null !== e.id ? (a = "Update", r = (0, f.default)({
              id: e.id
            }, n, v({
              id: e.id
            }, e))) : r = (0, f.default)({}, n, v({}, e)), s.props.createUpdateParams && (r[n] = v({}, s.props.createUpdateParams, {}, r[n])), s.props.parentId && s.props.parentName && (r[n]["".concat(s.props.parentName, "_id")] = s.props.parentId);
            t.redirectTo;
            var i = (0, o.default)(t, ["redirectTo"]);
            t.redirectTo && (i.successCallback = s.goBack()), t.hideForm && s.hideForm(), s.props["on".concat(a)](r, i);
          }), (0, f.default)((0, c.default)(s), "handleCancel", function (e) {
            s.hideForm();
          }), (0, f.default)((0, c.default)(s), "selectorProps", function () {
            return (0, p.returnSelectorProps)(g, s.props);
          }), (0, f.default)((0, c.default)(s), "renderForm", function (e) {
            var t = e.name,
                n = e.config,
                o = e.resource,
                i = n || {},
                u = h.find(function (e) {
              return e.name === t;
            });

            if (u) {
              var l = s.props,
                  c = l.currentUser,
                  f = l.permission,
                  p = l.loading,
                  g = s.state.showForm,
                  y = o || s.state.item;
              u.config = i;
              var b = {
                forms: [v({}, u)],
                selectorProps: s.selectorProps(),
                currentUser: c,
                permission: f,
                handleOk: s.handleOk,
                handleCancel: s.handleCancel,
                newItem: y,
                item: y,
                loading: p,
                displayName: a,
                showFormVal: g,
                resourceName: r,
                edited: s.edited
              };
              return d.default.createElement(m.default, Object.assign({
                key: t
              }, b));
            }
          }), (0, f.default)((0, c.default)(s), "showForm", function (e) {
            var t = {
              showForm: e.name
            };
            t.item = e.item || {}, s.setState(t);
          }), (0, f.default)((0, c.default)(s), "hideForm", function () {
            s.setState({
              showForm: ""
            });
          }), (0, f.default)((0, c.default)(s), "setParams", function (e) {
            var t = s.props,
                r = t.location,
                n = t.history;
            s.setState({
              params: v({}, s.state.params, {}, e)
            }, function () {
              (0, p.setQueryParams)({
                history: n,
                location: r,
                url: r.pathname,
                params: s.state.params
              }), s.props.onFetch({
                params: s.state.params
              });
            });
          }), s;
        }

        return (0, s.default)(t, e), t;
      }(t);
    };

    t.default = g;
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "MrCrudView", {
      enumerable: !0,
      get: function get() {
        return o.default;
      }
    }), Object.defineProperty(t, "MrApp", {
      enumerable: !0,
      get: function get() {
        return i.default;
      }
    }), Object.defineProperty(t, "MrTabView", {
      enumerable: !0,
      get: function get() {
        return u.default;
      }
    }), Object.defineProperty(t, "MrConnectField", {
      enumerable: !0,
      get: function get() {
        return l.default;
      }
    }), Object.defineProperty(t, "MrReduxCrud", {
      enumerable: !0,
      get: function get() {
        return c.default;
      }
    }), Object.defineProperty(t, "MrFilter", {
      enumerable: !0,
      get: function get() {
        return s.default;
      }
    }), Object.defineProperty(t, "MrShowView", {
      enumerable: !0,
      get: function get() {
        return f.default;
      }
    }), Object.defineProperty(t, "MrFormComponent", {
      enumerable: !0,
      get: function get() {
        return d.MrFormComponent;
      }
    }), Object.defineProperty(t, "MrFormRenderHelper", {
      enumerable: !0,
      get: function get() {
        return p.default;
      }
    }), Object.defineProperty(t, "FormRenderer", {
      enumerable: !0,
      get: function get() {
        return m.default;
      }
    }), Object.defineProperty(t, "MrInput", {
      enumerable: !0,
      get: function get() {
        return h.default;
      }
    }), Object.defineProperty(t, "MrSelect", {
      enumerable: !0,
      get: function get() {
        return v.default;
      }
    }), Object.defineProperty(t, "MrTreeSelect", {
      enumerable: !0,
      get: function get() {
        return g.default;
      }
    }), Object.defineProperty(t, "Spinner", {
      enumerable: !0,
      get: function get() {
        return y.default;
      }
    }), Object.defineProperty(t, "MrHelperMethods", {
      enumerable: !0,
      get: function get() {
        return b.default;
      }
    }), Object.defineProperty(t, "MrAxiosInstanceMethodBuilder", {
      enumerable: !0,
      get: function get() {
        return b.MrAxiosInstanceMethodBuilder;
      }
    }), Object.defineProperty(t, "formatJsonApiData", {
      enumerable: !0,
      get: function get() {
        return b.formatJsonApiData;
      }
    }), Object.defineProperty(t, "returnSelectorProps", {
      enumerable: !0,
      get: function get() {
        return b.returnSelectorProps;
      }
    }), t.default = void 0;
    var o = a(r(49)),
        i = a(r(183)),
        u = a(r(191)),
        l = a(r(192)),
        c = a(r(193)),
        s = a(r(47)),
        f = a(r(196)),
        d = r(65),
        p = a(r(28)),
        m = a(r(42)),
        h = a(r(30)),
        v = a(r(71)),
        g = a(r(198)),
        y = a(r(21)),
        b = n(r(6)),
        O = {
      MrInput: h.default,
      MrCrudView: o.default,
      MrApp: i.default,
      MrConnectField: l.default,
      MrReduxCrud: c.default,
      MrAxiosInstanceMethodBuilder: b.MrAxiosInstanceMethodBuilder,
      formatJsonApiData: b.formatJsonApiData,
      MrFilter: s.default,
      MrShowView: f.default,
      MrHelperMethods: b.default,
      returnSelectorProps: b.returnSelectorProps,
      MrTabView: u.default,
      MrFormComponent: d.MrFormComponent,
      MrFormRenderHelper: p.default,
      FormRenderer: m.default,
      MrSelect: v.default,
      MrTreeSelect: g.default,
      Spinner: y.default
    };
    t.default = O;
  }, function (e, t) {
    e.exports = function (e, t) {
      if (null == e) return {};
      var r,
          n,
          a = {},
          o = Object.keys(e);

      for (n = 0; n < o.length; n++) {
        r = o[n], t.indexOf(r) >= 0 || (a[r] = e[r]);
      }

      return a;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    function r(t, n) {
      return e.exports = r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, r(t, n);
    }

    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    "use strict";

    var n = r(79);

    function a() {}

    function o() {}

    o.resetWarningCache = a, e.exports = function () {
      function e(e, t, r, a, o, i) {
        if (i !== n) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var r = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: o,
        resetWarningCache: a
      };
      return r.PropTypes = r, r;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, r) {
    var n = r(51),
        a = r(52),
        o = r(88),
        i = r(90),
        u = r(27),
        l = r(61),
        c = r(60);

    e.exports = function e(t, r, s, f, d) {
      t !== r && o(r, function (o, l) {
        if (d || (d = new n()), u(o)) i(t, r, l, s, e, f, d);else {
          var p = f ? f(c(t, l), o, l + "", t, r, d) : void 0;
          void 0 === p && (p = o), a(t, l, p);
        }
      }, l);
    };
  }, function (e, t) {
    e.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (e, t, r) {
    var n = r(29),
        a = Array.prototype.splice;

    e.exports = function (e) {
      var t = this.__data__,
          r = n(t, e);
      return !(r < 0) && (r == t.length - 1 ? t.pop() : a.call(t, r, 1), --this.size, !0);
    };
  }, function (e, t, r) {
    var n = r(29);

    e.exports = function (e) {
      var t = this.__data__,
          r = n(t, e);
      return r < 0 ? void 0 : t[r][1];
    };
  }, function (e, t, r) {
    var n = r(29);

    e.exports = function (e) {
      return n(this.__data__, e) > -1;
    };
  }, function (e, t, r) {
    var n = r(29);

    e.exports = function (e, t) {
      var r = this.__data__,
          a = n(r, e);
      return a < 0 ? (++this.size, r.push([e, t])) : r[a][1] = t, this;
    };
  }, function (e, t, r) {
    var n = r(87),
        a = function () {
      try {
        var e = n(Object, "defineProperty");
        return e({}, "", {}), e;
      } catch (e) {}
    }();

    e.exports = a;
  }, function (e, t) {
    e.exports = function (e, t) {
      return null == e ? void 0 : e[t];
    };
  }, function (e, t, r) {
    var n = r(89)();
    e.exports = n;
  }, function (e, t) {
    e.exports = function (e) {
      return function (t, r, n) {
        for (var a = -1, o = Object(t), i = n(t), u = i.length; u--;) {
          var l = i[e ? u : ++a];
          if (!1 === r(o[l], l, o)) break;
        }

        return t;
      };
    };
  }, function (e, t, r) {
    var n = r(52),
        a = r(91),
        o = r(94),
        i = r(97),
        u = r(98),
        l = r(101),
        c = r(36),
        s = r(102),
        f = r(58),
        d = r(56),
        p = r(27),
        m = r(105),
        h = r(59),
        v = r(60),
        g = r(106);

    e.exports = function (e, t, r, y, b, O, P) {
      var w = v(e, r),
          x = v(t, r),
          j = P.get(x);
      if (j) n(e, r, j);else {
        var E = O ? O(w, x, r + "", e, t, P) : void 0,
            k = void 0 === E;

        if (k) {
          var S = c(x),
              C = !S && f(x),
              M = !S && !C && h(x);
          E = x, S || C || M ? c(w) ? E = w : s(w) ? E = i(w) : C ? (k = !1, E = a(x, !0)) : M ? (k = !1, E = o(x, !0)) : E = [] : m(x) || l(x) ? (E = w, l(w) ? E = g(w) : p(w) && !d(w) || (E = u(x))) : k = !1;
        }

        k && (P.set(x, E), b(E, x, y, O, P), P.delete(x)), n(e, r, E);
      }
    };
  }, function (e, t, r) {
    (function (e) {
      var n = r(35),
          a = t && !t.nodeType && t,
          o = a && "object" == typeof e && e && !e.nodeType && e,
          i = o && o.exports === a ? n.Buffer : void 0,
          u = i ? i.allocUnsafe : void 0;

      e.exports = function (e, t) {
        if (t) return e.slice();
        var r = e.length,
            n = u ? u(r) : new e.constructor(r);
        return e.copy(n), n;
      };
    }).call(this, r(92)(e));
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function get() {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function get() {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t, r) {
    (function (t) {
      var r = "object" == typeof t && t && t.Object === Object && t;
      e.exports = r;
    }).call(this, r(53));
  }, function (e, t, r) {
    var n = r(95);

    e.exports = function (e, t) {
      var r = t ? n(e.buffer) : e.buffer;
      return new e.constructor(r, e.byteOffset, e.length);
    };
  }, function (e, t, r) {
    var n = r(96);

    e.exports = function (e) {
      var t = new e.constructor(e.byteLength);
      return new n(t).set(new n(e)), t;
    };
  }, function (e, t, r) {
    var n = r(35).Uint8Array;
    e.exports = n;
  }, function (e, t) {
    e.exports = function (e, t) {
      var r = -1,
          n = e.length;

      for (t || (t = Array(n)); ++r < n;) {
        t[r] = e[r];
      }

      return t;
    };
  }, function (e, t, r) {
    var n = r(99),
        a = r(54),
        o = r(100);

    e.exports = function (e) {
      return "function" != typeof e.constructor || o(e) ? {} : n(a(e));
    };
  }, function (e, t, r) {
    var n = r(27),
        a = Object.create,
        o = function () {
      function e() {}

      return function (t) {
        if (!n(t)) return {};
        if (a) return a(t);
        e.prototype = t;
        var r = new e();
        return e.prototype = void 0, r;
      };
    }();

    e.exports = o;
  }, function (e, t) {
    e.exports = function () {
      return !1;
    };
  }, function (e, t) {
    e.exports = function () {
      return !1;
    };
  }, function (e, t, r) {
    var n = r(103),
        a = r(37);

    e.exports = function (e) {
      return a(e) && n(e);
    };
  }, function (e, t, r) {
    var n = r(56),
        a = r(104);

    e.exports = function (e) {
      return null != e && a(e.length) && !n(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
    };
  }, function (e, t, r) {
    var n = r(57),
        a = r(54),
        o = r(37),
        i = Function.prototype,
        u = Object.prototype,
        l = i.toString,
        c = u.hasOwnProperty,
        s = l.call(Object);

    e.exports = function (e) {
      if (!o(e) || "[object Object]" != n(e)) return !1;
      var t = a(e);
      if (null === t) return !0;
      var r = c.call(t, "constructor") && t.constructor;
      return "function" == typeof r && r instanceof r && l.call(r) == s;
    };
  }, function (e, t, r) {
    var n = r(107),
        a = r(61);

    e.exports = function (e) {
      return n(e, a(e));
    };
  }, function (e, t, r) {
    var n = r(108),
        a = r(34);

    e.exports = function (e, t, r, o) {
      var i = !r;
      r || (r = {});

      for (var u = -1, l = t.length; ++u < l;) {
        var c = t[u],
            s = o ? o(r[c], e[c], c, r, e) : void 0;
        void 0 === s && (s = e[c]), i ? a(r, c, s) : n(r, c, s);
      }

      return r;
    };
  }, function (e, t, r) {
    var n = r(34),
        a = r(33),
        o = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, r) {
      var i = e[t];
      o.call(e, t) && a(i, r) && (void 0 !== r || t in e) || n(e, t, r);
    };
  }, function (e, t, r) {
    var n = r(110),
        a = r(115);

    e.exports = function (e) {
      return n(function (t, r) {
        var n = -1,
            o = r.length,
            i = o > 1 ? r[o - 1] : void 0,
            u = o > 2 ? r[2] : void 0;

        for (i = e.length > 3 && "function" == typeof i ? (o--, i) : void 0, u && a(r[0], r[1], u) && (i = o < 3 ? void 0 : i, o = 1), t = Object(t); ++n < o;) {
          var l = r[n];
          l && e(t, l, n, i);
        }

        return t;
      });
    };
  }, function (e, t, r) {
    var n = r(111),
        a = r(112),
        o = r(114);

    e.exports = function (e, t) {
      return o(a(e, t, n), e + "");
    };
  }, function (e, t) {
    e.exports = function (e) {
      return e;
    };
  }, function (e, t, r) {
    var n = r(113),
        a = Math.max;

    e.exports = function (e, t, r) {
      return t = a(void 0 === t ? e.length - 1 : t, 0), function () {
        for (var o = arguments, i = -1, u = a(o.length - t, 0), l = Array(u); ++i < u;) {
          l[i] = o[t + i];
        }

        i = -1;

        for (var c = Array(t + 1); ++i < t;) {
          c[i] = o[i];
        }

        return c[t] = r(l), n(e, this, c);
      };
    };
  }, function (e, t) {
    e.exports = function (e, t, r) {
      switch (r.length) {
        case 0:
          return e.call(t);

        case 1:
          return e.call(t, r[0]);

        case 2:
          return e.call(t, r[0], r[1]);

        case 3:
          return e.call(t, r[0], r[1], r[2]);
      }

      return e.apply(t, r);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return e;
    };
  }, function (e, t) {
    e.exports = function () {
      return !1;
    };
  }, function (e, t, r) {
    (function (t) {
      var r = /^\s+|\s+$/g,
          n = /^[-+]0x[0-9a-f]+$/i,
          a = /^0b[01]+$/i,
          o = /^0o[0-7]+$/i,
          i = parseInt,
          u = "object" == typeof t && t && t.Object === Object && t,
          l = "object" == typeof self && self && self.Object === Object && self,
          c = u || l || Function("return this")(),
          s = Object.prototype.toString,
          f = Math.max,
          d = Math.min,
          p = function p() {
        return c.Date.now();
      };

      function m(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
      }

      function h(e) {
        if ("number" == typeof e) return e;
        if (function (e) {
          return "symbol" == typeof e || function (e) {
            return !!e && "object" == typeof e;
          }(e) && "[object Symbol]" == s.call(e);
        }(e)) return NaN;

        if (m(e)) {
          var t = "function" == typeof e.valueOf ? e.valueOf() : e;
          e = m(t) ? t + "" : t;
        }

        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(r, "");
        var u = a.test(e);
        return u || o.test(e) ? i(e.slice(2), u ? 2 : 8) : n.test(e) ? NaN : +e;
      }

      e.exports = function (e, t, r) {
        var n,
            a,
            o,
            i,
            u,
            l,
            c = 0,
            s = !1,
            v = !1,
            g = !0;
        if ("function" != typeof e) throw new TypeError("Expected a function");

        function y(t) {
          var r = n,
              o = a;
          return n = a = void 0, c = t, i = e.apply(o, r);
        }

        function b(e) {
          return c = e, u = setTimeout(P, t), s ? y(e) : i;
        }

        function O(e) {
          var r = e - l;
          return void 0 === l || r >= t || r < 0 || v && e - c >= o;
        }

        function P() {
          var e = p();
          if (O(e)) return w(e);
          u = setTimeout(P, function (e) {
            var r = t - (e - l);
            return v ? d(r, o - (e - c)) : r;
          }(e));
        }

        function w(e) {
          return u = void 0, g && n ? y(e) : (n = a = void 0, i);
        }

        function x() {
          var e = p(),
              r = O(e);

          if (n = arguments, a = this, l = e, r) {
            if (void 0 === u) return b(l);
            if (v) return u = setTimeout(P, t), y(l);
          }

          return void 0 === u && (u = setTimeout(P, t)), i;
        }

        return t = h(t) || 0, m(r) && (s = !!r.leading, o = (v = "maxWait" in r) ? f(h(r.maxWait) || 0, t) : o, g = "trailing" in r ? !!r.trailing : g), x.cancel = function () {
          void 0 !== u && clearTimeout(u), c = 0, n = l = a = u = void 0;
        }, x.flush = function () {
          return void 0 === u ? i : w(p());
        }, x;
      };
    }).call(this, r(53));
  }, function (e, t, r) {
    var n = r(19),
        a = r(118);
    "string" == typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    },
        i = (n(a, o), a.locals ? a.locals : {});
    e.exports = i;
  }, function (e, t, r) {
    (t = r(20)(!1)).push([e.i, "", ""]), e.exports = t;
  }, function (e, t, r) {
    var n = r(19),
        a = r(120);
    "string" == typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    },
        i = (n(a, o), a.locals ? a.locals : {});
    e.exports = i;
  }, function (e, t, r) {
    (t = r(20)(!1)).push([e.i, "#app-layout .trigger{height:64px;padding:22px 24px;font-size:20px;cursor:pointer;transition:all 0.3s, padding 0s}#app-layout .trigger:hover{color:#1890ff}#app-layout .logo{height:32px;background:rgba(255,255,255,0.2);margin:16px}\n", ""]), e.exports = t;
  }, function (e, t) {
    var r,
        n,
        a = e.exports = {};

    function o() {
      throw new Error("setTimeout has not been defined");
    }

    function i() {
      throw new Error("clearTimeout has not been defined");
    }

    function u(e) {
      if (r === setTimeout) return setTimeout(e, 0);
      if ((r === o || !r) && setTimeout) return r = setTimeout, setTimeout(e, 0);

      try {
        return r(e, 0);
      } catch (t) {
        try {
          return r.call(null, e, 0);
        } catch (t) {
          return r.call(this, e, 0);
        }
      }
    }

    !function () {
      try {
        r = "function" == typeof setTimeout ? setTimeout : o;
      } catch (e) {
        r = o;
      }

      try {
        n = "function" == typeof clearTimeout ? clearTimeout : i;
      } catch (e) {
        n = i;
      }
    }();
    var l,
        c = [],
        s = !1,
        f = -1;

    function d() {
      s && l && (s = !1, l.length ? c = l.concat(c) : f = -1, c.length && p());
    }

    function p() {
      if (!s) {
        var e = u(d);
        s = !0;

        for (var t = c.length; t;) {
          for (l = c, c = []; ++f < t;) {
            l && l[f].run();
          }

          f = -1, t = c.length;
        }

        l = null, s = !1, function (e) {
          if (n === clearTimeout) return clearTimeout(e);
          if ((n === i || !n) && clearTimeout) return n = clearTimeout, clearTimeout(e);

          try {
            n(e);
          } catch (t) {
            try {
              return n.call(null, e);
            } catch (t) {
              return n.call(this, e);
            }
          }
        }(e);
      }
    }

    function m(e, t) {
      this.fun = e, this.array = t;
    }

    function h() {}

    a.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
        t[r - 1] = arguments[r];
      }
      c.push(new m(e, t)), 1 !== c.length || s || u(p);
    }, m.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, a.title = "browser", a.browser = !0, a.env = {}, a.argv = [], a.version = "", a.versions = {}, a.on = h, a.addListener = h, a.once = h, a.off = h, a.removeListener = h, a.removeAllListeners = h, a.emit = h, a.prependListener = h, a.prependOnceListener = h, a.listeners = function (e) {
      return [];
    }, a.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, a.cwd = function () {
      return "/";
    }, a.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, a.umask = function () {
      return 0;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e) {
      return encodeURIComponent(e).replace(/[!'()*]/g, function (e) {
        return "%" + e.charCodeAt(0).toString(16).toUpperCase();
      });
    };
  }, function (e, t, r) {
    "use strict";

    var n = new RegExp("%[a-f0-9]{2}", "gi"),
        a = new RegExp("(%[a-f0-9]{2})+", "gi");

    function o(e, t) {
      try {
        return decodeURIComponent(e.join(""));
      } catch (e) {}

      if (1 === e.length) return e;
      t = t || 1;
      var r = e.slice(0, t),
          n = e.slice(t);
      return Array.prototype.concat.call([], o(r), o(n));
    }

    function i(e) {
      try {
        return decodeURIComponent(e);
      } catch (a) {
        for (var t = e.match(n), r = 1; r < t.length; r++) {
          t = (e = o(t, r).join("")).match(n);
        }

        return e;
      }
    }

    e.exports = function (e) {
      if ("string" != typeof e) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");

      try {
        return e = e.replace(/\+/g, " "), decodeURIComponent(e);
      } catch (t) {
        return function (e) {
          for (var t = {
            "%FE%FF": "��",
            "%FF%FE": "��"
          }, r = a.exec(e); r;) {
            try {
              t[r[0]] = decodeURIComponent(r[0]);
            } catch (e) {
              var n = i(r[0]);
              n !== r[0] && (t[r[0]] = n);
            }

            r = a.exec(e);
          }

          t["%C2"] = "�";

          for (var o = Object.keys(t), u = 0; u < o.length; u++) {
            var l = o[u];
            e = e.replace(new RegExp(l, "g"), t[l]);
          }

          return e;
        }(e);
      }
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t) {
      if ("string" != typeof e || "string" != typeof t) throw new TypeError("Expected the arguments to be of type `string`");
      if ("" === t) return [e];
      var r = e.indexOf(t);
      return -1 === r ? [e] : [e.slice(0, r), e.slice(r + t.length)];
    };
  }, function (e, t) {
    e.exports = s;
  }, function (e, t, r) {
    var n = r(19),
        a = r(127);
    "string" == typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    },
        i = (n(a, o), a.locals ? a.locals : {});
    e.exports = i;
  }, function (e, t, r) {
    (t = r(20)(!1)).push([e.i, ".Input{width:100%;padding:10px;box-sizing:border-box}.Label{font-weight:bold;display:block;margin-bottom:8px}.InputElement{outline:none;border:1px solid #ccc;background-color:white;font:inherit;padding:6px 10px;display:block;box-sizing:border-box}.InputElement:focus{outline:none;background-color:#ccc}.Invalid{border:1px solid red;background-color:#fda49a}.Error{color:red}\n", ""]), e.exports = t;
  }, function (e, t) {
    e.exports = function (e) {
      if (Array.isArray(e)) return e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e, t) {
      var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

      if (null != r) {
        var n,
            a,
            o = [],
            i = !0,
            u = !1;

        try {
          for (r = r.call(e); !(i = (n = r.next()).done) && (o.push(n.value), !t || o.length !== t); i = !0) {
            ;
          }
        } catch (e) {
          u = !0, a = e;
        } finally {
          try {
            i || null == r.return || r.return();
          } finally {
            if (u) throw a;
          }
        }

        return o;
      }
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e) {
      if (null == e) throw new TypeError("Cannot destructure undefined");
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    var n = r(35);

    e.exports = function () {
      return n.Date.now();
    };
  }, function (e, t) {
    e.exports = function (e) {
      return e;
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(5);
    Object.keys(n).forEach(function (e) {
      "default" !== e && "__esModule" !== e && Object.defineProperty(t, e, {
        enumerable: !0,
        get: function get() {
          return n[e];
        }
      });
    });
  }, function (e, t, r) {
    var n = r(67);
    e.exports = function (e) {
      if (Array.isArray(e)) return n(e);
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e) {
      if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.getFormItemName = void 0;
    var o = a(r(16)),
        i = a(r(2)),
        u = n(r(1)),
        l = (a(r(3)), a(r(139))),
        c = a(r(146)),
        s = r(42),
        f = r(5),
        d = r(11),
        p = r(6);

    function m(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function h(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? m(Object(r), !0).forEach(function (t) {
          (0, i.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : m(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var v = function v(e) {
      return Array.isArray(e) ? e : e && e.fileList;
    },
        g = function () {
      var e = {};

      for (var t in l.default) {
        if (l.default.hasOwnProperty(t)) {
          var r = l.default[t];
          e[t] = (0, c.default)({
            component: r,
            name: t
          });
        }
      }

      return e;
    }();

    for (var y in l.default) {
      if (l.default.hasOwnProperty(y)) {
        var b = l.default[y];
        g[y] = (0, c.default)({
          component: b,
          name: y
        });
      }
    }

    var O = function O(e) {
      return e ? Array.isArray(e) ? e : e.split(".").map(function (e) {
        return ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"].includes(e) ? parseInt(e) : e;
      }) : [];
    };

    t.getFormItemName = O;

    var P = function P(e) {
      e.type;
      var t = e.name,
          r = e.config,
          n = e.sourceValues,
          a = e.formInstance,
          i = e.options || {};
      e.formInstance;
      var l = e.options || {},
          c = (s.ObjectField, r.widget || "InputWidget"),
          m = r.rules,
          y = c && "string" == typeof c ? function (e) {
        var t = e.name;
        return g.hasOwnProperty(t) ? g[t] : g.InputWidget;
      }({
        name: c
      }) : c,
          b = r.title,
          P = r.widget,
          w = r.widgetConfig || {};

      for (var x in w) {
        if (w.hasOwnProperty(x)) {
          var j = w[x];
          "function" == typeof j && (w[x] = j(e));
        }
      }

      var E = r.formItemConfig || {},
          k = (r.type, r.default ? r.default : r.type, r.className || ""),
          S = r.wrapClassName || "",
          C = r.span || 24,
          M = r.offset || 0,
          _ = O(t),
          A = _[_.length - 1],
          N = r.label || b,
          T = r.placeholder || N;

      r.fieldConfig;

      if (t.includes("itemArrayItem1"), r.field) {
        if ("function" == typeof r.field) {
          var F = r.field;
          return u.default.createElement(F, {
            sourceValues: n
          });
        }

        return r.field;
      }

      var R = h({
        className: k
      }, E);
      ["UploadWidget"].includes(P) && (R = h({}, R, {
        valuePropName: "fileList",
        getValueFromEvent: v
      })), r.valuePropName && (R.valuePropName = r.valuePropName), r.validateTrigger && (R.validateTrigger = r.validateTrigger), r.dependencies && (R.dependencies = r.dependencies);
      var I,
          D = null;
      _[0];

      if (I = (0, p.isFunction)(r.dependsOn) ? r.dependsOn(e) : r.dependsOn, (0, o.default)(r.dependsOn), r.shouldUpdate, (0, p.isFunction)(r.dependsOn), I || r.shouldUpdate) {
        var L,
            U = r.shouldUpdate ? r.shouldUpdate : function (t, n) {
          var a = !1;
          return Array.isArray(I) ? I.forEach(function (e) {
            a || (a = (0, d.get)(t, e) !== (0, d.get)(n, e));
          }) : (0, p.isFunction)(r.dependsOn) && (a = r.dependsOn(h({}, e, {
            prevValues: t,
            curValues: n
          }))), !0;
        },
            B = r.children;
        r.setInitialValue && (R.initialValue = (0, d.get)(n, t));
        var V = {};
        "CustomField_".concat(t);
        l.arrayItemProps && (V = h({}, l.arrayItemProps), {
          fieldKey: [V.fieldKey, A]
        }, _ = [V.name, A]), (0, p.isFunction)(r.dependsOn), (0, p.isFunction)(r.dependsOn) ? I ? L = function L(e) {} : D = function D(e) {
          return u.default.createElement("span", null, "hello");
        } : L = function L(e) {
          return u.default.createElement(f.Row, {
            gutter: 24
          }, u.default.createElement(B, Object.assign({}, e, {
            sourceValues: n,
            formInstance: a,
            options: i
          })));
        }, D = u.default.createElement(f.Form.Item, Object.assign({
          key: "CustomField_".concat(t),
          noStyle: !0,
          shouldUpdate: U
        }, R), L);
      } else {
        r.setInitialValue && (R.initialValue = (0, d.get)(n, t));
        var W = {},
            q = {
          key: "CustomField_".concat(t)
        };
        l.arrayItemProps && (q = {
          fieldKey: [(W = h({}, l.arrayItemProps)).fieldKey, A]
        }, _ = [W.name, A]), D = u.default.createElement(f.Form.Item, Object.assign({}, W, {
          name: _
        }, q, {
          label: N,
          rules: m
        }, R), u.default.createElement(y, Object.assign({
          placeholder: T
        }, w, {
          formInstance: a
        })));
      }

      return r.shouldUpdate, u.default.createElement(f.Col, {
        span: C,
        offset: M,
        className: S
      }, D);
    };

    t.default = P;
  }, function (e, t, r) {
    "use strict";

    var n = r(0),
        a = r(4);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.componentMap = void 0;
    a(r(1));
    var o = r(5),
        i = n(r(140)),
        u = n(r(143)),
        l = {
      CheckboxWidget: (0, i.default)({
        component: o.Checkbox,
        name: "CheckboxWidget"
      }),
      CheckboxGroupWidget: (0, i.default)({
        component: o.Checkbox.Group,
        name: "CheckboxGroupWidget"
      }),
      TreeSelectWidget: (0, i.default)({
        component: o.TreeSelect,
        name: "TreeSelectWidget"
      }),
      PasswordWidget: (0, i.default)({
        component: o.Input.Password,
        name: "PasswordWidget"
      }),
      MentionsWidget: (0, i.default)({
        component: o.Mentions,
        name: "MentionsWidget"
      }),
      RateWidget: (0, i.default)({
        component: o.Rate,
        name: "RateWidget"
      }),
      RadioWidget: (0, i.default)({
        component: o.Radio,
        name: "RadioWidget"
      }),
      RadioGroupWidget: (0, i.default)({
        component: o.Radio.Group,
        name: "RadioGroupWidget"
      }),
      SwitchWidget: (0, i.default)({
        component: o.Switch,
        name: "SwitchWidget"
      }),
      InputWidget: (0, i.default)({
        component: o.Input,
        name: "InputWidget"
      }),
      InputNumberWidget: (0, i.default)({
        component: o.InputNumber,
        name: "InputNumberWidget"
      }),
      TransferWidget: (0, i.default)({
        component: o.Transfer,
        name: "TransferWidget"
      }),
      TimePickerWidget: (0, i.default)({
        component: o.TimePicker,
        name: "TimePickerWidget"
      }),
      UploadWidget: (0, i.default)({
        component: u.default,
        name: "UploadWidget"
      }),
      AutoCompleteWidget: (0, i.default)({
        component: o.AutoComplete,
        name: "AutoCompleteWidget"
      }),
      CascaderWidget: (0, i.default)({
        component: o.Cascader,
        name: "CascaderWidget"
      }),
      DatePickerWidget: (0, i.default)({
        component: o.DatePicker,
        name: "DatePickerWidget"
      }),
      DateRangePickerWidget: (0, i.default)({
        component: o.DatePicker.RangePicker,
        name: "DateRangePickerWidget"
      }),
      WeekPickerWidget: (0, i.default)({
        component: o.DatePicker.WeekPicker,
        name: "WeekPickerWidget"
      }),
      MonthPickerWidget: (0, i.default)({
        component: o.DatePicker.MonthPicker,
        name: "MonthPickerWidget"
      }),
      YearPickerWidget: (0, i.default)({
        component: o.DatePicker.YearPicker,
        name: "YearPickerWidget"
      }),
      TimeRangePickerWidget: (0, i.default)({
        component: o.TimePicker.RangePicker,
        name: "TimeRangePickerWidget"
      }),
      SelectWidget: (0, i.default)({
        component: o.Select,
        name: "SelectWidget"
      })
    };
    t.componentMap = l;
    var c = l;
    t.default = c;
  }, function (e, t, r) {
    "use strict";

    var n = r(0),
        a = r(4);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = a(r(1)),
        i = (n(r(3)), n(r(39)), r(68)),
        u = function u(e) {
      var t = e.component,
          r = (e.name, t);
      return function (e) {
        (0, i.getFinalValue)(e.value);
        return o.default.createElement(r, e);
      };
    };

    u.propTypes = {};
    var l = u;
    t.default = l;
  }, function (e, t) {
    e.exports = f;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.CONSTANTS = void 0;
    t.CONSTANTS = {
      DATE_PICKER_GROUP: ["DatePickerWidget", "TimePickerWidget", "WeekPickerWidget", "MonthPickerWidget", "YearPickerWidget"],
      RANGE_PICKER_GROUP: ["DateRangePickerWidget", "TimeRangePickerWidget"]
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var a = n(r(1)),
        o = (n(r(3)), r(5), n(r(144))),
        i = function i(e) {
      e.widgetConfig;
      return a.default.createElement(o.default, Object.assign({}, {}, e));
    };

    i.defaultProps = {}, i.propTypes = {};
    var u = i;
    t.default = u;
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = a(r(44)),
        i = a(r(69)),
        u = a(r(43)),
        l = a(r(7)),
        c = a(r(10)),
        s = a(r(12)),
        f = a(r(13)),
        d = a(r(17)),
        p = a(r(14)),
        m = a(r(2)),
        h = n(r(1)),
        v = (a(r(3)), r(5)),
        g = r(8);

    function y(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function b(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? y(Object(r), !0).forEach(function (t) {
          (0, m.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : y(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function O(e) {
      return new Promise(function (t, r) {
        var n = new FileReader();
        n.readAsDataURL(e), n.onload = function () {
          return t(n.result);
        }, n.onerror = function (e) {
          return r(e);
        };
      });
    }

    function P(e) {
      var t = e.uid,
          r = e.name,
          n = e.size,
          a = e.type;
      return new Promise(function (o, i) {
        var u = new window.FileReader();
        u.onerror = i, u.onload = function (e) {
          var i = function (e, t) {
            return e.replace(";base64", ";name=".concat(encodeURIComponent(t), ";base64"));
          }(e.target.result, r);

          o({
            uid: t,
            name: r,
            size: n,
            type: a,
            url: i
          });
        }, u.readAsDataURL(e);
      });
    }

    var w = function (e) {
      function t(e) {
        var r;
        (0, l.default)(this, t), r = (0, s.default)(this, (0, f.default)(t).call(this, e)), (0, m.default)((0, d.default)(r), "beforeUpload", function (e) {
          return r.setState(function (t) {
            return {
              fileList: [].concat((0, u.default)(t.fileList), [e])
            };
          }), !1;
        }), (0, m.default)((0, d.default)(r), "handleCancel", function () {
          return r.setState({
            previewVisible: !1
          });
        }), (0, m.default)((0, d.default)(r), "handlePreview", function () {
          var e = (0, i.default)(o.default.mark(function e(t) {
            var n;
            return o.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (t.url || t.preview) {
                      e.next = 4;
                      break;
                    }

                    return e.next = 3, O(t.originFileObj);

                  case 3:
                    t.preview = e.sent;

                  case 4:
                    n = {
                      imageUrl: t.url || t.preview,
                      previewVisible: !0
                    }, r.setState(n);

                  case 6:
                  case "end":
                    return e.stop();
                }
              }
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()), (0, m.default)((0, d.default)(r), "onChange", function () {
          var e = (0, i.default)(o.default.mark(function e(t) {
            var n, a, i, l, c, s, f, d, p;
            return o.default.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (n = r.props.onChange, a = !0, !1, "removed" === t.file.status && !0, a) {
                      e.next = 8;
                      break;
                    }

                    e.next = 22;
                    break;

                  case 8:
                    return l = [], {
                      data: ""
                    }, i = t.fileList, t.fileList.forEach(function (e) {
                      e.id || l.push(e.originFileObj);
                    }), e.next = 14, o = l, Promise.all([].map.call(o, P));

                  case 14:
                    c = e.sent, s = c.map(function (e) {
                      return b({}, e, {
                        uid: e.uid,
                        url: e.url,
                        filename: e.name,
                        content_type: e.type
                      });
                    }), f = (0, u.default)(r.state.initialFileList), d = 0, f.forEach(function (e) {
                      if (void 0 === r.state.fileList.find(function (t) {
                        return t.id === e.id;
                      })) {
                        var t = b({}, f[d], {
                          _destroy: !0
                        });
                        f[d] = t;
                      }

                      d += 1;
                    }), p = {
                      values: [].concat((0, u.default)(s), (0, u.default)(f)),
                      fileList: i.map(function (e) {
                        return b({}, e, {
                          uid: e.id || e.uid
                        });
                      }),
                      filesInfo: c
                    }, r.setState(p, function () {
                      n(a ? p.values : p.values[0]);
                    });

                  case 22:
                  case "end":
                    return e.stop();
                }
              }

              var o;
            }, e);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }());
        var n = (e.fileList || []).map(function (e, t) {
          var r = e || {};
          return b({}, r, {
            uid: r.id || -t
          });
        });
        return r.state = {
          fileList: n,
          initialFileList: n,
          previewVisible: !1,
          imageUrl: ""
        }, r;
      }

      return (0, p.default)(t, e), (0, c.default)(t, [{
        key: "render",
        value: function value() {
          var e = [],
              t = (this.props.listType, this.state),
              r = (t.fileList, t.previewVisible),
              n = t.imageUrl,
              a = (this.props.fileList || []).map(function (e, t) {
            var r = e || {};
            return r.uid ? e : b({}, r, {
              uid: r.id || -t
            });
          }),
              o = {
            beforeUpload: this.beforeUpload,
            fileList: a,
            onChange: this.onChange,
            onPreview: this.handlePreview,
            listType: "picture-card"
          };

          if ("picture-card" === o.listType) {
            var i = h.default.createElement(v.Modal, {
              key: "picture_card_preview_modal",
              visible: r,
              footer: null,
              onCancel: this.handleCancel
            }, h.default.createElement("img", {
              alt: "",
              style: {
                width: "100%"
              },
              src: n
            }));
            e.push(i);
          }

          return this.props.dragger ? e.push(h.default.createElement(v.Upload.Dragger, Object.assign({
            key: "uploadDragger"
          }, this.props, o), h.default.createElement("p", {
            className: "ant-upload-drag-icon"
          }, h.default.createElement(g.InboxOutlined, null)), h.default.createElement("p", {
            className: "ant-upload-text"
          }, "Click or drag file to this area to upload"), h.default.createElement("p", {
            className: "ant-upload-hint"
          }, "Support for a single or bulk upload."))) : e.push(h.default.createElement(v.Upload, Object.assign({
            key: "uploadRegular"
          }, this.props, o), this.props.fileList.length < 5 && "+ Upload")), e;
        }
      }]), t;
    }(h.Component);

    t.default = w;
  }, function (e, t, r) {
    var n = r(16).default;

    function a() {
      "use strict";

      e.exports = a = function a() {
        return t;
      }, e.exports.__esModule = !0, e.exports.default = e.exports;
      var t = {},
          r = Object.prototype,
          o = r.hasOwnProperty,
          i = "function" == typeof Symbol ? Symbol : {},
          u = i.iterator || "@@iterator",
          l = i.asyncIterator || "@@asyncIterator",
          c = i.toStringTag || "@@toStringTag";

      function s(e, t, r) {
        return Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        s({}, "");
      } catch (e) {
        s = function s(e, t, r) {
          return e[t] = r;
        };
      }

      function f(e, t, r, n) {
        var a = t && t.prototype instanceof m ? t : m,
            o = Object.create(a.prototype),
            i = new k(n || []);
        return o._invoke = function (e, t, r) {
          var n = "suspendedStart";
          return function (a, o) {
            if ("executing" === n) throw new Error("Generator is already running");

            if ("completed" === n) {
              if ("throw" === a) throw o;
              return C();
            }

            for (r.method = a, r.arg = o;;) {
              var i = r.delegate;

              if (i) {
                var u = x(i, r);

                if (u) {
                  if (u === p) continue;
                  return u;
                }
              }

              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if ("suspendedStart" === n) throw n = "completed", r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = "executing";
              var l = d(e, t, r);

              if ("normal" === l.type) {
                if (n = r.done ? "completed" : "suspendedYield", l.arg === p) continue;
                return {
                  value: l.arg,
                  done: r.done
                };
              }

              "throw" === l.type && (n = "completed", r.method = "throw", r.arg = l.arg);
            }
          };
        }(e, r, i), o;
      }

      function d(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      t.wrap = f;
      var p = {};

      function m() {}

      function h() {}

      function v() {}

      var g = {};
      s(g, u, function () {
        return this;
      });
      var y = Object.getPrototypeOf,
          b = y && y(y(S([])));
      b && b !== r && o.call(b, u) && (g = b);
      var O = v.prototype = m.prototype = Object.create(g);

      function P(e) {
        ["next", "throw", "return"].forEach(function (t) {
          s(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function w(e, t) {
        var r;

        this._invoke = function (a, i) {
          function u() {
            return new t(function (r, u) {
              !function r(a, i, u, l) {
                var c = d(e[a], e, i);

                if ("throw" !== c.type) {
                  var s = c.arg,
                      f = s.value;
                  return f && "object" == n(f) && o.call(f, "__await") ? t.resolve(f.__await).then(function (e) {
                    r("next", e, u, l);
                  }, function (e) {
                    r("throw", e, u, l);
                  }) : t.resolve(f).then(function (e) {
                    s.value = e, u(s);
                  }, function (e) {
                    return r("throw", e, u, l);
                  });
                }

                l(c.arg);
              }(a, i, r, u);
            });
          }

          return r = r ? r.then(u, u) : u();
        };
      }

      function x(e, t) {
        var r = e.iterator[t.method];

        if (void 0 === r) {
          if (t.delegate = null, "throw" === t.method) {
            if (e.iterator.return && (t.method = "return", t.arg = void 0, x(e, t), "throw" === t.method)) return p;
            t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return p;
        }

        var n = d(r, e.iterator, t.arg);
        if ("throw" === n.type) return t.method = "throw", t.arg = n.arg, t.delegate = null, p;
        var a = n.arg;
        return a ? a.done ? (t[e.resultName] = a.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, p) : a : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, p);
      }

      function j(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function E(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function k(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(j, this), this.reset(!0);
      }

      function S(e) {
        if (e) {
          var t = e[u];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;

          if (!isNaN(e.length)) {
            var r = -1,
                n = function t() {
              for (; ++r < e.length;) {
                if (o.call(e, r)) return t.value = e[r], t.done = !1, t;
              }

              return t.value = void 0, t.done = !0, t;
            };

            return n.next = n;
          }
        }

        return {
          next: C
        };
      }

      function C() {
        return {
          value: void 0,
          done: !0
        };
      }

      return h.prototype = v, s(O, "constructor", v), s(v, "constructor", h), h.displayName = s(v, c, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === h || "GeneratorFunction" === (t.displayName || t.name));
      }, t.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, v) : (e.__proto__ = v, s(e, c, "GeneratorFunction")), e.prototype = Object.create(O), e;
      }, t.awrap = function (e) {
        return {
          __await: e
        };
      }, P(w.prototype), s(w.prototype, l, function () {
        return this;
      }), t.AsyncIterator = w, t.async = function (e, r, n, a, o) {
        void 0 === o && (o = Promise);
        var i = new w(f(e, r, n, a), o);
        return t.isGeneratorFunction(r) ? i : i.next().then(function (e) {
          return e.done ? e.value : i.next();
        });
      }, P(O), s(O, c, "Generator"), s(O, u, function () {
        return this;
      }), s(O, "toString", function () {
        return "[object Generator]";
      }), t.keys = function (e) {
        var t = [];

        for (var r in e) {
          t.push(r);
        }

        return t.reverse(), function r() {
          for (; t.length;) {
            var n = t.pop();
            if (n in e) return r.value = n, r.done = !1, r;
          }

          return r.done = !0, r;
        };
      }, t.values = S, k.prototype = {
        constructor: k,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(E), !e) for (var t in this) {
            "t" === t.charAt(0) && o.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var t = this;

          function r(r, n) {
            return i.type = "throw", i.arg = e, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
          }

          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var a = this.tryEntries[n],
                i = a.completion;
            if ("root" === a.tryLoc) return r("end");

            if (a.tryLoc <= this.prev) {
              var u = o.call(a, "catchLoc"),
                  l = o.call(a, "finallyLoc");

              if (u && l) {
                if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return r(a.finallyLoc);
              } else if (u) {
                if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
              } else {
                if (!l) throw new Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return r(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var n = this.tryEntries[r];

            if (n.tryLoc <= this.prev && o.call(n, "finallyLoc") && this.prev < n.finallyLoc) {
              var a = n;
              break;
            }
          }

          a && ("break" === e || "continue" === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
          var i = a ? a.completion : {};
          return i.type = e, i.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, p) : this.complete(i);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), p;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), E(r), p;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];

            if (r.tryLoc === e) {
              var n = r.completion;

              if ("throw" === n.type) {
                var a = n.arg;
                E(r);
              }

              return a;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, t, r) {
          return this.delegate = {
            iterator: S(e),
            resultName: t,
            nextLoc: r
          }, "next" === this.method && (this.arg = void 0), p;
        }
      }, t;
    }

    e.exports = a, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    "use strict";

    var n = r(0),
        a = r(4);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = a(r(1)),
        i = (n(r(3)), function (e) {
      var t = e.component;
      return function (e) {
        return o.default.createElement(t, e);
      };
    });
    i.propTypes = {};
    var u = i;
    t.default = u;
  }, function (e, t, r) {
    var n = r(19),
        a = r(148);
    "string" == typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    },
        i = (n(a, o), a.locals ? a.locals : {});
    e.exports = i;
  }, function (e, t, r) {
    (t = r(20)(!1)).push([e.i, ".form-nested-remove-btn{position:absolute;right:0;top:10}\n", ""]), e.exports = t;
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, r, n, a, o, i, u) {
      if (!e) {
        var l;
        if (void 0 === t) l = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var c = [r, n, a, o, i, u],
              s = 0;
          (l = new Error(t.replace(/%s/g, function () {
            return c[s++];
          }))).name = "Invariant Violation";
        }
        throw l.framesToPop = 1, l;
      }
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = n(r(2)),
        o = n(r(25)),
        i = n(r(1)),
        u = r(5),
        l = r(8),
        c = n(r(22));
    r(151);
    var s = r(9);

    function f(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function d() {
      var e = (0, o.default)(["\n  // position: absolute;\n  // right: 10px;\n  // top: 10px;\n"]);
      return d = function d() {
        return e;
      }, e;
    }

    var p = u.Button.Group,
        m = (0, c.default)(p)(d()),
        h = function h(e) {
      var t,
          r = e.history,
          n = e.item,
          o = (e.formMode, e.config),
          c = (0, s.useRouteMatch)(),
          d = (c.path, c.url),
          p = n.id,
          h = [];

      if (o && o.uuid && o.uuid.active) {
        var v = "uuid";
        o.uuid.key && (v = o.uuid.key), p = n[v];
      } else p = n.id;

      return e.edit && (t = i.default.createElement(u.Button, {
        key: "editBtn",
        onClick: function onClick() {
          r.push("".concat(d, "/").concat(p, "/edit"));
        },
        icon: i.default.createElement(l.EditOutlined, null)
      })), h.push(t), e.delete && (t = i.default.createElement(u.Popconfirm, {
        key: "popConfirmDelete",
        title: "Confirm archive?",
        onConfirm: function onConfirm(t) {
          e.deleted(function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = null != arguments[t] ? arguments[t] : {};
              t % 2 ? f(Object(r), !0).forEach(function (t) {
                (0, a.default)(e, t, r[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : f(Object(r)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
              });
            }

            return e;
          }({}, n, {
            id: p
          }));
        },
        onCancel: function onCancel(e) {},
        okText: "Yes",
        cancelText: "No"
      }, i.default.createElement(u.Button, {
        key: "popConfirmDeleteBtn",
        icon: i.default.createElement(l.DeleteOutlined, null)
      })), h.push(t)), i.default.createElement(m, {
        key: "actionBtnGroup",
        className: "action-btns"
      }, h);
    };

    t.default = h;
  }, function (e, t, r) {
    var n = r(19),
        a = r(152);
    "string" == typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    },
        i = (n(a, o), a.locals ? a.locals : {});
    e.exports = i;
  }, function (e, t, r) {
    (t = r(20)(!1)).push([e.i, "", ""]), e.exports = t;
  }, function (e, t, r) {
    var n = r(19),
        a = r(154);
    "string" == typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    },
        i = (n(a, o), a.locals ? a.locals : {});
    e.exports = i;
  }, function (e, t, r) {
    (t = r(20)(!1)).push([e.i, ".main-loader{display:flex;justify-content:center;align-items:center;padding:100px 50px;height:100%}.lds-ring{display:inline-block;position:relative;width:60px;height:60px}.lds-ring div{box-sizing:border-box;display:block;position:absolute;width:44px;height:44px;margin:6px;border:6px solid #00BCD4;border-radius:50%;animation:lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;border-color:#00BCD4 transparent transparent transparent}.lds-ring div:nth-child(1){animation-delay:-0.45s}.lds-ring div:nth-child(2){animation-delay:-0.3s}.lds-ring div:nth-child(3){animation-delay:-0.15s}@keyframes lds-ring{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}\n", ""]), e.exports = t;
  }, function (e, t) {
    e.exports = d;
  }, function (e, t, r) {
    var n = r(19),
        a = r(157);
    "string" == typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    },
        i = (n(a, o), a.locals ? a.locals : {});
    e.exports = i;
  }, function (e, t, r) {
    (t = r(20)(!1)).push([e.i, ".mainFilter{margin-bottom:20px}\n", ""]), e.exports = t;
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.withWrapperComponent = t.renderCrudListComponent = void 0;
    var o = a(r(2)),
        i = n(r(1)),
        u = (a(r(3)), r(9)),
        l = r(5),
        c = r(8);
    a(r(22));
    r(159);
    var s = r(15),
        f = (a(r(21)), a(r(28)), a(r(161)), a(r(162))),
        d = a(r(167)),
        p = a(r(168)),
        m = (a(r(169)), a(r(170))),
        h = r(47),
        v = r(6);

    function g(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function y(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? g(Object(r), !0).forEach(function (t) {
          (0, o.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : g(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    c.PlusOutlined, (0, s.defineMessages)({
      search: {
        id: "general.search",
        defaultMessage: "Search"
      }
    });

    var b = function b(e) {
      var t,
          r,
          n = e.permission,
          a = e.config,
          o = e.singleResourceName;
      return (null == n || null === (t = n[o]) || void 0 === t ? void 0 : t.create) && (r = a.list.createBtn.component ? a.list.createBtn.component : i.default.createElement(h.CreateBtn, e)), r;
    },
        O = function O(e) {
      return i.default.createElement(h.SearchFilterComponent, e);
    },
        P = function P(e) {
      var t,
          r = e.config,
          n = (e.pagination, e.onPageChange, e.hocProps);
      e.wrapperComponent;
      return n.isRoute && (null === (t = r.pagination) || void 0 === t ? void 0 : t.show) ? i.default.createElement(l.Pagination, e) : null;
    },
        w = function w(e) {
      var t = e.crudListData,
          r = e.resourceName;
      return i.default.createElement(t, Object.assign({
        key: "mainCrudList".concat(r)
      }, e));
    };

    t.renderCrudListComponent = w;

    t.withWrapperComponent = function (e) {
      return function (t) {
        if (e.wrapperComponent) {
          var r = e.wrapperComponent,
              n = e.component;
          return i.default.createElement(r, null, i.default.createElement(n, t));
        }
      };
    };

    var x = function x(e) {
      var t,
          r = e.hocProps,
          n = e.config,
          a = e.pagination,
          o = e.onPageChange,
          l = e.permission,
          c = e.singleResourceName,
          s = e.displayName,
          h = e.selectorProps,
          g = e.setParams,
          x = e.resourceName,
          j = e.history,
          E = e.params,
          k = e.filter,
          S = r.formMode,
          C = e.match.path,
          M = e.match.url;
      r.isRoute && e.isRoute;

      var _ = n.list.layout ? n.list.layout : p.default,
          A = y({
        key: "mainPagination",
        hocProps: r,
        config: n,
        onPageChange: o,
        total: null == a ? void 0 : a.totalCount,
        pageSize: null == a ? void 0 : a.pageSize,
        onChange: o,
        current: null == a ? void 0 : a.page
      }, null == n || null === (t = n.pagination) || void 0 === t ? void 0 : t.config),
          N = {
        permission: l,
        config: n,
        singleResourceName: c,
        history: j
      },
          T = y({}, E, {
        parentProps: y({}, e),
        name: s,
        singleResourceName: c
      }, h, {
        changed: v.setQueryParams,
        url: M,
        setParams: g,
        resourceName: x,
        filter: k,
        config: n.filter.config || {}
      }),
          F = {
        renderCreateBtn: b,
        renderSearchComponent: O,
        renderCrudListComponent: w,
        renderPaginationComponent: P,
        paginationProps: A,
        createBtnProps: N,
        filterProps: T
      };

      return !1 === n.routes.fetch ? i.default.createElement(u.Route, {
        path: "".concat(C),
        render: function render(t) {
          return i.default.createElement(f.default, Object.assign({}, t, e));
        }
      }) : "modal" === S ? i.default.createElement(i.default.Fragment, null, i.default.createElement(u.Switch, null, i.default.createElement(u.Route, {
        path: "".concat(C, "/:id/detail"),
        render: function render(t) {
          return i.default.createElement(f.default, Object.assign({}, t, e));
        }
      }), i.default.createElement(u.Route, {
        path: "".concat(C),
        render: function render(t) {
          return i.default.createElement(i.default.Fragment, null, i.default.createElement(u.Route, {
            path: "".concat(C, "/create"),
            render: function render(t) {
              return i.default.createElement(d.default, Object.assign({}, e, {
                visible: !0,
                isModal: !0
              }, t));
            }
          }), i.default.createElement(p.default, Object.assign({}, e, t)));
        }
      }))) : i.default.createElement(i.default.Fragment, null, i.default.createElement(u.Switch, null, n.routes.create && i.default.createElement(u.Route, {
        path: "".concat(C, "/create"),
        render: function render(t) {
          return i.default.createElement(d.default, Object.assign({}, e, t));
        }
      }), n.routes.show && i.default.createElement(u.Route, {
        path: "".concat(C, "/:id"),
        render: function render(t) {
          return i.default.createElement(f.default, Object.assign({}, e, t));
        }
      }), i.default.createElement(u.Route, {
        path: "".concat(C),
        render: function render(t) {
          return i.default.createElement(_, Object.assign({
            crudListData: m.default
          }, F, e, t));
        }
      })));
    };

    x.defaultProps = {
      isRoute: !0,
      item: {}
    };
    var j = x;
    t.default = j;
  }, function (e, t, r) {
    var n = r(19),
        a = r(160);
    "string" == typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    },
        i = (n(a, o), a.locals ? a.locals : {});
    e.exports = i;
  }, function (e, t, r) {
    (t = r(20)(!1)).push([e.i, "", ""]), e.exports = t;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var a = n(r(1)),
        o = (n(r(3)), r(9)),
        i = function i(e) {
      var t = (0, o.useRouteMatch)().path;
      return a.default.createElement(a.default.Fragment, null, a.default.createElement(o.Link, {
        to: "".concat(t, "/create")
      }, "Create "), a.default.createElement(o.Link, {
        to: "".concat(t, "/24")
      }, "Show "), a.default.createElement("span", null, "Show all"), ";");
    };

    i.defaultProps = {}, i.propTypes = {};
    var u = i;
    t.default = u;
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = a(r(2)),
        i = a(r(7)),
        u = a(r(10)),
        l = a(r(12)),
        c = a(r(13)),
        s = a(r(14)),
        f = n(r(1)),
        d = (r(6), r(18)),
        p = r(163),
        m = a(r(21)),
        h = r(9),
        v = a(r(164)),
        g = function (e) {
      function t(e) {
        var r;
        return (0, i.default)(this, t), (r = (0, l.default)(this, (0, c.default)(t).call(this, e))).state = {}, r;
      }

      return (0, s.default)(t, e), (0, u.default)(t, [{
        key: "componentDidMount",
        value: function value() {
          var e = this.props,
              t = (e.dataSource, e.selectorProps, e.parentInstance),
              r = e.match,
              n = e.singleResourceName,
              a = e.resourceName;

          if (!this.props[n].id || this.props.config.forceReloadShow) {
            var o = this.props.resourceId || r.params["".concat(a, "Id")] || r.params.id;
            t.props.onShow({
              id: o
            });
          }
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              r = (t.dataSource, t.selectorProps, t.parentInstance, t.match),
              n = t.singleResourceName,
              a = (t.location, t.formMode),
              o = this.props.showloading || !1,
              i = this.props[n],
              u = this.props.config.itemDetail.loader || m.default;
          if (o) return f.default.createElement(u, null);
          if (!i.id) return null;
          var l = this.props.config.itemDetail.widget;
          return l ? "modal" === a ? f.default.createElement(f.default.Fragment, null, f.default.createElement(h.Route, {
            path: "".concat(r.path, "/edit"),
            render: function render(t) {
              return f.default.createElement(v.default, Object.assign({}, e.props, {
                isModal: !0
              }, t));
            }
          }), f.default.createElement("span", null, "Not completed yet")) : f.default.createElement(h.Switch, null, f.default.createElement(h.Route, {
            path: "".concat(r.path, "/edit"),
            render: function render(t) {
              return f.default.createElement(v.default, Object.assign({}, e.props, t, {
                item: i,
                resource: i
              }));
            }
          }), f.default.createElement(h.Route, {
            path: "".concat(r.path),
            render: function render(t) {
              return f.default.createElement(l, Object.assign({}, e.props, t, {
                loading: o,
                item: i
              }));
            }
          })) : f.default.createElement("span", null, "config.itemDetail.widget missing");
        }
      }]), t;
    }(f.PureComponent);

    (0, p.showResourceSelector)(), (0, p.getShowLoadingSelector)();
    g.propTypes = {};
    var y = (0, d.connect)(function () {
      var e = (0, p.showResourceSelector)();
      return function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = arguments.length > 1 ? arguments[1] : void 0,
            n = (r.hocProps, r.singleResourceName);
        r.resourceName;
        return (0, o.default)({}, "".concat(n), e(t, r));
      };
    }, null)(g);
    t.default = y;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.showResourceSelector = t.getShowLoadingSelector = void 0;

    var a = n(r(2)),
        o = r(46),
        i = r(11),
        u = function u(e, t) {
      var r,
          n = t.resourceName,
          o = t.singleResourceName,
          u = t.config,
          l = !1;
      u && u.uuid && u.uuid.active && (l = !0, r = u.uuid.key || "uuid");
      var c = o + "s",
          s = e[n].get(c);
      if (0 === s.size) return {};
      var f,
          d,
          p = t.resourceId || t.match.params["".concat(n, "Id")] || t.match.params.id;
      return l ? (f = p, d = (0, i.findIndex)(s, (0, a.default)({}, r, f))) : (f = parseInt(p), d = (0, i.findIndex)(s, {
        id: f
      })), -1 !== d ? s[d] : {};
    },
        l = function l(e) {
      return function (t) {
        var r = e.resourceName;
        return t[r].get("showloading");
      };
    };

    t.getShowLoadingSelector = function () {
      return (0, o.createSelector)([l], function (e) {
        return e;
      });
    };

    t.showResourceSelector = function () {
      return (0, o.createSelector)([u], function (e) {
        return e;
      });
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var a = n(r(1)),
        o = (n(r(3)), r(9)),
        i = (r(8), n(r(72))),
        u = n(r(73)),
        l = r(26),
        c = function c(e) {
      var t = e.resourceName,
          r = e.history,
          n = e.forms,
          c = (0, o.useRouteMatch)().path,
          s = e.updateloading || !1,
          f = (c.split("/create")[0], "".concat(t)),
          d = n.find(function (e) {
        return e.name === t;
      });
      return f = "Edit ".concat(f), d && (f = (0, l.getNested)("config.title.editValue", d) || "Edit ".concat((0, l.getNested)("config.title.value", d) || t)), a.default.createElement(i.default, {
        pageHeaderConfig: {
          title: f,
          onBack: function onBack() {
            return r.goBack();
          }
        }
      }, a.default.createElement(u.default, Object.assign({}, e, {
        loading: s,
        edit: !0
      })));
    };

    c.defaultProps = {}, c.propTypes = {};
    var s = c;
    t.default = s;
  }, function (e, t, r) {
    var n = r(19),
        a = r(166);
    "string" == typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    },
        i = (n(a, o), a.locals ? a.locals : {});
    e.exports = i;
  }, function (e, t, r) {
    (t = r(20)(!1)).push([e.i, ".mrf-page-header{padding:10px 0px}.mrf-page-header .page-header-back-btn{padding:10px 5px;cursor:pointer}.mrf-page-header .mrf-page-header-children{padding:0px 10px}\n", ""]), e.exports = t;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var a = n(r(1)),
        o = (n(r(3)), r(9)),
        i = (r(8), n(r(72))),
        u = n(r(73)),
        l = r(26),
        c = function c(e) {
      var t = e.resourceName,
          r = e.history,
          n = e.visible,
          c = e.isModal,
          s = e.forms,
          f = (0, o.useRouteMatch)().path,
          d = e.createloading || !1,
          p = (f.split("/create")[0], "".concat(t)),
          m = s.find(function (e) {
        return e.name === t;
      });
      return p = "Create ".concat(p), m && (p = (0, l.getNested)("config.title.createValue", m) || "Create ".concat((0, l.getNested)("config.title.value", m) || t)), a.default.createElement(i.default, {
        pageHeaderConfig: {
          title: p,
          onBack: function onBack() {
            return r.goBack();
          }
        }
      }, a.default.createElement(u.default, Object.assign({}, e, {
        loading: d,
        visible: n,
        isModal: c
      })));
    };

    c.defaultProps = {}, c.propTypes = {};
    var s = c;
    t.default = s;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.CYButton = void 0;
    var a = n(r(2)),
        o = n(r(40)),
        i = n(r(25)),
        u = n(r(1)),
        l = (n(r(3)), r(5)),
        c = r(15),
        s = n(r(22)),
        f = r(8);
    n(r(21)), r(9);

    function d(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function p(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? d(Object(r), !0).forEach(function (t) {
          (0, a.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : d(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    function m() {
      var e = (0, i.default)(["\n  background: ", ";\n  color: ", ";\n"]);
      return m = function m() {
        return e;
      }, e;
    }

    var h = (0, s.default)(l.Button)(m(), function (e) {
      return e.theme.button.background;
    }, function (e) {
      return e.theme.main.colors.primary;
    });
    t.CYButton = h;

    var v = function v(e) {
      var t = e.resourceName,
          r = e.singleResourceName,
          n = e.filter,
          a = (e.forms, e.MrFilter),
          i = e.displayName,
          s = (e.resourceForm, e.CustomListItem, e.ActionBtns, e.params),
          d = e.setParams,
          m = e.showFormVal,
          h = (e.showForm, e.loading),
          v = e.item,
          g = (e.handleOk, e.handleCancel, e.refresh),
          y = (e.dataSource, e.pagination),
          b = e.onPageChange,
          O = (e.edited, e.deleted, e.permission),
          P = (e.currentUser, e.ListHeader),
          w = (e.resourceUrl, e.parentInstance, e.hocProps),
          x = e.selectorProps,
          j = (e.renderList, e.renderForm, e.manualFormRender, e.crudMode, e.formMode, e.config),
          E = (e.duplicateResource, e.crudListData),
          k = e.history,
          S = (e.match.path, e.match.url),
          C = E;
      w.isRoute && e.isRoute, v || ((0, o.default)("item"), v = {});
      p({}, v), O[r];
      var M = [];
      var _ = [];
      n && (_ = n(p({}, s, {}, x, {
        changed: d,
        url: S,
        setParams: d,
        resourceName: t,
        singleResourceName: r,
        parentProps: p({}, e)
      })));
      var A = p({
        parentProps: p({}, e),
        name: i,
        singleResourceName: r,
        extraFilters: _
      }, x, {
        config: j.filter.config || {}
      }),
          N = a,
          T = null;
      O && O[r] && O[r].create && (T = j.list.createBtn.component ? j.list.createBtn.component : function (e) {
        return u.default.createElement(l.Button, {
          key: "createBtn",
          type: "primary",
          onClick: function onClick() {
            return k.push("".concat(S, "/create"));
          },
          icon: u.default.createElement(f.PlusOutlined, null)
        }, u.default.createElement(c.FormattedMessage, {
          id: "CommonText.create",
          defaultMessage: "Create"
        }));
      });
      var F = j.filter.show ? u.default.createElement(l.Col, {
        span: j.filter.style.width,
        key: "filter".concat(r, "MainContainer")
      }, u.default.createElement(l.Row, null, u.default.createElement(N, Object.assign({
        key: "filter".concat(r, "Main")
      }, s, {
        changed: d,
        setParams: d,
        refresh: g,
        createBtn: T
      }, A)))) : null,
          R = j.filter.style.width < 12 ? 24 - j.filter.style.width : 24,
          I = u.default.createElement(C, Object.assign({
        key: "mainCrudList".concat(t)
      }, e)),
          D = u.default.createElement(l.Col, {
        span: R,
        key: "mainList".concat(t, "Container")
      }, u.default.createElement(l.Row, null, I, w.isRoute && j.pagination.show ? u.default.createElement(l.Col, {
        span: 24
      }, u.default.createElement(l.Row, null, u.default.createElement(l.Pagination, Object.assign({
        key: "mainPagination",
        total: y.totalCount,
        pageSize: y.pageSize,
        onChange: b,
        current: y.page
      }, j.pagination.config)))) : null));
      M.push(P), M.push(D), u.default.createElement(l.Row, {
        key: "mainRowCRUDLayout"
      }, M);
      var L = j.list.loader;
      return u.default.createElement(u.default.Fragment, null, u.default.createElement(l.Row, null, "right" !== j.filter.style.align ? F : null, h ? u.default.createElement(L, null) : M, "right" == j.filter.style.align ? F : null));
    };

    v.propTypes = {};
    var g = v;
    t.default = g;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.CYButton = void 0;
    var a = n(r(23)),
        o = n(r(25)),
        i = n(r(1)),
        u = (n(r(3)), r(5)),
        l = (r(15), n(r(22)));
    r(8), n(r(21)), r(9);

    function c() {
      var e = (0, o.default)(["\n  background: ", ";\n  color: ", ";\n"]);
      return c = function c() {
        return e;
      }, e;
    }

    var s = (0, l.default)(u.Button)(c(), function (e) {
      return e.theme.button.background;
    }, function (e) {
      return e.theme.main.colors.primary;
    });
    t.CYButton = s;

    var f = function f(e) {
      e.resourceName;
      var t = e.singleResourceName,
          r = e.filter,
          n = (e.forms, e.MrFilter, e.displayName, e.resourceForm, e.CustomListItem, e.ActionBtns, e.params, e.setParams, e.showFormVal, e.showForm, e.loading),
          o = (e.item, e.handleOk, e.handleCancel, e.refresh, e.dataSource, e.pagination, e.onPageChange, e.edited, e.deleted, e.permission),
          l = (e.currentUser, e.ListHeader, e.resourceUrl, e.parentInstance, e.hocProps, e.selectorProps, e.renderList, e.renderForm, e.manualFormRender, e.crudMode, e.formMode, e.config),
          c = (e.duplicateResource, e.crudListData, e.renderCreateBtn),
          s = e.renderSearchComponent,
          f = (e.renderFilterComponent, e.renderPaginationComponent),
          d = e.paginationProps,
          p = e.createBtnProps,
          m = e.filterProps,
          h = e.renderCrudListComponent,
          v = (0, a.default)(e, ["renderCreateBtn", "renderSearchComponent", "renderFilterComponent", "renderPaginationComponent", "paginationProps", "createBtnProps", "filterProps", "renderCrudListComponent"]),
          g = (o[t], i.default.createElement(i.default.Fragment, null, h(v), f(d), s(m), i.default.createElement(r, m))),
          y = l.list.loader;
      return i.default.createElement(i.default.Fragment, null, i.default.createElement(u.Row, null, i.default.createElement(u.Space, null, c(p)), n ? i.default.createElement(y, null) : g));
    };

    f.propTypes = {};
    var d = f;
    t.default = d;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = n(r(2)),
        o = n(r(1)),
        i = (n(r(3)), r(5));

    function u(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    var l = function l(e) {
      var t = e.resourceName,
          r = e.resourceUrl,
          n = e.dataSource,
          l = e.CustomListItem,
          c = e.ActionBtns,
          s = e.config,
          f = e.edited,
          d = e.deleted,
          p = e.currentUser,
          m = e.permission,
          h = e.parentInstance,
          v = e.showForm,
          g = e.showFormVal,
          y = e.hocProps,
          b = e.selectorProps,
          O = e.renderForm,
          P = e.formMode,
          w = e.singleResourceName,
          x = e.history,
          j = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = null != arguments[t] ? arguments[t] : {};
          t % 2 ? u(Object(r), !0).forEach(function (t) {
            (0, a.default)(e, t, r[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : u(Object(r)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
          });
        }

        return e;
      }({
        edited: f,
        deleted: d,
        currentUser: p,
        permission: m,
        parentInstance: h,
        showForm: v,
        showFormVal: g,
        hocProps: y,
        renderForm: O
      }, b, {}, e),
          E = null;

      if (s.list.widget) {
        var k = s.list.widget;
        E = o.default.createElement(k, j);
      } else E = o.default.createElement(i.List, {
        key: "mainCrudDataList".concat(t),
        grid: {
          gutter: 16,
          xs: 1,
          sm: 1,
          md: 1,
          lg: 2,
          xl: 2,
          xxl: 2
        },
        dataSource: n,
        renderItem: function renderItem(e) {
          return o.default.createElement(l, Object.assign({}, j, {
            key: "".concat(t, "list-item.").concat(e.id),
            className: "custom-list-item",
            item: e,
            resourceUrl: "".concat(r, "/").concat(e.id),
            actionBtns: o.default.createElement(c, {
              config: s,
              edit: m[w] && m[w].update,
              delete: m[w] && m[w].delete,
              edited: f,
              deleted: d,
              name: t,
              formMode: P,
              history: x,
              item: e
            }),
            name: t
          }));
        }
      });

      return E;
    };

    l.defaultProps = {}, l.propTypes = {};
    var c = l;
    t.default = c;
  }, function (e, t, r) {
    var n = r(172);

    e.exports = function (e, t) {
      return n(e, t);
    };
  }, function (e, t, r) {
    var n = r(173),
        a = r(37);

    e.exports = function e(t, r, o, i, u) {
      return t === r || (null == t || null == r || !a(t) && !a(r) ? t != t && r != r : n(t, r, o, i, e, u));
    };
  }, function (e, t, r) {
    var n = r(51),
        a = r(174),
        o = r(179),
        i = r(180),
        u = r(182),
        l = r(36),
        c = r(58),
        s = r(59),
        f = "[object Object]",
        d = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, r, p, m, h) {
      var v = l(e),
          g = l(t),
          y = v ? "[object Array]" : u(e),
          b = g ? "[object Array]" : u(t),
          O = (y = "[object Arguments]" == y ? f : y) == f,
          P = (b = "[object Arguments]" == b ? f : b) == f,
          w = y == b;

      if (w && c(e)) {
        if (!c(t)) return !1;
        v = !0, O = !1;
      }

      if (w && !O) return h || (h = new n()), v || s(e) ? a(e, t, r, p, m, h) : o(e, t, y, r, p, m, h);

      if (!(1 & r)) {
        var x = O && d.call(e, "__wrapped__"),
            j = P && d.call(t, "__wrapped__");

        if (x || j) {
          var E = x ? e.value() : e,
              k = j ? t.value() : t;
          return h || (h = new n()), m(E, k, r, p, h);
        }
      }

      return !!w && (h || (h = new n()), i(e, t, r, p, m, h));
    };
  }, function (e, t, r) {
    var n = r(175),
        a = r(176),
        o = r(177);

    e.exports = function (e, t, r, i, u, l) {
      var c = 1 & r,
          s = e.length,
          f = t.length;
      if (s != f && !(c && f > s)) return !1;
      var d = l.get(e),
          p = l.get(t);
      if (d && p) return d == t && p == e;
      var m = -1,
          h = !0,
          v = 2 & r ? new n() : void 0;

      for (l.set(e, t), l.set(t, e); ++m < s;) {
        var g = e[m],
            y = t[m];
        if (i) var b = c ? i(y, g, m, t, e, l) : i(g, y, m, e, t, l);

        if (void 0 !== b) {
          if (b) continue;
          h = !1;
          break;
        }

        if (v) {
          if (!a(t, function (e, t) {
            if (!o(v, t) && (g === e || u(g, e, r, i, l))) return v.push(t);
          })) {
            h = !1;
            break;
          }
        } else if (g !== y && !u(g, y, r, i, l)) {
          h = !1;
          break;
        }
      }

      return l.delete(e), l.delete(t), h;
    };
  }, function (e, t, r) {
    var n = r(36);

    e.exports = function () {
      if (!arguments.length) return [];
      var e = arguments[0];
      return n(e) ? e : [e];
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = -1, n = null == e ? 0 : e.length; ++r < n;) {
        if (t(e[r], r, e)) return !0;
      }

      return !1;
    };
  }, function (e, t, r) {
    var n = r(178);

    e.exports = function (e, t) {
      return !!(null == e ? 0 : e.length) && n(e, t, 0) > -1;
    };
  }, function (e, t) {
    e.exports = function (e, t, r) {
      for (var n = r - 1, a = e.length; ++n < a;) {
        if (e[n] === t) return n;
      }

      return -1;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return e === t || e != e && t != t;
    };
  }, function (e, t, r) {
    var n = r(181),
        a = Object.prototype.hasOwnProperty;

    e.exports = function (e, t, r, o, i, u) {
      var l = 1 & r,
          c = n(e),
          s = c.length;
      if (s != n(t).length && !l) return !1;

      for (var f = s; f--;) {
        var d = c[f];
        if (!(l ? d in t : a.call(t, d))) return !1;
      }

      var p = u.get(e),
          m = u.get(t);
      if (p && m) return p == t && m == e;
      var h = !0;
      u.set(e, t), u.set(t, e);

      for (var v = l; ++f < s;) {
        var g = e[d = c[f]],
            y = t[d];
        if (o) var b = l ? o(y, g, d, t, e, u) : o(g, y, d, e, t, u);

        if (!(void 0 === b ? g === y || i(g, y, r, o, u) : b)) {
          h = !1;
          break;
        }

        v || (v = "constructor" == d);
      }

      if (h && !v) {
        var O = e.constructor,
            P = t.constructor;
        O == P || !("constructor" in e) || !("constructor" in t) || "function" == typeof O && O instanceof O && "function" == typeof P && P instanceof P || (h = !1);
      }

      return u.delete(e), u.delete(t), h;
    };
  }, function (e, t, r) {
    var n = r(55)(Object.keys, Object);
    e.exports = n;
  }, function (e, t) {
    var r = Object.prototype.toString;

    e.exports = function (e) {
      return r.call(e);
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = a(r(17)),
        i = a(r(2)),
        u = a(r(7)),
        l = a(r(10)),
        c = a(r(12)),
        s = a(r(13)),
        f = a(r(14)),
        d = a(r(23)),
        p = n(r(1)),
        m = a(r(3)),
        h = r(9),
        v = (r(184), r(15)),
        g = a(r(38)),
        y = n(r(22)),
        b = r(18),
        O = a(r(63)),
        P = a(r(21)),
        w = (a(r(64)), r(26), a(r(185)), a(r(186)), a(r(49)), r(6)),
        x = r(5);
    a(r(188));
    r(189);
    var j = r(31);

    function E(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function k(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? E(Object(r), !0).forEach(function (t) {
          (0, i.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : E(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var S = {
      locale: navigator.locale,
      appLoaded: !1,
      waitForAuth: !1
    },
        C = {
      main: {
        colors: {
          primary: "green",
          success: "green",
          warning: "orange",
          danger: "red"
        },
        padding: "20px",
        background: "#fff",
        textColor: "#000"
      },
      button: {
        background: "#fff"
      }
    },
        M = function M(e) {
      return p.default.createElement("div", {
        className: "MrAppLoader"
      }, p.default.createElement(P.default, null));
    };

    function _(e) {
      var t,
          r = e.children,
          n = e.extraProps,
          a = (0, d.default)(e, ["children", "extraProps"]),
          o = (0, h.useLocation)(),
          i = ((0, b.useDispatch)(), n.tokenPresent),
          u = n.isAuthenticated;
      n.loginActions;
      return (0, p.useEffect)(function () {}, []), i ? t = u ? r : p.default.createElement(P.default, null) : (o.search, t = p.default.createElement(h.Redirect, {
        to: {
          pathname: "/auth/login",
          search: o.search,
          state: {
            from: o
          }
        }
      })), p.default.createElement(h.Route, a, t);
    }

    var A = function A(e) {
      var t = e.children;
      return p.default.createElement("div", {
        className: "public-layout"
      }, t);
    },
        N = function N(e) {
      e.theme || (e.theme = C);
      e.dependencies;

      var t = e.localeConfig,
          r = function (t) {
        function r(e) {
          var t;
          return (0, u.default)(this, r), (t = (0, c.default)(this, (0, s.default)(r).call(this, e))).state = k({}, S), t.homePath = "/", t.props.intl ? t.mrIntl = (0, j.mrTranslate)(t.props.intl) : t.mrIntl = null, t;
        }

        return (0, f.default)(r, t), (0, l.default)(r, [{
          key: "componentDidMount",
          value: function value() {
            var t,
                r = this,
                n = this.props,
                a = n.location,
                o = n.history,
                i = k({
              intl: this.props.intl,
              currentUser: this.props.currentUser,
              permission: this.props.permission
            }, (0, w.returnSelectorProps)(e.selectorsObj, this.props)),
                u = e.routes(i),
                l = u.findIndex(function (e) {
              return !!r.props.location.pathname.match("^" + e.path + "/") || e.path === r.props.location.pathname;
            });
            (u[l] && u[l].isPrivate || -1 === l && "/" === this.props.location.pathname) && ((t = g.default.parse(this.props.location.search)).token ? (localStorage.setItem("token", t.token), this.props.initApp(), t.token = null, (0, w.setQueryParams)({
              history: o,
              location: a,
              url: a.pathname,
              params: t
            })) : this.props.tokenPresent && (this.props.isAuthenticated || this.props.initApp()));
            e.mountCallback && e.mountCallback();
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            e.unmountCallback && e.unmountCallback();
          }
        }, {
          key: "componentDidUpdate",
          value: function value(e, t) {}
        }, {
          key: "getMenuRoutes",
          value: function value(e) {
            var t = this,
                r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = [],
                a = r.routePrefix || "";
            return e.forEach(function (e, o) {
              var i = !1;

              if ((void 0 === e.addToMenu || e.addToMenu) && (i = !0), i) {
                var u = k({}, e, {
                  url: a + e.url
                }),
                    l = (u.children, (0, d.default)(u, ["children"]));
                n.push(k({}, l)), e.hasOwnProperty("children") && Array.isArray(e.children) && (n[o].children = t.getMenuRoutes(e.children, r));
              }
            }), n;
          }
        }, {
          key: "setAppLoaded",
          value: function value() {
            var e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            this.setState({
              appLoaded: e
            });
          }
        }, {
          key: "setMenuRoutes",
          value: function value(e, t) {
            var r = this,
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                a = n.routePrefix || "";
            e.forEach(function (e, o) {
              var i = !1;

              if ((void 0 === e.addToMenu || e.addToMenu) && (i = !0), i) {
                e.url = a + e.url;
                k({}, e);
                t.push(k({}, e));
              }

              if (e.hasOwnProperty("children") && Array.isArray(e.children)) r.setMenuRoutes(e.children, t, n);
            });
          }
        }, {
          key: "setAppAndMenuRoutes",
          value: function value(e) {
            var t = this,
                r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              addToMenu: !0
            },
                n = arguments.length > 2 ? arguments[2] : void 0,
                a = arguments.length > 3 ? arguments[3] : void 0,
                o = r.routePrefix || "";
            e.forEach(function (e, i) {
              var u = t.props.permission[e.singleResourceName] || {};

              if ((void 0 === e.addToMenu || e.addToMenu) && !0, u && !1 === u.list && !1, e.url) {
                var l = e.component,
                    c = (e.url, "".concat(o).concat(e.url));
                a.push(p.default.createElement(h.Route, {
                  key: "".concat(c || "", "-routeItem-").concat(i),
                  path: c,
                  exact: e.exact || !1,
                  render: function render(e) {
                    return p.default.createElement(l, Object.assign({}, e, {
                      intl: t.props.intl,
                      mrIntl: t.mrIntl
                    }));
                  }
                }));
              }

              if (e.hasOwnProperty("children") && Array.isArray(e.children)) t.setAppAndMenuRoutes(e.children, k({}, r, {
                addToMenu: !1,
                isChild: !0,
                routePrefix: o
              }), n, a);
            });
          }
        }, {
          key: "isFirstLayoutPrivate",
          value: function value(e) {}
        }, {
          key: "shouldProceed",
          value: function value(e) {
            var t = this,
                r = e.findIndex(function (e) {
              return !!t.props.location.pathname.match("^" + e.path + "/") || e.path === t.props.location.pathname || e.path === t.props.location.pathname;
            });
            return !((e[r] && e[r].isPrivate || -1 === r && "/" === this.props.location.pathname) && this.props.tokenPresent && !this.props.isAuthenticated);
          }
        }, {
          key: "render",
          value: function value() {
            var t = this;
            var r = [],
                n = e.routes;
            if (Array.isArray(n)) ;else if ("function" == typeof n) {
              var a = k({
                intl: this.props.intl,
                mrIntl: this.mrIntl,
                currentUser: this.props.currentUser,
                permission: this.props.permission
              }, (0, w.returnSelectorProps)(e.selectorsObj, this.props));
              n = e.routes(a);
            }
            var o = n[0].path || "",
                i = e.homePath || (n[0].routes[0].children ? n[0].routes[0].children[0].url : n[0].routes[0].url) || "/u/orgs";
            this.props.currentUser && this.props.currentUser.id && (i = e.homePath || (n[0].routes[0].children ? n[0].routes[0].children[0].url : n[0].routes[0].url) || "/u/orgs");
            var u = "".concat(o).concat(i);
            this.homePath = u;
            var l = this.props,
                c = l.onLogout,
                s = l.currentUser,
                f = l.changeLanguage,
                d = l.currentLocale,
                m = l.locales,
                v = l.tokenPresent,
                g = l.isAuthenticated,
                b = l.permission;
            n.forEach(function (n, a) {
              var o,
                  i = n.routes,
                  u = [];

              if (o = t.getMenuRoutes(i, {
                routePrefix: n.path
              }), t.setAppAndMenuRoutes(i, {
                routePrefix: n.path
              }, o, u), !1 !== n.isPrivate || n.isPrivate) {
                var l = n.layout || O.default,
                    y = {
                  logout: c,
                  currentUser: s,
                  permission: b,
                  changeLanguage: f,
                  locales: m,
                  currentLocale: d,
                  config: e.config,
                  menuOptions: e.menuOptions,
                  menu: o,
                  tokenPresent: v,
                  isAuthenticated: g,
                  setAppLoaded: t.setAppLoaded,
                  key: "appLayoutMain-".concat(n.path)
                };
                r.push(p.default.createElement(_, {
                  key: "privateRoute".concat(n.path),
                  path: n.path,
                  extraProps: {
                    tokenPresent: v,
                    isAuthenticated: g,
                    loginActions: e.loginActions
                  }
                }, p.default.createElement(l, y, u)));
              } else {
                var P = n.layout || A,
                    w = {
                  changeLanguage: f,
                  locales: m,
                  currentLocale: d,
                  config: e.config,
                  menuOptions: e.menuOptions,
                  menu: o,
                  tokenPresent: v,
                  isAuthenticated: g,
                  setAppLoaded: t.setAppLoaded,
                  key: "appLayoutMainPublic-".concat(n.path)
                };
                r.push(p.default.createElement(h.Route, {
                  key: n.path,
                  path: n.path
                }, p.default.createElement(P, w, u)));
              }
            });
            var P = e.appLoader || M;
            if (!this.shouldProceed(n)) return p.default.createElement(P, null);
            n[0].isPrivate && !this.props.currentUser.id && "/" === this.props.location.pathname && r.push(p.default.createElement(h.Redirect, {
              key: "mainAuthRedirect",
              exact: !0,
              from: "/",
              to: "/auth/login"
            })), "/" !== u && r.push(p.default.createElement(h.Redirect, {
              key: "mainRedirect",
              exact: !0,
              from: "/",
              to: u
            })), r.push(p.default.createElement(h.Route, {
              key: "noRouteMatchPath",
              path: "*",
              render: function render(e) {
                return p.default.createElement("div", null, "No Route matches this path");
              }
            }));
            return p.default.createElement(x.ConfigProvider, {}, p.default.createElement(y.ThemeProvider, {
              theme: e.theme
            }, p.default.createElement(h.Switch, null, r)));
          }
        }]), r;
      }(p.Component),
          n = (0, v.injectIntl)(r),
          a = (0, b.connect)(function () {
        var t = (0, w.selectorsObjBuilder)(e.selectorsObj);
        return function (e, r) {
          var n = {};
          if (e) for (var a in t) {
            if (t.hasOwnProperty(a)) {
              var o = t[a];
              n[a] = o(e);
            }
          }
          return n;
        };
      }, function (t) {
        return {
          initApp: function initApp() {
            t(e.loginActions.checkAuthState());
          },
          onLogout: function onLogout() {
            t(e.loginActions.logout());
          }
        };
      })(n),
          P = (0, h.withRouter)(a);

      return P.defaultProps = {
        menuOptions: {}
      }, P.propTypes = {
        name: m.default.string.isRequired,
        theme: m.default.object,
        routes: m.default.array.isRequired,
        HomeComponent: m.default.any,
        selectorsObj: m.default.object.isRequired
      }, function (e) {
        function r(e) {
          var n;

          for (var a in (0, u.default)(this, r), n = (0, c.default)(this, (0, s.default)(r).call(this, e)), (0, i.default)((0, o.default)(n), "changeLanguage", function (e) {
            n.setState({
              locale: e
            }, function () {
              localStorage.setItem("locale", e);
            });
          }), n.state = {
            locale: "en",
            messages: {}
          }, n.locales = [], t) {
            if (t.hasOwnProperty(a)) {
              var l = t[a];
              n.locales.push({
                label: l.label,
                value: a
              });
            }
          }

          return n;
        }

        return (0, f.default)(r, e), (0, l.default)(r, [{
          key: "componentDidMount",
          value: function value() {
            var e = localStorage.getItem("locale");
            e || (e = "en"), t[this.state.locale] && t[this.state.locale].messages ? t[this.state.locale].messages : e = "en", this.state.locale !== e && this.changeLanguage(e);
          }
        }, {
          key: "render",
          value: function value() {
            var e = t[this.state.locale].messages;
            return "function" == typeof e && (e = e()), p.default.createElement(v.IntlProvider, {
              key: "mainIntlProvider",
              locale: this.state.locale,
              messages: e
            }, p.default.createElement(P, {
              key: "mainAppWithLang",
              changeLanguage: this.changeLanguage,
              currentLocale: this.state.locale,
              locales: this.locales
            }));
          }
        }]), r;
      }(p.Component);
    };

    t.default = N;
  }, function (e, t) {
    e.exports = p;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    n(r(1));

    var a = function a(e) {
      return e.children;
    };

    t.default = a;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = r(187),
        a = {
      currentUser: n.currentUserSelector,
      permission: n.permissionsSelector,
      currentOrg: n.orgSelector
    };
    t.default = a;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.orgSelector = t.permissionsSelector = t.currentUserSelector = t.errorSelector = t.loadingSelector = t.tokenPresentSelector = t.isAuthenticatedSelector = void 0;
    var a = n(r(2)),
        o = r(46);

    function i(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function u(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? i(Object(r), !0).forEach(function (t) {
          (0, a.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : i(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var l = function l(e, t) {
      return null !== e.login.get("token");
    };

    t.isAuthenticatedSelector = function () {
      return (0, o.createSelector)([l], function (e) {
        return null !== localStorage.getItem("token") && !0, e;
      });
    };

    var c = function c(e, t) {
      return !!localStorage.getItem("token");
    };

    t.tokenPresentSelector = function () {
      return (0, o.createSelector)([c], function (e) {
        return e;
      });
    };

    var s = function s(e, t) {
      return e.login.get("loading");
    };

    t.loadingSelector = function () {
      return (0, o.createSelector)([s], function (e) {
        return e;
      });
    };

    var f = function f(e, t) {
      return e.login.get("error");
    };

    t.errorSelector = function () {
      return (0, o.createSelector)([f], function (e) {
        return e;
      });
    };

    var d = function d(e, t) {
      return e.login.get("currentUser");
    };

    t.currentUserSelector = function () {
      return (0, o.createSelector)([d], function (e) {
        return e.permission && e.permission.settings ? u({}, e, {
          permission: u({}, e.permission, {
            settings: JSON.parse(e.permission.settings)
          })
        }) : e;
      });
    };

    t.permissionsSelector = function () {
      return (0, o.createSelector)([d], function (e) {
        return u({}, e.permission);
      });
    };

    var p = function p(e, t) {
      return e.login.get("currentUser").org;
    };

    t.orgSelector = function () {
      return (0, o.createSelector)([p], function (e) {
        return e;
      });
    };
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;

    var o = a(r(7)),
        i = a(r(10)),
        u = a(r(12)),
        l = a(r(13)),
        c = a(r(17)),
        s = a(r(14)),
        f = a(r(2)),
        d = n(r(1)),
        p = (a(r(3)), r(5)),
        m = r(8),
        h = p.Layout.Header,
        v = p.Layout.Sider,
        g = p.Layout.Content,
        y = function (e) {
      function t() {
        var e, r;
        (0, o.default)(this, t);

        for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++) {
          a[i] = arguments[i];
        }

        return r = (0, u.default)(this, (e = (0, l.default)(t)).call.apply(e, [this].concat(a))), (0, f.default)((0, c.default)(r), "state", {
          collapsed: !1
        }), (0, f.default)((0, c.default)(r), "toggle", function () {
          r.setState({
            collapsed: !r.state.collapsed
          });
        }), r;
      }

      return (0, s.default)(t, e), (0, i.default)(t, [{
        key: "render",
        value: function value() {
          return d.default.createElement(p.Layout, null, d.default.createElement(v, {
            trigger: null,
            collapsible: !0,
            collapsed: this.state.collapsed
          }, d.default.createElement("div", {
            className: "logo"
          }), d.default.createElement(p.Menu, {
            theme: "dark",
            mode: "inline",
            defaultSelectedKeys: ["1"]
          }, d.default.createElement(p.Menu.Item, {
            key: "1"
          }, d.default.createElement(m.UserOutlined, null), d.default.createElement("span", null, "nav 1")), d.default.createElement(p.Menu.Item, {
            key: "2"
          }, d.default.createElement(m.VideoCameraOutlined, null), d.default.createElement("span", null, "nav 2")), d.default.createElement(p.Menu.Item, {
            key: "3"
          }, d.default.createElement(m.UploadOutlined, null), d.default.createElement("span", null, "nav 3")))), d.default.createElement(p.Layout, {
            className: "site-layout"
          }, d.default.createElement(h, {
            className: "site-layout-background",
            style: {
              padding: 0
            }
          }, d.default.createElement(this.state.collapsed ? m.MenuUnfoldOutlined : m.MenuFoldOutlined, {
            className: "trigger",
            onClick: this.toggle
          })), d.default.createElement(g, {
            className: "site-layout-background",
            style: {
              margin: "24px 16px",
              padding: 24,
              minHeight: 280
            }
          }, "Content")));
        }
      }]), t;
    }(d.default.Component);

    t.default = y;
  }, function (e, t, r) {
    var n = r(19),
        a = r(190);
    "string" == typeof (a = a.__esModule ? a.default : a) && (a = [[e.i, a, ""]]);
    var o = {
      insert: "head",
      singleton: !1
    },
        i = (n(a, o), a.locals ? a.locals : {});
    e.exports = i;
  }, function (e, t, r) {
    (t = r(20)(!1)).push([e.i, ".MrAppLoader{position:fixed;width:100%;height:100%;display:flex;justify-content:center}\n", ""]), e.exports = t;
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = a(r(7)),
        i = a(r(10)),
        u = a(r(12)),
        l = a(r(13)),
        c = a(r(17)),
        s = a(r(14)),
        f = a(r(2)),
        d = n(r(1)),
        p = a(r(3)),
        m = r(5),
        h = (a(r(48)), r(18)),
        v = r(6),
        g = r(9);

    function y(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function b(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? y(Object(r), !0).forEach(function (t) {
          (0, f.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : y(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var O = m.Tabs.TabPane,
        P = function P(e) {
      var t = e.tabs,
          r = e.selectorsObj,
          n = function (n) {
        function a() {
          var n, i;
          (0, o.default)(this, a);

          for (var s = arguments.length, p = new Array(s), h = 0; h < s; h++) {
            p[h] = arguments[h];
          }

          return i = (0, u.default)(this, (n = (0, l.default)(a)).call.apply(n, [this].concat(p))), (0, f.default)((0, c.default)(i), "state", {
            mode: e.mode,
            params: {
              activeTab: e.defaultTab || "1"
            }
          }), (0, f.default)((0, c.default)(i), "handleTabClick", function (e) {
            i.setState({
              params: b({}, i.state.params, {
                activeTab: e
              })
            }, function () {
              if (i.props.hasQueryParams) {
                i.props.history, i.props.location;
                var e = i.props,
                    t = e.location,
                    r = e.history;
                (0, v.setQueryParams)({
                  history: r,
                  location: t,
                  url: t.pathname,
                  newParams: b({}, i.state.params)
                });
              }
            });
          }), (0, f.default)((0, c.default)(i), "renderTabs", function () {
            var e = i.state.mode,
                n = i.props,
                a = (n.currentUser, n.permission, []);
            "function" == typeof t && (a = t((0, v.returnSelectorProps)(r, i.props)));
            var o = i.state.params.activeTab || 1;
            i.state.params.activeTab && a.length >= 1 && (o = a[0].id);
            var u = a.map(function (e) {
              var t = e.component;
              return d.default.createElement(O, {
                tab: "".concat(e.name),
                key: "".concat(e.name).concat(e.id)
              }, d.default.createElement(t, null));
            });
            return d.default.createElement(d.default.Fragment, null, d.default.createElement(m.Tabs, {
              defaultActiveKey: "".concat(o),
              activeKey: i.state.params.activeTab,
              onTabClick: i.handleTabClick,
              tabPosition: e
            }, u));
          }), i;
        }

        return (0, s.default)(a, n), (0, i.default)(a, [{
          key: "componentDidMount",
          value: function value() {
            if (this.props.hasQueryParams) {
              var e = this.props.location,
                  t = (0, v.getQueryParams)({
                location: e
              });
              this.setState({
                params: b({}, t)
              }, function () {});
            }
          }
        }, {
          key: "render",
          value: function value() {
            return d.default.createElement(d.default.Fragment, null, this.renderTabs());
          }
        }]), a;
      }(d.PureComponent),
          a = (0, g.withRouter)((0, h.connect)(function () {
        return function (t, r) {
          if (t) return (0, v.mapStateToPropsBuilder)(t, e.selectorsObj, r);
        };
      }, {})(n));

      return a.defaultProps = {}, a;
    };

    P.defaultProps = {
      mode: "top",
      hasQueryParams: !0
    }, P.propTypes = {
      tabs: p.default.func.isRequired
    };
    var w = P;
    t.default = w;
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = a(r(44)),
        i = a(r(69)),
        u = a(r(7)),
        l = a(r(10)),
        c = a(r(12)),
        s = a(r(13)),
        f = a(r(17)),
        d = a(r(14)),
        p = a(r(2)),
        m = n(r(1)),
        h = a(r(30)),
        v = r(18),
        g = r(26),
        y = (r(5), r(6)),
        b = a(r(45));

    function O(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function P(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? O(Object(r), !0).forEach(function (t) {
          (0, p.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : O(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var w = function w() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.selectorsObj || {},
          r = (e.dispatchObj, e.itemName),
          n = e.initialState,
          a = e.resourceName || r,
          O = ((0, y.getResourceNameSet)(a), "".concat(r, "s")),
          w = function (t) {
        function a() {
          var t, r;
          (0, u.default)(this, a);

          for (var l = arguments.length, d = new Array(l), m = 0; m < l; m++) {
            d[m] = arguments[m];
          }

          return r = (0, c.default)(this, (t = (0, s.default)(a)).call.apply(t, [this].concat(d))), (0, p.default)((0, f.default)(r), "state", n), (0, p.default)((0, f.default)(r), "componentDidMount", (0, i.default)(o.default.mark(function t() {
            return o.default.wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (!r.props.hasOwnProperty(O)) {
                      t.next = 5;
                      break;
                    }

                    if (!e.fetch || 0 !== r.props[O].size) {
                      t.next = 5;
                      break;
                    }

                    return t.next = 4, r.props.onFetch({
                      params: r.props.params
                    });

                  case 4:
                    r.forceUpdate();

                  case 5:
                  case "end":
                    return t.stop();
                }
              }
            }, t);
          }))), r;
        }

        return (0, d.default)(a, t), (0, l.default)(a, [{
          key: "render",
          value: function value() {
            var t = [];
            t = "function" == typeof e.options ? e.options(this.props) : (0, g.getNested)(e.options, this);
            var n = r;
            this.props.controlName && (n = this.props.controlName), this.props;
            var a = P({
              valueKey: "value",
              textKey: "label",
              elementType: e.elementType,
              value: this.props.value,
              group: this.props.group,
              width: this.props.width,
              search: this.props.search,
              label: n,
              placeholder: n,
              validation_rules: "required",
              isFormItem: this.props.isFormItem,
              multiple: this.props.multiple,
              controlName: this.props.controlName,
              validation: {
                required: !0
              }
            }, e.config, {}, this.props);
            this.props, "dropdown" !== a.elementType && "select" !== a.elementType || (a.options = t, a.value || !0 !== a.default || a.options.length > 0 && (a.value = a.options[0][e.config.valueKey]));
            var o = {};
            return this.props.hasOwnProperty("changed") && "function" == typeof this.props.changed && (o.changed = this.props.changed), this.props.hasOwnProperty("fieldInfo") && (o.fieldInfo = P({}, this.props.fieldInfo)), m.default.createElement(h.default, Object.assign({
              key: this.props.controlName,
              controlName: this.props.controlName
            }, a, {
              message: this.props.message,
              invalid: !a.valid,
              showInvalid: this.props.showInvalid,
              parentKey: this.props.parentKey,
              index: this.props.index,
              extraOpts: {
                index: this.props.index
              }
            }, o));
          }
        }], [{
          key: "getDerivedStateFromProps",
          value: function value(e, t) {
            var r = null;
            return e.value !== t.value && (r = {
              value: e.value || []
            }), e[O] !== t[O] && (r = P({}, r, (0, p.default)({}, O, e[O]))), r;
          }
        }]), a;
      }(m.Component),
          x = P({}, (0, b.default)({
        resourceName: O,
        resourceGroupName: O
      }));

      t && (x = P({}, x, {}, t));

      var j = function j() {
        return function (e, t) {
          if (e) return (0, y.mapStateToPropsBuilder)(e, x, t);
        };
      },
          E = function E(t, r) {
        var n = {};
        return e.fetch && (n.onFetch = function () {
          var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          t(e.actions.fetch(r));
        }), n;
      };

      return (0, v.connect)(j, E)(w);
    };

    t.default = w;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.returnCamelCase = t.returnActionTypeName = t.nameHandler = void 0;
    var a = n(r(43)),
        o = n(r(44)),
        i = n(r(7)),
        u = n(r(10)),
        l = n(r(2)),
        c = (r(194), r(195)),
        s = n(r(24)),
        f = n(r(11)),
        d = r(5),
        p = (n(r(38)), r(26)),
        m = r(6),
        h = {
      upCase: function upCase() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        return e.toUpperCase();
      },
      pascalCase: function pascalCase() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        return s.default.classify(e);
      },
      camelCase: function camelCase() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        return s.default.camelize(e, !0);
      },
      lowerCase: function lowerCase() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        return e.toLowerCase();
      },
      actionTypeName: function actionTypeName() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
        (void 0).upCase(e);
      }
    };
    t.nameHandler = h;

    var v = function v(e, t, r) {
      var n = t.toUpperCase() + "_" + e.toUpperCase();
      return r && (n = n + "_" + r.toUpperCase()), n;
    },
        g = function g(e) {
      return e.map(function (e) {
        if (e && "" != e) return e.toUpperCase();
      }).join("_");
    };

    t.returnActionTypeName = g;

    t.returnCamelCase = function (e) {
      return s.default.camelize(e.map(function (e) {
        if (e && "" != e) return e.toLowerCase();
      }).join("_"), !0);
    };

    var y = function () {
      function e(t) {
        var r = this;
        (0, i.default)(this, e), (0, l.default)(this, "createActionTypes", function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
              r = {};
          0 == t.length && (t = ["FETCH", "CREATE", "UPDATE", "DELETE", "SHOW", "DUPLICATE"]);
          var n = ["START", "SUCCESS", "FAIL"];
          return t.forEach(function (t) {
            r[v(e, t)] = v(e, t), n.forEach(function (n) {
              r[v(e, t, n)] = v(e, t, n);
            });
          }), r;
        }), (0, l.default)(this, "actionCreatorFor", function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
              r = ["START", "SUCCESS", "FAIL"];
          0 == t.length && (t = ["FETCH", "CREATE", "UPDATE", "DELETE", "SHOW"]), t.push("FILTER");
          var n = {},
              a = e.toUpperCase(),
              o = "".concat(e, "s");
          o.toUpperCase();
          return t.forEach(function (e) {
            r.forEach(function (t) {
              var r = "".concat(e, "_").concat(a, "_").concat(t);

              function o(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                return {
                  type: r,
                  payload: e,
                  options: t
                };
              }

              var i = h.camelCase("".concat(e.toLowerCase()).concat(h.pascalCase(t.toLowerCase())));
              n[i] = o, n[r] = o;
            });
            var t = "".concat(e, "_").concat(a);

            function o(e) {
              var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return {
                type: t,
                payload: e,
                options: r
              };
            }

            var i = h.camelCase("".concat(e.toLowerCase()));
            n[i] = o, n[t] = o;
          }), n;
        }), (0, l.default)(this, "generateWatchSaga", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              a = r;
          return o.default.mark(function r() {
            var i, u, l, s, f, d, p, m;
            return o.default.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    i = 0;

                  case 1:
                    if (!(i < a.actionNames.length)) {
                      r.next = 33;
                      break;
                    }

                    if (u = a.apiUrl || a.resourceName + "s", l = a.apiUrl || a.resourceName + "s", e.baseUrl && (l = e.baseUrl, u = e.baseUrl), s = "get", f = a.actionNames[i], d = g([f, a.resourceName]), p = {}, m = "takeLatest", n.hasOwnProperty(d) && "takeEvery" === n[d].watchType && (m = "takeEvery"), !e.hasOwnProperty(d)) {
                      r.next = 21;
                      break;
                    }

                    if ("takeEvery" !== m) {
                      r.next = 17;
                      break;
                    }

                    return r.next = 15, (0, c.takeEvery)(d, e[d]);

                  case 15:
                    r.next = 19;
                    break;

                  case 17:
                    return r.next = 19, (0, c.takeLatest)(d, e[d]);

                  case 19:
                    r.next = 30;
                    break;

                  case 21:
                    if (-1 !== d.indexOf("FETCH") ? (u = l, s = "get") : -1 !== d.indexOf("SHOW") ? s = "get" : -1 !== d.indexOf("DUPLICATE") || -1 !== d.indexOf("CREATE") ? s = "post" : -1 !== d.indexOf("UPDATE") ? s = "put" : -1 !== d.indexOf("DELETE") ? s = "delete" : (s = "get", p = {}), p = t.hasOwnProperty(d) ? t[d] : {}, "takeEvery" !== m) {
                      r.next = 28;
                      break;
                    }

                    return r.next = 26, (0, c.takeEvery)(d, a.generateSaga(u, s, p));

                  case 26:
                    r.next = 30;
                    break;

                  case 28:
                    return r.next = 30, (0, c.takeLatest)(d, a.generateSaga(u, s, p));

                  case 30:
                    i++, r.next = 1;
                    break;

                  case 33:
                  case "end":
                    return r.stop();
                }
              }
            }, r);
          });
        }), (0, l.default)(this, "generateSaga", function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "get",
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
            beforeSuccess: !1,
            beforeError: !1,
            afterError: !1,
            afterSuccess: !1
          },
              a = r;
          return o.default.mark(function r(i) {
            var u, s, f, d, m, h, v, g;
            return o.default.wrap(function (r) {
              for (;;) {
                switch (r.prev = r.next) {
                  case 0:
                    return u = i.options || {}, s = !1, !1, f = i.type, d = u.url || e, m = t, i && i.payload && i.payload.id && (d += "/".concat(i.payload.id), "get" === m && (s = !0), "post" === m && (d += "/duplicate", !0)), ".json", -1 === d.indexOf(".json") && (d += ".json"), "get" === m && i && i.payload && i.payload.params, a.axiosInstance.token && a.axiosInstance.instance || a.axiosInstance.resetInstance(), r.prev = 11, h = {}, i.payload && i.payload.id && (h.id = i.payload.id), r.next = 16, (0, c.put)(a.actions["".concat(f, "_START")](h));

                  case 16:
                    if (!s) {
                      r.next = 22;
                      break;
                    }

                    return r.next = 19, (0, c.call)(a.axiosInstance.instance[m], d, i.payload);

                  case 19:
                    v = r.sent, r.next = 25;
                    break;

                  case 22:
                    return r.next = 24, (0, c.call)(a.axiosInstance.instance[m], d, i.payload);

                  case 24:
                    v = r.sent;

                  case 25:
                    return r.next = 28, (0, c.put)(a.actions["".concat(f, "_SUCCESS")](v, u));

                  case 28:
                    if (!i.options || !i.options.successCallback) {
                      r.next = 31;
                      break;
                    }

                    return r.next = 31, (0, c.call)(i.options.successCallback, v);

                  case 31:
                    if (!n.afterSuccess) {
                      r.next = 34;
                      break;
                    }

                    return r.next = 34, (0, c.put)((0, l.default)({
                      type: n.afterSuccess()
                    }, a.resourceName, v.data[a.resourceName]));

                  case 34:
                    r.next = 58;
                    break;

                  case 36:
                    if (r.prev = 36, r.t0 = r.catch(11), console.error("saga fail: ", r.t0), r.t0, !r.t0 || !r.t0.response || 401 !== r.t0.response.status) {
                      r.next = 44;
                      break;
                    }

                    if (!location) {
                      r.next = 44;
                      break;
                    }

                    return r.next = 44, (0, c.put)({
                      type: a.logoutActionName
                    });

                  case 44:
                    if (!i.options || !i.options.errorCallback) {
                      r.next = 47;
                      break;
                    }

                    return r.next = 47, (0, c.call)(i.options.errorCallback, r.t0);

                  case 47:
                    if (!(g = (0, p.getNested)(["response", "data", "error"], r.t0))) {
                      r.next = 53;
                      break;
                    }

                    return r.next = 51, (0, c.put)(a.actions["".concat(f, "_FAIL")]({
                      error: g
                    }, u));

                  case 51:
                    r.next = 55;
                    break;

                  case 53:
                    return r.next = 55, (0, c.put)(a.actions["".concat(f, "_FAIL")]({
                      error: r.t0
                    }, u));

                  case 55:
                    if (!n.afterError) {
                      r.next = 58;
                      break;
                    }

                    return r.next = 58, (0, c.put)(n.afterError());

                  case 58:
                  case "end":
                    return r.stop();
                }
              }
            }, r, null, [[11, 36]]);
          });
        }), this.resourceName = t.resourceName, this.singleResourceName = t.singleResourceName || this.resourceName, this.apiUrl = t.apiUrl, this.actionNames = t.actionNames, this.eventNames = t.eventNames || ["START", "SUCCESS", "FAIL"], this.logoutActionName = t.logoutActionName || "LOGOUT_LOGIN", this.overrides = t.overrides || {
          reducer: {}
        }, this.axiosInstance = t.axiosInstance, this.message = t.message || d.message, this.messageConfig = t.messageConfig || {}, this.message.config(this.messageConfig), this.actionTypes = this.createActionTypes(this.resourceName, this.actionNames), this.actions = this.actionCreatorFor(this.resourceName, this.actionNames);
      }

      return (0, u.default)(e, [{
        key: "getActionTypes",
        value: function value() {
          return this.actionTypes;
        }
      }, {
        key: "getActions",
        value: function value() {
          return this.actions;
        }
      }, {
        key: "getReducer",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return this.generateReducer(e, t);
        }
      }, {
        key: "generateReducer",
        value: function value() {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = function n() {
            var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : t,
                o = arguments.length > 1 ? arguments[1] : void 0,
                i = o.options || {},
                u = (e.resourceName.toUpperCase(), i.resourceName || e.singleResourceName + "s" || e.resourceName + "s"),
                c = o.payload && o.payload.id,
                s = o.type.split("_")[0].toLowerCase(),
                d = ["".concat(s, "loading")],
                h = !0;
            if (c && (h = (0, l.default)({}, c, !0)), r[o.type]) return r[o.type](n, o);

            if (e.actionTypes.hasOwnProperty(o.type)) {
              if (-1 != o.type.indexOf("START")) return n.set("loading", !0).setIn(d, h);

              if (-1 != o.type.indexOf("SUCCESS")) {
                var v = (o.options || {}).success,
                    g = n.set("loading", !1).setIn(d, !1),
                    y = {};

                if (o.payload) {
                  var b = !1;
                  -1 !== o.type.indexOf("SHOW") && (b = !0);
                  var O = o.payload.data || {};

                  for (var P in O) {
                    if (O.hasOwnProperty(P)) {
                      var w = O[P];
                      n.has(P) ? g = P === u ? g.set(P, (0, m.formatJsonApiData)(w)) : i.apiResourceName && i.apiResourceName === P ? g.set(i.resourceName, (0, m.formatJsonApiData)(w)) : g.set(P, w) : i.apiResourceName && i.apiResourceName === P ? g = g.set(i.resourceName, (0, m.formatJsonApiData)(w)) : y[P] = w;
                    }
                  }

                  var x,
                      j,
                      E = !1;
                  x = (0, a.default)(g.get(u, [])), O.hasOwnProperty(e.singleResourceName) ? (j = O[e.singleResourceName], j = (0, m.formatJsonApiData)(j)) : O.hasOwnProperty("data") && (j = (0, m.formatJsonApiData)(O.data[e.singleResourceName]));

                  if (-1 !== o.type.indexOf("SHOW")) {
                    var k = f.default.findIndex(x, {
                      id: j.id
                    });
                    -1 !== k ? x.splice(k, 1, j) : x.unshift(j);
                  } else if (-1 !== o.type.indexOf("CREATE")) o.options && void 0 !== o.options.createAtIndex ? x.splice(i.createAtIndex, 0, j) : x.unshift(j), E = !0, v || e.message.success("".concat(e.resourceName, " successfully created."));else if (-1 !== o.type.indexOf("UPDATE")) {
                    var S = f.default.findIndex(x, {
                      id: j.id
                    });
                    v || e.message.success("".concat(e.resourceName, " successfully updated.")), -1 !== S && (x.splice(S, 1, j), E = !0);
                  } else if (-1 !== o.type.indexOf("DELETE")) {
                    var C = f.default.findIndex(x, {
                      id: j.id
                    });
                    -1 !== C && (x.splice(C, 1), E = !0), v || e.message.success(" ".concat(e.resourceName, " successfully deleted"));
                  } else -1 !== o.type.indexOf("DUPLICATE") ? (v || e.message.success("".concat(e.resourceName, " successfully duplicated.")), o.options && void 0 !== o.options.duplicateAtIndex ? x.splice(o.options.duplicateAtIndex, 0, j) : x.unshift(j), E = !0) : -1 !== o.type.indexOf("FETCH") && (g = g.set("firstAction", !0));

                  (E || b) && n.has(u) && (g = g.set(u, x));
                }

                return g = g.set("extra", y), v && v.showMessage && e.message.success(v.message), g;
              }

              if (-1 !== o.type.indexOf("FAIL")) {
                var M = (o.options || {}).error,
                    _ = (0, p.getNested)("payload.error", o);

                return M ? M.showMessage && e.message.error(M.message) : _ && "string" == typeof _ ? e.message.error(_) : e.message.error("Something went wrong in processing ".concat(e.resourceName)), n.set("error", o.error).set("loading", !1).setIn(d, !1);
              }

              return n;
            }

            return n;
          };

          return n;
        }
      }]), e;
    }();

    t.default = y;
  }, function (e, t) {
    e.exports = m;
  }, function (e, t) {
    e.exports = h;
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o = a(r(7)),
        i = a(r(10)),
        u = a(r(12)),
        l = a(r(13)),
        c = a(r(14)),
        s = a(r(2)),
        f = a(r(40)),
        d = n(r(1)),
        p = (a(r(3)), r(18), a(r(74))),
        m = a(r(48)),
        h = a(r(197)),
        v = a(r(24)),
        g = a(r(11)),
        y = r(6);

    function b(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function O(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? b(Object(r), !0).forEach(function (t) {
          (0, s.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : b(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var P = function P() {
      var e,
          t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          r = t.resourceName,
          n = t.singleResourceName,
          a = t.displayName,
          b = (t.actions, t.actionNames, t.firstTimeFetchParams, t.listHeader, t.layout),
          P = t.forms,
          w = t.infoComponent,
          x = t.manualFormRender,
          j = t.ChildComponent,
          E = w;
      b || (b = h.default);
      var k = b,
          S = t.selectorsObj || {},
          C = (t.dispatchObj, t.itemName, P[0]),
          M = (v.default.camelize("".concat(r), !0), e = {}, (0, s.default)(e, n, {}), (0, s.default)(e, "modal", {
        open: !1
      }), (0, s.default)(e, "id", null), (0, s.default)(e, "item", {}), (0, s.default)(e, "displayForm", ""), (0, s.default)(e, "formProps", {
        name: "",
        item: null
      }), e);
      t.initialState && ((0, f.default)("initialState"), M = O({}, M, {}, t.initialState));

      var _ = function (e) {
        function s(e) {
          var t;
          return (0, o.default)(this, s), (t = (0, u.default)(this, (0, l.default)(s).call(this, e))).state = O({}, M), t;
        }

        return (0, c.default)(s, e), (0, i.default)(s, [{
          key: "componentDidMount",
          value: function value() {
            if (0 === this.props[r].size) {
              var e = this.props.match.params.id;
              this.props.onShow({
                id: e
              });
            }
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.props.loading,
                o = this.state.showForm,
                i = (0, y.returnSelectorProps)(S, this.props).selectorProps,
                u = {
              resourceName: r,
              singleResourceName: n,
              displayName: a,
              resourceForm: C,
              forms: P,
              params: this.state.params,
              setParams: this.setParams,
              showFormVal: o,
              showForm: this.showForm,
              loading: e,
              item: this.state.item,
              handleOk: this.handleOk,
              handleCancel: this.handleCancel,
              refresh: this.refresh,
              edited: this.edited,
              deleted: this.deleted,
              currentUser: this.props.currentUser,
              permission: this.props.permission,
              parentInstance: this,
              hocProps: t,
              InfoComponent: E,
              selectorProps: i,
              ChildComponent: j,
              renderForm: this.renderForm,
              manualFormRender: x
            };
            return d.default.createElement(k, u);
          }
        }], [{
          key: "getDerivedStateFromProps",
          value: function value(e, t) {
            var a = !1,
                o = O({}, t);

            if (e.match.params.id !== t.id && (o.id = parseInt(e.match.params.id), a = !0), e[n].id && (t.item.id && (0, y.shallowCompare)(t.item, e[n]) || (o.item = O({}, e[n]))), !t.item.id && Array.isArray(e[r]) && e[r].length > 0) {
              var i = g.default.findIndex(e[r], {
                id: o.id
              });
              -1 !== i && (o.item = O({}, e[r][i]), a = !0);
            }

            return a ? o : null;
          }
        }]), s;
      }((0, p.default)(t, d.PureComponent));

      return _.defaultProps = {
        item: {},
        manualFormRender: !1
      }, _.propTypes = {}, (0, m.default)(t, _);
    };

    t.default = P;
  }, function (e, t, r) {
    "use strict";

    var n = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = n(r(2)),
        o = n(r(1)),
        i = (n(r(3)), r(15)),
        u = n(r(21)),
        l = n(r(28));

    function c(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function s(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? c(Object(r), !0).forEach(function (t) {
          (0, a.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : c(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    var f = function f(e) {
      var t = [],
          r = (e.item, e.loading),
          n = e.InfoComponent,
          a = (e.singleResourceName, e.displayName),
          c = e.handleOk,
          f = e.handleCancel,
          d = e.resourceName,
          p = e.showFormVal,
          m = e.showForm,
          h = e.forms,
          v = e.parentInstance,
          g = e.hocProps,
          y = e.permission,
          b = e.currentUser,
          O = e.selectorProps,
          P = e.edited,
          w = e.deleted,
          x = e.ChildComponent,
          j = e.renderForm,
          E = e.manualFormRender,
          k = (0, i.useIntl)();
      if (e.loading && !e.item.id) return t.push(o.default.createElement(u.default, {
        key: "loading"
      }, "loading...")), t;
      var S = s({
        item: e.item,
        edited: P,
        deleted: w,
        currentUser: b,
        permission: y,
        parentInstance: v,
        showForm: m,
        showFormVal: p,
        hocProps: g,
        renderForm: j,
        manualFormRender: E
      }, O);

      if (t.push(o.default.createElement(n, Object.assign({
        key: "showviewlayout"
      }, S))), !E) {
        var C = (0, l.default)({
          intl: k,
          currentUser: b,
          permission: y,
          selectorProps: O,
          forms: h,
          handleOk: c,
          handleCancel: f,
          newItem: e.item,
          item: e.item,
          loading: r,
          displayName: a,
          showFormVal: p,
          resourceName: d,
          renderForm: j,
          manualFormRender: E
        });
        t.push(C);
      }

      var M = s({}, e, {}, O);
      return x && t.push(o.default.createElement(x, M)), t;
    };

    t.default = f;
  }, function (e, t, r) {
    "use strict";

    var n = r(4),
        a = r(0);
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.usePrevious = void 0;
    var o = a(r(2)),
        i = a(r(32)),
        u = a(r(23)),
        l = a(r(3)),
        c = n(r(1)),
        s = r(5),
        f = r(18),
        d = a(r(41)),
        p = r(11),
        m = a(r(21));

    function h(e, t) {
      var r = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    function v(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? h(Object(r), !0).forEach(function (t) {
          (0, o.default)(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : h(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }

      return e;
    }

    s.TreeSelect.TreeNode;

    var g = {
      isJsx: !1,
      searchApi: !1,
      initialSearchApiParams: {},
      params: {},
      clearValueOnParamsChange: !0,
      forceReload: !1,
      debounceTime: 400,
      widgetConfig: {},
      loader: m.default
    },
        y = function y(e) {
      var t = (0, c.useRef)();
      return (0, c.useEffect)(function () {
        t.current = e;
      }), t.current;
    };

    t.usePrevious = y;

    var b = function b(e) {
      var t = e.actions,
          r = e.resourceName,
          n = e.apiResourceName || r;
      e.searchKeys;
      return function (a) {
        var l = a.value,
            h = (a.onChange, a.config, (0, u.default)(a, ["config"])),
            b = (0, c.useState)(l),
            O = (0, i.default)(b, 2),
            P = O[0],
            w = O[1],
            x = e.config || {},
            j = a.config || {},
            E = j.callback,
            k = (0, f.useDispatch)(),
            S = (0, p.merge)({}, g, x, j),
            C = y(l),
            M = (0, c.useState)([]),
            _ = (0, i.default)(M, 2),
            A = (_[0], _[1]),
            N = a.loadData || S.widgetConfig.loadData;

        (0, c.useEffect)(function () {
          (0, p.isEqual)(l, C) ? !C && !Array.isArray(C) && (0, p.isEqual)(l, C) : (0, p.isEqual)(l, P) || w(l);
        }, [l, C, P]);
        var T = S.processData,
            F = !0,
            R = S.widgetConfig.options;
        R && (F = !1);
        var I = [];
        I = F ? (0, f.useSelector)(function (e) {
          return e.request.get(r, []);
        }) : "function" == typeof R ? (0, f.useSelector)(R) : R;
        var D = (0, c.useState)(S.params),
            L = (0, i.default)(D, 2),
            U = (L[0], L[1], (0, f.useSelector)(function (e) {
          return e.request.getIn(["".concat(r, "loading")], !1);
        })),
            B = y(S.params),
            V = (0, c.useCallback)((0, d.default)(function (e) {
          W({
            search: e
          });
        }, S.debounceTime), []);
        I && T && (I = T(I, a));

        var W = function W() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          F && k(t[r]({
            params: v({}, S.params, {}, e)
          }, {
            resourceName: r,
            apiResourceName: n,
            url: S.url,
            successCallback: function successCallback(e) {
              E && E(e);
            }
          }));
        };

        (0, c.useEffect)(function () {
          if (!(0, p.isEqual)(B, S.params) && (S.searchApi || W(), S.clearValueOnParamsChange)) {
            var e = null;
            C && (Array.isArray(C) && (e = []), a.onChange(e));
          }
        }, [B]), (0, c.useEffect)(function () {
          var e = !1,
              t = {};

          if (S.searchApi, I.length && 0 !== I.length && !S.forceReload || S.searchApi || (e = !0), I.length, S.forceReload, S.searchApi, S.searchApi) {
            var r = !1;
            e = !1;
            var n = S.initialSearchApiKeyName || "by_ids";
            if (I.length && 0 !== I.length || (r = !0), Array.isArray(P) && 0 !== P.length) if (r) t = (0, o.default)({}, n, P);else for (var a = function a(r) {
              var a = P[r];
              if (!I.find(function (e) {
                return e.value == a;
              })) return e = !0, t = (0, o.default)({}, n, P), "break";
            }, i = 0; i < P.length; i++) {
              if ("break" === a(i)) break;
            }
            if (!Array.isArray(P) && null != P) if (r) t = (0, o.default)({}, n, [P]);else I.find(function (e) {
              return e.value == P;
            }) || (e = !0, t = (0, o.default)({}, n, [P]));
            I.length && 0 !== I.length || (Array.isArray(P) && 0 !== P.length && (e = !0, t = (0, o.default)({}, n, P)), !Array.isArray(P) && P && (t = (0, o.default)({}, n, [P])));
          }

          e && W(t);
        }, []);
        var q = v({}, S.widgetConfig, {
          loading: U,
          onChange: a.onChange
        }, h, {
          value: P
        });

        if (N && (q.loadData = function (e) {
          return new Promise(function (t) {
            N && N(e, P, w, k), setInterval(function () {
              A(), t();
            }, 300);
          });
        }), S.isJsx || (q.treeData = I), S.searchApi) {
          q.onSearch = V;
          var z = S.loader || m.default;
          q.notFoundContent = U ? c.default.createElement(z, null) : null;
        }

        var H = S.widget || s.TreeSelect,
            $ = null;
        return $ = S.isJsx ? c.default.createElement(H, q, I) : c.default.createElement(H, q), c.default.createElement(c.default.Fragment, null, $);
      };
    };

    b.propTypes = {
      url: l.default.string.isRequired,
      resourceName: l.default.string.isRequired,
      apiResourceName: l.default.string,
      config: l.default.shape({
        params: l.default.object,
        searchApi: l.default.bool,
        isJsx: l.default.bool,
        widgetConfig: l.default.shape({})
      })
    };
    var O = b;
    t.default = O;
  }]).default;
});